  function addToCartAndCheckout(){
  if (typeof clearWizardStateFromStorage === 'function') clearWizardStateFromStorage();
  const form = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.sectionId ? document.querySelector('#shopify-section-' + window.WIZARD_CONFIG.sectionId + ' form[action*="/cart/add"]') : null) || document.querySelector('form[action*="/cart/add"]');
  if(!form) return;

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(() => {
    window.location.href = '/checkout';
  });
}
// Constants and State
const steps = ['Your Bible', 'Leather', 'Cover', 'Ribbons', 'Spine', 'Stamping', 'Extras', 'Review'];
let currentStep = 0;
let basePrice = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.basePrice !== undefined) ? window.WIZARD_CONFIG.basePrice : 350;

const WIZARD_STORAGE_KEY = 'byrd_bound_wizard_state';

let orderState = {
  bibleSource: '',
  ownBibleType: '',
  bibleCondition: '',
  bibleConditionPrice: 0,
  translation: '',
  translationPrice: 0,
  leather: '',
  leatherName: '',
  leatherPrice: 0,
  customLeatherText: '',
  color: '',
  coverStiffness: '',
  coverStiffnessPrice: 0,
  yapp: '',
  yappPrice: 0,
  liner: '',
  ribbons: undefined,
  ribbonsPrice: 0,
  ribbonChoices: [],
  hubStyle: '',
  hubPrice: 0,
  spineStampColor: '',
  spineStampColorPrice: 0,
  stampFont: 'Goudy Light',
  stampFontFamily: "'Cormorant Garamond',serif",
  stampFontStyle: 'normal',
  spineSections: {},
  spineLogo: 'both',
  tooling: 'no-tooling',
  toolingPrice: 0,
  toggles: { stitch: false, gilt1: false, gilt2: false, dye: false, speckle: false },
  gilt1Color: '',
  gilt1Upcharge: 0,
  gilt2Color: '',
  gilt2Upcharge: 0,
  dyeColor: '',
  dyeSandoff: false,
  speckle1: '',
  speckle2: '',
  speckle3: '',
  stitchColor: '',
  // Cover stamping
  coverStampType: '',
  coverStampCost: 0,
  coverStampPlacement: '',
  coverStampColor: '',
  coverStampColorCost: 0,
  coverStampText: '',
  inscriptions: { front: false, liner: false, back: false },
  inscriptionTexts: { front: [''], liner: [''], back: [''] },
  inscriptionCost: 0,
  inscriptionFont: ''
};

function saveWizardStateToStorage() {
  if (window._isInitializingWizard || window._isRestoringCartWizard || (window.WIZARD_EDIT_MODE && window.WIZARD_EDIT_MODE.isEditing)) {
    return;
  }
  try {
    const notesEl = document.getElementById('notes');
    const dyeInput = document.getElementById('dye-color');
    const stitchInput = document.getElementById('stitch-color');
    const ownInput = document.getElementById('own-bible-type');
    const custLeathInput = document.getElementById('custom-leather-text');
    const coverStampTextInput = document.getElementById('cover-stamp-text-input');

    const stateToSave = {
      savedStep: typeof currentStep === 'number' ? currentStep : 0,
      orderState: JSON.parse(JSON.stringify(orderState)),
      notes: notesEl ? notesEl.value : (orderState.notes || ''),
      dyeColorVal: dyeInput ? dyeInput.value : (orderState.dyeColor || ''),
      stitchColorVal: stitchInput ? stitchInput.value : (orderState.stitchColor || ''),
      ownBibleTypeVal: ownInput ? ownInput.value : (orderState.ownBibleType || ''),
      customLeatherTextVal: custLeathInput ? custLeathInput.value : (orderState.customLeatherText || ''),
      coverStampTextVal: coverStampTextInput ? coverStampTextInput.value : (orderState.coverStampText || ''),
      timestamp: Date.now()
    };

    localStorage.setItem(WIZARD_STORAGE_KEY, JSON.stringify(stateToSave));
  } catch (err) {
    console.warn('Error saving wizard state to localStorage:', err);
  }
}
window.saveWizardStateToStorage = saveWizardStateToStorage;

function clearWizardStateFromStorage() {
  try {
    localStorage.removeItem(WIZARD_STORAGE_KEY);
  } catch (err) {
    console.warn('Error clearing wizard state from localStorage:', err);
  }
}
window.clearWizardStateFromStorage = clearWizardStateFromStorage;

function restoreWizardStateFromStorage() {
  if (window._isRestoringCartWizard || (window.WIZARD_EDIT_MODE && window.WIZARD_EDIT_MODE.isEditing)) {
    return null;
  }
  try {
    const stored = localStorage.getItem(WIZARD_STORAGE_KEY);
    if (!stored) return null;
    const data = JSON.parse(stored);
    if (!data || !data.orderState) return null;

    const os = data.orderState;
    const hasAnyChoice = !!(os.bibleSource || os.leather || os.coverStiffness || (os.ribbons !== undefined) || os.hubStyle || (os.coverStampType && os.coverStampType !== 'none') || (os.inscriptions && (os.inscriptions.front || os.inscriptions.liner || os.inscriptions.back)) || (os.toggles && (os.toggles.stitch || os.toggles.gilt1 || os.toggles.gilt2 || os.toggles.dye || os.toggles.speckle)) || (typeof data.savedStep === 'number' && data.savedStep > 0));

    if (!hasAnyChoice) return null;

    Object.assign(orderState, os);
    if (typeof data.savedStep === 'number' && !isNaN(data.savedStep)) {
      currentStep = data.savedStep;
    }
    applyOrderStateToUI(data);

    return data;
  } catch (err) {
    console.warn('Error restoring wizard state from localStorage:', err);
    return null;
  }
}
window.restoreWizardStateFromStorage = restoreWizardStateFromStorage;

function applyOrderStateToUI(data) {
  if (!data || !data.orderState) return;
  const os = data.orderState;
  const prevRestoring = window._isRestoringCartWizard;
  window._isRestoringCartWizard = true;

  try {
    // Step 0
    if (os.bibleSource === 'own') {
      const ownCard = document.querySelector('#panel-0 .opt-card[data-opt="own"]');
      const sourceCard = document.querySelector('#panel-0 .opt-card[data-opt="source"]');
      if (sourceCard) sourceCard.classList.remove('selected');
      if (ownCard) ownCard.classList.add('selected');

      const ownSec = document.getElementById('own-bible-section');
      if (ownSec) ownSec.style.display = 'block';
      const transSec = document.getElementById('translation-section');
      if (transSec) transSec.style.display = 'none';

      const ownInput = document.getElementById('own-bible-type');
      const ownVal = os.ownBibleType || data.ownBibleTypeVal || '';
      if (ownInput) ownInput.value = ownVal;

      if (os.bibleCondition) {
        document.querySelectorAll('#own-bible-section .opt-card').forEach(c => {
          const title = (c.querySelector('.opt-card-title')?.innerText || '').trim();
          if (title.toLowerCase() === os.bibleCondition.toLowerCase() || c.dataset.opt === os.bibleCondition) {
            c.classList.add('selected');
          } else {
            c.classList.remove('selected');
          }
        });
      }
    } else if (os.bibleSource === 'source') {
      const sourceCard = document.querySelector('#panel-0 .opt-card[data-opt="source"]');
      const ownCard = document.querySelector('#panel-0 .opt-card[data-opt="own"]');
      if (ownCard) ownCard.classList.remove('selected');
      if (sourceCard) sourceCard.classList.add('selected');

      const transSec = document.getElementById('translation-section');
      if (transSec) transSec.style.display = 'block';
      const ownSec = document.getElementById('own-bible-section');
      if (ownSec) ownSec.style.display = 'none';

      if (os.translation) {
        document.querySelectorAll('#translation-section .opt-card').forEach(c => {
          const title = (c.querySelector('.opt-card-title')?.innerText || '').trim();
          if (title.toLowerCase() === os.translation.toLowerCase() || c.dataset.opt === os.translation) {
            c.classList.add('selected');
          } else {
            c.classList.remove('selected');
          }
        });
      }
    }

    // Step 1
    if (os.leather) {
      document.querySelectorAll('.ltab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.leather-panel').forEach(p => p.style.display = 'none');
      const chosenTab = document.getElementById('tab-' + os.leather);
      if (chosenTab) chosenTab.classList.add('active');
      const chosenPanel = document.getElementById('panel-' + os.leather);
      if (chosenPanel) chosenPanel.style.display = 'block';

      if (os.leather === 'custom') {
        const custInput = document.getElementById('custom-leather-text');
        const custVal = os.customLeatherText || data.customLeatherTextVal || os.color || '';
        if (custInput) custInput.value = custVal;
      } else if (os.color) {
        document.querySelectorAll('.ldot').forEach(d => d.classList.remove('sel'));
        const colorDots = document.querySelectorAll(`#dots-${os.leather} .ldot, .ldot`);
        let matchedDot = null;
        for (let dot of colorDots) {
          const dotTitle = (dot.getAttribute('title') || '').trim();
          if (dotTitle.toLowerCase() === os.color.toLowerCase().trim()) {
            matchedDot = dot;
            break;
          }
        }
        if (matchedDot) matchedDot.classList.add('sel');
        if (typeof updateColorLabelWithChip === 'function') {
          updateColorLabelWithChip(os.leather, os.color, matchedDot);
        } else {
          const label = document.getElementById(`sel-color-${os.leather}`);
          if (label) label.textContent = os.color;
        }
      }
    }

    if (os.liner) {
      document.querySelectorAll('.lnr-dot').forEach(d => d.classList.remove('sel'));
      const linerDots = document.querySelectorAll('.lnr-dot');
      let matchedLinerDot = null;
      for (let dot of linerDots) {
        const dotTitle = (dot.getAttribute('title') || '').trim();
        if (dotTitle.toLowerCase() === os.liner.toLowerCase().trim()) {
          matchedLinerDot = dot;
          break;
        }
      }
      if (matchedLinerDot) matchedLinerDot.classList.add('sel');
      if (typeof updateLinerLabelWithChip === 'function') {
        updateLinerLabelWithChip(os.liner, matchedLinerDot);
      } else {
        const label = document.getElementById('liner-name');
        if (label) label.textContent = os.liner + ' lambskin';
      }
    }

    // Step 2
    if (os.coverStiffness) {
      document.querySelectorAll('#panel-2 .opt-card[data-opt="floppy"], #panel-2 .opt-card[data-opt="firm"]').forEach(c => c.classList.remove('selected'));
      const isFirm = os.coverStiffness.toLowerCase().includes('firm') || os.coverStiffness.toLowerCase().includes('stiff');
      const stiffCard = document.querySelector(`#panel-2 .opt-card[data-opt="${isFirm ? 'firm' : 'floppy'}"]`);
      if (stiffCard) stiffCard.classList.add('selected');
    }

    if (os.yapp) {
      document.querySelectorAll('#panel-2 .opt-card[data-opt="standard"], #panel-2 .opt-card[data-opt="half"], #panel-2 .opt-card[data-opt="full"]').forEach(c => c.classList.remove('selected'));
      let yappOpt = 'standard';
      if (os.yapp.includes('1/2') || os.yapp.toLowerCase().includes('half') || os.yapp.toLowerCase().includes('semi')) yappOpt = 'half';
      else if (os.yapp.includes('3/4') || os.yapp.toLowerCase().includes('full')) yappOpt = 'full';
      const yappCard = document.querySelector(`#panel-2 .opt-card[data-opt="${yappOpt}"]`);
      if (yappCard) yappCard.classList.add('selected');
    }

    if (os.tooling) {
      document.querySelectorAll('#panel-2 .opt-card[data-opt="no-tooling"], #panel-2 .opt-card[data-opt="single-tooling"], #panel-2 .opt-card[data-opt="double-tooling"]').forEach(c => c.classList.remove('selected'));
      const toolCard = document.querySelector(`.opt-card[data-opt="${os.tooling}"]`);
      if (toolCard) toolCard.classList.add('selected');
    }

    // Step 3
    if (os.ribbons !== undefined) {
      document.querySelectorAll('.rcount-btn').forEach(b => b.classList.remove('selected'));
      buildRibbonBtns();
      renderRibbonInputs();
      if (os.ribbonChoices && os.ribbonChoices.length > 0) {
        for (let i = 0; i < os.ribbonChoices.length; i++) {
          const val = os.ribbonChoices[i];
          if (val) {
            const input = document.getElementById(`ribbon-input-${i}`);
            if (input) input.value = val;
            const selText = document.getElementById(`ribbon-sel-text-${i}`);
            if (selText) {
              selText.innerHTML = `<span class="ribbon-color-name">${val}</span>`;
            }
            const grid = document.getElementById(`ribbon-grid-${i}`);
            if (grid) {
              grid.querySelectorAll('.ribbon-swatch-btn').forEach(b => {
                const btnTitle = b.getAttribute('title') || '';
                if (btnTitle.toLowerCase().includes(val.toLowerCase()) || val.toLowerCase().includes(btnTitle.toLowerCase())) {
                  b.classList.add('sel');
                }
              });
            }
          }
        }
      }
    }

    // Step 4
    if (os.hubStyle) {
      document.querySelectorAll('#panel-4 .hub-card').forEach(c => {
        const name = c.querySelector('.hub-name')?.textContent;
        if (name && name.trim().toLowerCase() === os.hubStyle.trim().toLowerCase()) {
          c.classList.add('sel');
        } else {
          c.classList.remove('sel');
        }
      });
    }

    if (os.spineStampColor) {
      document.querySelectorAll('#panel-4 .stamp-color').forEach(c => {
        const name = c.querySelector('.sc-name')?.textContent;
        if (name && name.trim().toLowerCase() === os.spineStampColor.trim().toLowerCase()) {
          c.classList.add('sel');
        } else {
          c.classList.remove('sel');
        }
      });
      const selColorName = document.getElementById('sel-color-name');
      if (selColorName) selColorName.textContent = os.spineStampColor;
    }

    if (os.stampFont) {
      document.querySelectorAll('#panel-4 .font-card').forEach(c => {
        const name = c.querySelector('.font-name')?.textContent;
        if (name && name.trim().toLowerCase() === os.stampFont.trim().toLowerCase()) {
          c.classList.add('sel');
        } else {
          c.classList.remove('sel');
        }
      });
    }

    if (os.spineLogo) {
      document.querySelectorAll('.mand-card').forEach(c => c.classList.remove('sel'));
      let mandId = 'mand-both';
      if (os.spineLogo === 'text') mandId = 'mand-text';
      else if (os.spineLogo === 'logo') mandId = 'mand-logo';
      else if (os.spineLogo && os.spineLogo !== 'both') mandId = 'mand-custom';
      const mandCard = document.getElementById(mandId);
      if (mandCard) mandCard.classList.add('sel');
    }

    if (os.spineSections) {
      for (let i = 1; i <= 5; i++) {
        const secVal = os.spineSections[i] || '';
        const input = document.getElementById(`spine${i}`);
        if (input) input.value = secVal;
        if (secVal) {
          updateSec(i, secVal);
        }
      }
      const sec3Val = os.spineSections[3] || '';
      const logoMap = {
        'chi rho': 'chirho',
        'latin cross': 'latincross',
        'sword': 'sword',
        'ichthys': 'ichthys',
        'fish + bread': 'fishbread',
        'ark': 'ark',
        'ega': 'ega'
      };
      let matchedLogo = null;
      for (let k in logoMap) {
        if (sec3Val.toLowerCase().includes(k)) {
          matchedLogo = logoMap[k];
          break;
        }
      }
      if (matchedLogo) {
        pickSec3(matchedLogo);
      } else if (sec3Val) {
        pickSec3('text');
        const input3 = document.getElementById('spine3');
        if (input3) input3.value = sec3Val;
        updateSec(3, sec3Val);
      }
    }
    syncSelectedSpineFont();
    updateByrdBoundPreview();

    // Step 5
    if (os.coverStampType) {
      document.querySelectorAll('.stamp-card, .stamp-custom-card').forEach(c => {
        if (c.getAttribute('data-cover-stamp') === os.coverStampType) {
          c.classList.add('selected');
        } else {
          c.classList.remove('selected');
        }
      });
      const brassNote = document.getElementById('brass-note');
      if (brassNote) brassNote.style.display = os.coverStampType === 'custom' ? 'block' : 'none';
      const textWrap = document.getElementById('cover-stamp-text-wrap');
      if (textWrap) textWrap.style.display = os.coverStampType === 'text' ? 'block' : 'none';
      if (os.coverStampType === 'text') {
        const cstInput = document.getElementById('cover-stamp-text-input');
        const cstVal = os.coverStampText || data.coverStampTextVal || '';
        if (cstInput) cstInput.value = cstVal;
        const charCountEl = document.getElementById('cover-stamp-char-count');
        if (charCountEl) {
          charCountEl.textContent = cstVal.length + ' character' + (cstVal.length === 1 ? '' : 's') + ' (+$' + cstVal.length + '.00)';
        }
      }
    }

    if (os.coverStampPlacement) {
      document.querySelectorAll('.place-card').forEach(c => {
        if (c.getAttribute('data-placement') === os.coverStampPlacement) {
          c.classList.add('selected');
        } else {
          c.classList.remove('selected');
        }
      });
      const placementOther = document.getElementById('placement-other-input');
      if (placementOther) placementOther.style.display = os.coverStampPlacement === 'other' ? 'block' : 'none';
    }

    if (os.coverStampColor) {
      document.querySelectorAll('.stamp-color-card').forEach(c => {
        if (c.getAttribute('data-stamp-color') === os.coverStampColor) {
          c.classList.add('selected');
        } else {
          c.classList.remove('selected');
        }
      });
      const selCoverStampColor = document.getElementById('selected-cover-stamp-color');
      if (selCoverStampColor) selCoverStampColor.textContent = os.coverStampColor;
    }

    if (os.inscriptions) {
      document.querySelectorAll('.insc-card').forEach(c => c.classList.remove('selected'));
      let hasInsc = false;
      for (let loc of ['front', 'liner', 'back']) {
        if (os.inscriptions[loc]) {
          hasInsc = true;
          const card = document.querySelector(`.insc-card[data-inscription="${loc}"]`);
          if (card) card.classList.add('selected');
          const wrap = document.getElementById(`insc-${loc}-input-wrap`);
          if (wrap) {
            wrap.style.display = 'block';
            renderInscriptionInputs(loc);
          }
        } else {
          const wrap = document.getElementById(`insc-${loc}-input-wrap`);
          if (wrap) wrap.style.display = 'none';
        }
      }
      const inscWrap = document.getElementById('inscription-input-wrap');
      if (inscWrap) inscWrap.style.display = hasInsc ? 'block' : 'none';
      if (!hasInsc) {
        const noInscCard = document.querySelector('.insc-card[data-inscription="none"]');
        if (noInscCard) noInscCard.classList.add('selected');
      }
      if (os.inscriptionFont) {
        document.querySelectorAll('#inscription-input-wrap .font-card').forEach(c => {
          const name = c.querySelector('.font-name')?.textContent;
          if (name && name.trim().toLowerCase() === os.inscriptionFont.trim().toLowerCase()) {
            c.classList.add('selected');
          } else {
            c.classList.remove('selected');
          }
        });
      }
    }

    // Step 6
    if (os.toggles) {
      const rowSingle = document.getElementById('row-single');
      if (rowSingle) {
        if (os.toggles.gilt1) {
          rowSingle.classList.add('active');
          if (os.gilt1Color) {
            document.querySelectorAll('#colors-single .sc-extra').forEach(c => {
              const name = c.querySelector('.sc-name')?.textContent;
              if (name && name.trim().toLowerCase() === os.gilt1Color.trim().toLowerCase()) c.classList.add('sel');
              else c.classList.remove('sel');
            });
          }
        } else {
          rowSingle.classList.remove('active');
        }
      }

      const rowDouble = document.getElementById('row-double');
      if (rowDouble) {
        if (os.toggles.gilt2) {
          rowDouble.classList.add('active');
          if (os.gilt2Color) {
            document.querySelectorAll('#colors-double .sc-extra').forEach(c => {
              const name = c.querySelector('.sc-name')?.textContent;
              if (name && name.trim().toLowerCase() === os.gilt2Color.trim().toLowerCase()) c.classList.add('sel');
              else c.classList.remove('sel');
            });
          }
        } else {
          rowDouble.classList.remove('active');
        }
      }

      const rowDye = document.getElementById('row-dye');
      if (rowDye) {
        if (os.toggles.dye) {
          rowDye.classList.add('active');
          const dyeInput = document.getElementById('dye-color');
          const dyeVal = os.dyeColor || data.dyeColorVal || '';
          if (dyeInput) dyeInput.value = dyeVal;
          if (os.dyeSandoff) {
            const sandoffCb = document.getElementById('sandoff-cb') || document.getElementById('sandoff-row');
            if (sandoffCb) sandoffCb.classList.add('checked');
            const sandoffBox = document.getElementById('sandoff-box');
            if (sandoffBox) sandoffBox.textContent = '✓';
          }
          if (os.dyeAck) {
            const dyeAckRow = document.getElementById('dye-ack-row');
            if (dyeAckRow) dyeAckRow.classList.add('checked');
            const dyeAckBox = document.getElementById('dye-ack-box');
            if (dyeAckBox) dyeAckBox.textContent = '✓';
          }
        } else {
          rowDye.classList.remove('active');
        }
      }

      const rowSpeckle = document.getElementById('row-speckle');
      if (rowSpeckle) {
        if (os.toggles.speckle) {
          rowSpeckle.classList.add('active');
          if (os.speckleAck) {
            const spAckRow = document.getElementById('speckle-ack-row');
            if (spAckRow) spAckRow.classList.add('checked');
            const spAckBox = document.getElementById('speckle-ack-box');
            if (spAckBox) spAckBox.textContent = '✓';
          }
          [1, 2, 3].forEach(slot => {
            const spVal = os['speckle' + slot];
            if (spVal) {
              const dots = document.querySelectorAll(`#sp${slot} .sp-dot`);
              dots.forEach(dot => {
                const dotTitle = dot.getAttribute('title') || '';
                if (dotTitle.toLowerCase() === spVal.toLowerCase()) {
                  pickSp(slot, dot, dotTitle);
                }
              });
            }
          });
        } else {
          rowSpeckle.classList.remove('active');
        }
      }

      const rowStitch = document.getElementById('row-stitch');
      if (rowStitch) {
        if (os.toggles.stitch) {
          rowStitch.classList.add('active');
          const stitchInput = document.getElementById('stitch-color');
          const stitchVal = os.stitchColor || data.stitchColorVal || '';
          if (stitchInput) stitchInput.value = stitchVal;
        } else {
          rowStitch.classList.remove('active');
        }
      }
      updateExtrasSummary();
    }

    // Step 7
    const notesVal = data.notes || os.notes || '';
    const notesEl = document.getElementById('notes');
    if (notesEl && notesVal) {
      notesEl.value = notesVal;
    }

    updatePriceBar();
    updateSummary();

  } catch (err) {
    console.error('Error applying wizard state to UI:', err);
  } finally {
    window._isRestoringCartWizard = prevRestoring;
  }
}
window.applyOrderStateToUI = applyOrderStateToUI;

const togglePrices = { 
  stitch: (window.WIZARD_CONFIG && window.WIZARD_CONFIG.extraPrices && window.WIZARD_CONFIG.extraPrices.stitch !== undefined) ? window.WIZARD_CONFIG.extraPrices.stitch : 100,
  tool: (window.WIZARD_CONFIG && window.WIZARD_CONFIG.extraPrices && window.WIZARD_CONFIG.extraPrices.tool !== undefined) ? window.WIZARD_CONFIG.extraPrices.tool : 25,
  gilt1: (window.WIZARD_CONFIG && window.WIZARD_CONFIG.extraPrices && window.WIZARD_CONFIG.extraPrices.gilt1 !== undefined) ? window.WIZARD_CONFIG.extraPrices.gilt1 : 20,
  gilt2: (window.WIZARD_CONFIG && window.WIZARD_CONFIG.extraPrices && window.WIZARD_CONFIG.extraPrices.gilt2 !== undefined) ? window.WIZARD_CONFIG.extraPrices.gilt2 : 40,
  dye: (window.WIZARD_CONFIG && window.WIZARD_CONFIG.extraPrices && window.WIZARD_CONFIG.extraPrices.dye !== undefined) ? window.WIZARD_CONFIG.extraPrices.dye : 40,
  speckle: (window.WIZARD_CONFIG && window.WIZARD_CONFIG.extraPrices && window.WIZARD_CONFIG.extraPrices.speckle !== undefined) ? window.WIZARD_CONFIG.extraPrices.speckle : 100
};

// Ribbon Colors Data - Exact Bible Ribbons from Chart (30 colors in 5 rows of 6)
const ribbonColors = {
  row1: [
    { name: "White", hex: "#ffffff" },
    { name: "Ivory", hex: "#f3ecdc" },
    { name: "Silver", hex: "#b6babd" },
    { name: "Gold", hex: "#cfac61" },
    { name: "Brown", hex: "#6d4f43" },
    { name: "Black", hex: "#333333" }
  ],
  row2: [
    { name: "Red", hex: "#d3353f" },
    { name: "Wine Red", hex: "#7e3946" },
    { name: "Burgundy", hex: "#8a4450" },
    { name: "Rose", hex: "#e55489" },
    { name: "Pink", hex: "#f17cab" },
    { name: "Light Pink", hex: "#f0b5c7" }
  ],
  row3: [
    { name: "Dusty Pink", hex: "#d4a5ac" },
    { name: "Coral", hex: "#fe7e6f" },
    { name: "Peach", hex: "#f5bd9a" },
    { name: "Orange", hex: "#f69234" },
    { name: "Yellow", hex: "#f7c948" },
    { name: "Purple", hex: "#8a42a7" }
  ],
  row4: [
    { name: "Light Purple", hex: "#a895da" },
    { name: "Navy Blue", hex: "#3c4f7d" },
    { name: "Royal Blue", hex: "#4066cc" },
    { name: "Light Blue", hex: "#b2cee1" },
    { name: "Teal", hex: "#347d85" },
    { name: "Turquoise", hex: "#36b0d1" }
  ],
  row5: [
    { name: "Forest Green", hex: "#347554" },
    { name: "Green", hex: "#2fb16b" },
    { name: "Sage Green", hex: "#b2ccac" },
    { name: "Olive Green", hex: "#7d8941" },
    { name: "Army Green", hex: "#98a550" },
    { name: "Lime Green", hex: "#93dd36" }
  ]
};

const leatherColors = {
  waxy: ['Black', 'Bordeaux', 'Cognac', 'Dark Brown', 'Natural', 'Navy Blue', 'Olive Green', 'Red', 'Walnut', 'Bone', 'Steel Grey', 'Golden Yellow', 'Emerald', 'Turquoise', 'Sapphire', 'Navy', 'Violet', 'Pink'],
  buffalo: ['Storm Blue'],
  pueblo: ['Natural', 'Cognac', 'Olmo', 'Siena', 'Walnut', 'Tobacco', 'Dark Brown', 'Black', 'Grey', 'Red', 'Yellow', 'Emerald Green', 'Olive Green', 'Pink', 'Ortensia', 'Sapphire Blue', 'Navy Blue', 'Violet', 'Coccinella', 'Bordeaux'],
  capra3: ['Natural', 'Cognac', 'Olmo', 'Siena', 'Walnut', 'Tobacco', 'Dark Brown', 'Black', 'Grey', 'Red', 'Yellow', 'Emerald Green', 'Olive Green', 'Pink', 'Ortensia', 'Sapphire Blue', 'Navy Blue', 'Violet', 'Coccinella', 'Bordeaux'],
  minerva: ['Natural (Bone)', 'Cognac', 'Olmo', 'Walnut', 'Tobacco', 'Dark Brown', 'Black', 'Grey', 'Red', 'Yellow', 'Olive', 'Emerald', 'Ortensia', 'Sapphire', 'Navy', 'Violet', 'Bordeaux', 'Pink'],
  lochness: ['Bone', 'Cognac', 'Walnut', 'Black', 'Olive', 'Navy'],
  bisanzio: ['Silver', 'Gold', 'Aztec', 'Rose Gold', 'Copper', 'Bronze', 'Diamond', 'Ruby', 'Emerald', 'Sapphire', 'Magnolia', 'Amethyste'],
  sauvage: ['Pine Green', 'Marine', 'Antique Walnut', 'Cigar', 'Black'],
  capra: ['Black', 'British Tan', 'Brown 205', 'Crimson', 'Forest Green', 'Grey', 'Mocha', 'Navy Blue', 'Purple', 'Red 100', 'Red 104', 'Terra Cotta'],
  pullup: ['Black', 'Blue', 'British Tan', 'Dark Brown', 'Green', 'Red'],
  sokoto: ['Black', 'British Tan', 'Brown 205', 'Crimson', 'Forest Green', 'Grey', 'Mocha', 'Navy Blue', 'Purple', 'Red 100', 'Red 104', 'Terra Cotta']
};

const colorSwatches = {
  'Black': '#1a1a1a', 'Bordeaux': '#6b1a2a', 'Cognac': '#945b2b', 'Dark Brown': '#3a2010', 'Natural': '#c8a868', 'Natural (Bone)': '#c8a868',
  'Storm Blue': '#2c3947',
  'Navy Blue': '#0a1a3a', 'Olive Green': '#4a5a1a', 'Red': '#8a0808', 'Walnut': '#4a2a10', 'Deep Blue': '#2a3f70',
  'Red Wine': '#6a2030', 'Pine Green': '#2f5a46', 'Mocha': '#4a2a10', 'Blue': '#0d4868', 'Brown': '#6a4a2a',
  'Crimson': '#8a0808', 'Forest Green': '#2f5a46', 'British Tan': '#a87840', 'Terra Cotta': '#b85a20', 'Purple': '#4a1060',
  'Aqua': '#1a8a8a', 'Yellow': '#c89020', 'Emerald': '#2d5854', 'Emerald Green': '#5f6f4f', 'Grey': '#7a7a7a', 'Gray': '#6a6a6a',
  'Whiskey': '#8a5020', 'Bone': '#c8a868', 'Pink': '#d06080', 'Violet': '#4a1060', 'Turquoise': '#1a7a7a', 'Olmo': '#7a3810',
  'Siena': '#8c5a4a', 'Tobacco': '#6a4020', 'Ortensia': '#2c8c94', 'Sapphire Blue': '#2f5f8f', 'Coccinella': '#7a2d2d',
  'Marine Blue': '#2d5382', 'Marine': '#23345c', 'Antique Walnut': '#4c372b', 'Cigar': '#3a2b22', 'Forest': '#31583c', 'Burgundy': '#6e213d', 'Brown 205': '#6a4020', 'Red 100': '#b82030', 'Red 104': '#d06080',
  'Radical Red': '#c03040', 'Robin Egg Blue': '#4aa8c8', 'Steel Grey': '#5a6a7a', 'Golden Yellow': '#c89020', 'Sapphire': '#0d628a',
  'Navy': '#0a1a3a', 'Olive': '#4a5a1a', 'Green': '#1a5840',
  'Silver': '#b8b8ba', 'Gold': '#c5a059', 'Aztec': '#b07d58', 'Rose Gold': '#b87b70', 'Copper': '#b86848', 'Bronze': '#584a48', 'Diamond': '#9ba0b4', 'Ruby': '#8a1838', 'Magnolia': '#b84868', 'Amethyste': '#6b4068'
};

const linerColors = ['Black', 'Forest Green', 'Burgundy', 'Navy Blue', 'Orange', 'Ocean Blue', 'Bone', 'Grey', 'White', 'Yellow', 'Lilac', 'Kelly Green', 'Chocolate', 'Dark Brown', 'Red', 'Magenta', 'Rose Pink', 'Purple', 'Sky Blue'];
const linerSwatches = { 
  'Black': '#141414', 'Forest Green': '#1a4a1a', 'Burgundy': '#5a0a2a', 'Navy Blue': '#0a1a4a', 'Orange': '#e86a10',
  'Ocean Blue': '#1a4a7a', 'Bone': '#d4b878', 'Grey': '#6a6a6a', 'White': '#e8e0d0', 'Yellow': '#c89020',
  'Lilac': '#a060a0', 'Kelly Green': '#108040', 'Chocolate': '#4a2010', 'Dark Brown': '#2a1408', 'Red': '#8a0a0a',
  'Magenta': '#a01a6a', 'Rose Pink': '#d07080', 'Purple': '#3a0a6a', 'Sky Blue': '#7aa8c8'
};

function calcTotal() {
  if (window.WIZARD_CONFIG && window.WIZARD_CONFIG.basePrice !== undefined) {
    basePrice = window.WIZARD_CONFIG.basePrice;
  }
  let total = basePrice;
  if (orderState.bibleSource === 'source') total += orderState.translationPrice;
  if (orderState.bibleSource === 'own') total += orderState.bibleConditionPrice;
  total += orderState.leatherPrice + orderState.coverStiffnessPrice + orderState.yappPrice + orderState.ribbonsPrice + orderState.hubPrice;
  total += orderState.spineStampColorPrice;

  Object.keys(orderState.spineSections).forEach(section => {
    if (section !== '1' && section !== '2' && section !== '6' && orderState.spineSections[section]) {
    total += ((window.WIZARD_CONFIG && window.WIZARD_CONFIG.spineSecPrice !== undefined) ? window.WIZARD_CONFIG.spineSecPrice : 15);
    }
  });
  
  Object.keys(orderState.toggles).forEach(key => {
    if (orderState.toggles[key] && togglePrices[key]) total += togglePrices[key];
  });
  if (orderState.toolingPrice) total += orderState.toolingPrice;
  if (orderState.toggles.gilt1) total += orderState.gilt1Upcharge;
  if (orderState.toggles.gilt2) total += orderState.gilt2Upcharge;
  if (orderState.toggles.speckle && orderState.speckle3) total += 15;

  if (orderState.coverStampType !== 'none') {
    let applyCost = true;
    if (orderState.coverStampPlacement === 'spine-middle' && orderState.spineSections[3] === 'Chi Rho Logo') {
      applyCost = false;
    }
    if (applyCost) {
      total += orderState.coverStampCost;
    }
    total += orderState.coverStampColorCost;
  }
  if (orderState.inscriptionCost) {
    total += orderState.inscriptionCost;
  }

  return Math.max(0, total);
}

function updatePriceBar() {
  const total = calcTotal();
  const runTotal = document.getElementById('running-total');
  if (runTotal) runTotal.textContent = '$' + total.toFixed(0);
  const sumTotal = document.getElementById('sum-total');
  if (sumTotal) sumTotal.textContent = '$' + total.toFixed(0);
  const deposit = 200;
  const sumBalance = document.getElementById('sum-balance');
  if (sumBalance) sumBalance.textContent = '$' + Math.max(0, (total - deposit)).toFixed(0);

  const sectionsTotal = Object.keys(orderState.spineSections).filter(s => s !== '1' && s !== '2' && s !== '6' && orderState.spineSections[s] && orderState.spineSections[s].trim()).length * ((window.WIZARD_CONFIG && window.WIZARD_CONFIG.spineSecPrice !== undefined) ? window.WIZARD_CONFIG.spineSecPrice : 15);
  const secTotalDisplay = document.getElementById('sections-total-display') || document.getElementById('sec-total');
  if (secTotalDisplay) secTotalDisplay.textContent = '$' + sectionsTotal;
}

function buildProgress() {
  const el = document.getElementById('progress-steps');
  if (!el) return;
  el.innerHTML = steps.map((s, i) => {
    const statusClass = i < currentStep ? 'done' : i === currentStep ? 'active' : '';
    return `<div class="p-step ${statusClass}" id="pstep-${i}" onclick="goToStep(${i})" title="Go to ${s}" role="button" tabindex="0"><div class="p-step-line"></div><div class="p-step-label">${s}</div></div>`;
  }).join('');
}

function buildRibbonColorGrids() {
  for (let [group, colorArr] of Object.entries(ribbonColors)) {
    const container = document.getElementById(`ribbon-grid-${group}`);
    if (!container) continue;
    let htmlStr = '';
    colorArr.forEach(color => {
      const isSelected = orderState.selectedRibbons && orderState.selectedRibbons.some(r => r.name === color.name && r.num === color.num);
      htmlStr += `
        <div class="ribbon-color-chip ${isSelected ? 'selected' : ''}" onclick="selectRibbonColor('${color.name}', '${color.num}', '${color.hex}')">
          <div class="ribbon-chip-dot" style="background:${color.hex};"></div>
          <div>
            <div class="ribbon-chip-name">${color.name}</div>
            <div class="ribbon-chip-num">#${color.num}</div>
          </div>
        </div>
      `;
    });
    container.innerHTML = htmlStr;
  }
}

function buildRibbonBtns() {
  const el = document.getElementById('ribbon-btns');
  if (!el) return;
  el.innerHTML = [0, 1, 2, 3, 4, 5, 6].map(n => {
    const isSelected = n === orderState.ribbons;
    return `<button class="rcount-btn ${isSelected ? 'selected' : ''}" onclick="pickRibbon(${n})">${n}</button>`;
  }).join('');
}

function setupRibbonTabs() {
  document.querySelectorAll('.ribbon-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const tabId = tab.getAttribute('data-ribbon-tab');
      document.querySelectorAll('.ribbon-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      document.querySelectorAll('.ribbon-panel').forEach(panel => panel.classList.remove('active'));
      const targetPanel = document.querySelector(`.ribbon-panel[data-ribbon-panel="${tabId}"]`);
      if (targetPanel) targetPanel.classList.add('active');
    });
  });
}

function updateSpineSectionPrices() {
  for (let i = 1; i <= 5; i++) {
    const input = document.getElementById(`spine${i}`);
    const priceEl = document.getElementById(`price-${i}`);
    const row = document.getElementById(`row-${i}`);
    if (input && priceEl) {
      const hasValue = input.value && input.value.trim() !== '';
      const isFree = (i === 1 || i === 2);
      if (hasValue) {
        if (isFree) {
          priceEl.textContent = 'Free';
          priceEl.style.color = '#706050';
        } else {
  priceEl.textContent = '+$' + ((window.WIZARD_CONFIG && window.WIZARD_CONFIG.spineSecPrice !== undefined) ? window.WIZARD_CONFIG.spineSecPrice : 15);
          priceEl.style.color = '#c9a96e';
        }
        if (row) row.style.borderBottom = '1px solid #c9a96e';
        orderState.spineSections[i] = input.value.trim();
      } else {
        if (isFree) {
          priceEl.textContent = 'Free';
        } else {
  priceEl.textContent = '$' + ((window.WIZARD_CONFIG && window.WIZARD_CONFIG.spineSecPrice !== undefined) ? window.WIZARD_CONFIG.spineSecPrice : 15);
        }
        priceEl.style.color = '#706050';
        if (row) row.style.borderBottom = '1px solid #2a2018';
        delete orderState.spineSections[i];
      }
    }
  }
  updatePriceBar();
}

function updateSummary() {
  const updateText = (id, text) => {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  };

  let sumBibleText = '';
  if (orderState.bibleSource === 'own') {
    sumBibleText = `My own Bible (${orderState.ownBibleType || 'Not specified'})`;
    if (orderState.bibleCondition) {
      sumBibleText += ` - ${orderState.bibleCondition}`;
    }
  } else {
    sumBibleText = `Sourced: ${orderState.translation || 'None selected'}`;
  }
  updateText('sum-bible', sumBibleText);
  updateText('sum-leather', orderState.leatherName);
  updateText('sum-color', orderState.color);
  updateText('sum-cover', `${orderState.coverStiffness} · ${orderState.yapp}`);
  updateText('sum-liner', orderState.liner + ' lambskin');
  updateText('sum-ribbons', orderState.ribbons !== undefined ? orderState.ribbons + (orderState.ribbons === 1 ? ' ribbon' : ' ribbons') : 'None');
  
  let ribbonSumText = '';
  if (orderState.ribbons > 0 && orderState.ribbonChoices && orderState.ribbonChoices.length > 0) {
    ribbonSumText = orderState.ribbonChoices.map((c, i) => `Ribbon ${i + 1}: ${c.trim()}`).filter(Boolean).join(', ');
  }
  updateText('sum-ribbon-color', ribbonSumText || 'None');
  updateText('sum-hub', orderState.hubStyle);
  updateText('sum-spine-stamp-color', orderState.spineStampColor);
  updateText('sum-font', orderState.stampFont);
  
  const spineSectionsList = Object.keys(orderState.spineSections).filter(s => s !== '6' && orderState.spineSections[s]).map(s => `Section ${s}: ${orderState.spineSections[s]}`).join(', ');
  updateText('sum-spine-sections', spineSectionsList || 'None');
  updateText('sum-stitch', orderState.toggles.stitch ? 'Hand stitching (+$100)' : 'None');

  if (orderState.coverStampType !== 'none') {
    const stampNameMap = {
      cross: 'Jerusalem Cross',
      chirho: 'Chi Rho',
      'latin-cross': 'Latin Cross',
      sword: 'Sword',
      ichthys: 'Ichthys (Fish)',
      fishbread: 'Fish + Bread',
      ark: 'Ark',
      believe: 'BELIEVE',
      'bryce-jesus': 'Bryce Jesus',
      'byzantine-cross': 'Byzantine Jerusalem Cross',
      'celtic-cross': 'Celtic Cross',
      eagle: 'Eagle',
      ega: 'EGA',
      'jerusalem-cross-alt': 'Jerusalem Cross',
      'lost-sheep': 'Jesus and the Lost Sheep',
      lamb: 'Victorious Lamb',
      'lion-lamb': 'Lion and the Lamb',
      'nail-cross': 'Nail Cross',
      'orthodox-cross': 'Orthodox Cross',
      'realistic-cross': 'Realistic Cross',
      custom: 'Custom Logo',
      text: 'Custom Text Stamp'
    };
    let stampVal = stampNameMap[orderState.coverStampType] || orderState.coverStampType;
    if (orderState.coverStampType === 'text' && orderState.coverStampText) {
      stampVal += ` ("${orderState.coverStampText}")`;
    }
    updateText('sum-cover-stamp', stampVal);
  } else {
    updateText('sum-cover-stamp', 'None');
  }
  updateText('sum-cover-placement', orderState.coverStampPlacement ? orderState.coverStampPlacement.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'None');
  updateText('sum-cover-stamp-color', orderState.coverStampColor || 'None');

  let sumInsc = [];
  const inscShortNames = { front: 'Front', liner: 'Liner', back: 'Back' };
  for (let loc in orderState.inscriptions) {
    if (orderState.inscriptions[loc]) {
      const arr = Array.isArray(orderState.inscriptionTexts[loc])
        ? orderState.inscriptionTexts[loc].filter(t => t && t.trim())
        : (orderState.inscriptionTexts[loc] && orderState.inscriptionTexts[loc].trim() ? [orderState.inscriptionTexts[loc].trim()] : []);
      if (arr.length > 0) {
        sumInsc.push(`${inscShortNames[loc]}: ${arr.map(n => `"${n}"`).join(', ')}`);
      } else {
        sumInsc.push(`${inscShortNames[loc]}: "..."`);
      }
    }
  }
  updateText('sum-inscription', sumInsc.length ? `${sumInsc.join(' · ')} (${orderState.inscriptionFont || 'Goudy Light'})` : 'None');

  let extras = [];
  if (orderState.tooling && orderState.tooling !== 'no-tooling') extras.push('Edge tooling (' + orderState.tooling.replace('-tooling', '') + ')');
  if (orderState.toggles.gilt1) extras.push('Single gilt (' + orderState.gilt1Color + ')');
  if (orderState.toggles.gilt2) extras.push('Double gilt (' + orderState.gilt2Color + ')');
  if (orderState.toggles.dye) extras.push('Edge dye (' + (orderState.dyeColor || 'Not specified') + ')');
  if (orderState.toggles.speckle) {
    let spColors = [orderState.speckle1, orderState.speckle2, orderState.speckle3].filter(Boolean).join(', ');
    extras.push('Speckled edges (' + spColors + ')');
  }
  if (orderState.toggles.stitch) extras.push('Hand stitching (' + (orderState.stitchColor || 'Not specified') + ')');
  updateText('sum-extras', extras.length ? extras.join(', ') : 'None selected');
  
  updatePriceBar();
}

let savedScrollY = 0;

let chatObserver = null;

function toggleChatWidget(show) {
  const selectors = [
    '#shopify-chat',
    'iframe#chat-button',
    '#dummy-chat-button-iframe',
    'shopify-chat',
    '#ShopifyChat',
    'iframe[id*="chat"]',
    'iframe[id*="inbox"]',
    'div[id*="shopify-chat"]',
    '[data-chat-button]',
    '#inbox-chat',
    '[id*="shopify-inbox"]',
    '[class*="shopify-inbox"]',
    '.shopify-inbox-conversation-button',
    '#chat-bubble-button',
    '[aria-label*="chat" i]',
    '[aria-label*="inbox" i]',
    '[id*="chat-container"]',
    '[class*="chat-widget"]',
    '#chat-button-container',
    '[data-testid="chat-button"]'
  ];
  selectors.forEach(sel => {
    try {
      document.querySelectorAll(sel).forEach(el => {
        el.style.setProperty('display', show ? '' : 'none', 'important');
        el.style.setProperty('visibility', show ? '' : 'hidden', 'important');
        el.style.setProperty('opacity', show ? '' : '0', 'important');
        el.style.setProperty('pointer-events', show ? '' : 'none', 'important');
      });
    } catch(err) {}
  });
}

function startChatHidingObserver() {
  if (chatObserver) return;
  try {
    chatObserver = new MutationObserver(() => {
      if (document.body && document.body.classList.contains('wizard-open')) {
        toggleChatWidget(false);
      }
    });
    chatObserver.observe(document.body, { childList: true, subtree: true });
  } catch(err) {}
}

function stopChatHidingObserver() {
  if (chatObserver) {
    try {
      chatObserver.disconnect();
    } catch(err) {}
    chatObserver = null;
  }
}

function optimizeWizardImages() {
  try {
    document.querySelectorAll('#wizardModal img').forEach(img => {
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  } catch(err) {}
}

function wizardAutoScroll(target) {
  if (window._isRestoringCartWizard) {
    return;
  }
  if (window.WIZARD_CONFIG && window.WIZARD_CONFIG.autoScroll === false) {
    return;
  }
  setTimeout(function() {
    let targetEl = null;
    if (typeof target === 'string') {
      targetEl = document.querySelector(target);
    } else if (target && target.nodeType === 1) {
      targetEl = target;
    }
    if (!targetEl) return;

    const container = document.querySelector('.wizard-modal-content');
    if (!container) {
      if (typeof targetEl.scrollIntoView === 'function') {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    // Check if targetEl is a fixed element (such as mobile bottom navigation bar)
    const isFixed = window.getComputedStyle ? (window.getComputedStyle(targetEl).position === 'fixed') : false;
    if (isFixed) {
      const dest = container.scrollHeight;
      try {
        container.scrollTo({ top: dest, behavior: 'smooth' });
      } catch (e) {
        container.scrollTop = dest;
      }
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const targetRect = targetEl.getBoundingClientRect();
    const targetOffset = 30; // 30px offset from the top
    const relativeTop = targetRect.top - containerRect.top;

    // Scroll if relative distance differs from target offset by more than 15px
    if (Math.abs(relativeTop - targetOffset) > 15) {
      const destTop = Math.max(0, container.scrollTop + relativeTop - targetOffset);
      try {
        container.scrollTo({
          top: destTop,
          behavior: 'smooth'
        });
      } catch (err) {
        container.scrollTop = destTop;
      }
    }
  }, 10);
}
window.wizardAutoScroll = wizardAutoScroll;

function openWizard(initialStep) {
  if (typeof deduplicateWizardModals === 'function') deduplicateWizardModals();
  const modal = document.getElementById('wizardModal');
  if (modal) {
    savedScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    modal.classList.add('active');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('wizard-open');
    document.documentElement.classList.add('wizard-open');

    toggleChatWidget(false);
    startChatHidingObserver();
    optimizeWizardImages();

    let restoredData = null;
    if (!window.WIZARD_EDIT_MODE || !window.WIZARD_EDIT_MODE.isEditing) {
      restoredData = restoreWizardStateFromStorage();
    }

    let stepToOpen = 0;
    if (typeof initialStep === 'number' && !isNaN(initialStep) && initialStep >= 0 && initialStep <= 7) {
      stepToOpen = initialStep;
    } else if (restoredData && typeof restoredData.savedStep === 'number' && !isNaN(restoredData.savedStep) && restoredData.savedStep >= 0 && restoredData.savedStep <= 7) {
      stepToOpen = restoredData.savedStep;
    }

    currentStep = stepToOpen;
    document.querySelectorAll('.step-panel').forEach(p => p.classList.remove('active'));
    const targetPanel = document.getElementById('panel-' + currentStep);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
    buildProgress();
    buildRibbonBtns();
    renderRibbonInputs();

    if (!restoredData && typeof initialStep !== 'number') {
      orderState.ribbonChoices = [];
      document.querySelectorAll('.stamp-card').forEach(c => c.classList.remove('selected'));
      const noneStamp = document.querySelector('.stamp-card[data-cover-stamp="none"]');
      if (noneStamp) noneStamp.classList.add('selected');
      orderState.coverStampType = 'none';
      orderState.coverStampCost = 0;
      const brassNote = document.getElementById('brass-note');
      if (brassNote) brassNote.style.display = 'none';
      const coverStampTextWrap = document.getElementById('cover-stamp-text-wrap');
      if (coverStampTextWrap) coverStampTextWrap.style.display = 'none';
      document.querySelectorAll('.place-card').forEach(c => c.classList.remove('selected'));
      const placeOther = document.getElementById('placement-other-input');
      if (placeOther) placeOther.style.display = 'none';
      document.querySelectorAll('.stamp-color-card').forEach(c => c.classList.remove('selected'));
      const selCoverStampColor = document.getElementById('selected-cover-stamp-color');
      if (selCoverStampColor) selCoverStampColor.textContent = '';
      document.querySelectorAll('.insc-card').forEach(c => c.classList.remove('selected'));
      const inscInputWrap = document.getElementById('inscription-input-wrap');
      if (inscInputWrap) inscInputWrap.style.display = 'none';
      const inscFrontWrap = document.getElementById('insc-front-input-wrap');
      if (inscFrontWrap) inscFrontWrap.style.display = 'none';
      const inscLinerWrap = document.getElementById('insc-liner-input-wrap');
      if (inscLinerWrap) inscLinerWrap.style.display = 'none';
      const inscBackWrap = document.getElementById('insc-back-input-wrap');
      if (inscBackWrap) inscBackWrap.style.display = 'none';
      const cstInput = document.getElementById('cover-stamp-text-input');
      if (cstInput) cstInput.value = '';
      const inscFront = document.getElementById('inscription-text-front');
      if (inscFront) inscFront.value = '';
      const inscLiner = document.getElementById('inscription-text-liner');
      if (inscLiner) inscLiner.value = '';
      const inscBack = document.getElementById('inscription-text-back');
      if (inscBack) inscBack.value = '';
      orderState.coverStampText = '';
      orderState.customLeatherText = '';
      const custInput = document.getElementById('custom-leather-text');
      if (custInput) custInput.value = '';
      orderState.inscriptions = { front: false, liner: false, back: false };
      orderState.inscriptionTexts = { front: '', liner: '', back: '' };
      orderState.inscriptionCost = 0;
      
      document.querySelectorAll('.font-card').forEach(c => c.classList.remove('selected'));
      orderState.inscriptionFont = 'Goudy Light';
      const firstInscFont = document.querySelector('#inscription-input-wrap .font-card');
      if (firstInscFont) firstInscFont.classList.add('selected');
      document.querySelectorAll('.sp-dot').forEach(d => d.classList.remove('sel'));
      const sp1L = document.getElementById('sp1-label');
      if (sp1L) sp1L.textContent = '— select a color';
      const sp2L = document.getElementById('sp2-label');
      if (sp2L) sp2L.textContent = '— select a color';
      const sp3L = document.getElementById('sp3-label');
      if (sp3L) sp3L.textContent = '— optional +$15';
      orderState.speckle1 = '';
      orderState.speckle2 = '';
      orderState.speckle3 = '';
      const noTooling = document.querySelector('.opt-card[data-opt="no-tooling"]');
      if(noTooling) selectOpt(noTooling, 'tooling');
      const firstFont = document.querySelector('.font-card');
      if(firstFont) selFont(firstFont);
      const mandBoth = document.getElementById('mand-both');
      if(mandBoth) selMand(mandBoth, 'both');
      pickSec3('blank');
      updatePriceBar();
    }

    if (restoredData) {
      if (currentStep === 1) {
        const activeTab = document.querySelector('.ltab.active') || document.getElementById('tab-' + (orderState.leather || 'minerva'));
        if (activeTab) activeTab.classList.add('active');
        const activePanel = document.querySelector('.leather-panel[style*="display: block"]') || document.getElementById('panel-' + (orderState.leather || 'minerva'));
        if (activePanel) activePanel.style.display = 'block';
      }
      if (currentStep === 3) {
        buildRibbonBtns();
        renderRibbonInputs();
      }
      if (currentStep === 4) {
        setupSpineStep();
      }
      if (currentStep === 7) {
        updateSummary();
      }
      updatePriceBar();
    }

    const headerBanner = document.getElementById('wiz-cart-product-header');
    if (headerBanner && (!window.WIZARD_EDIT_MODE || !window.WIZARD_EDIT_MODE.isEditing)) {
      headerBanner.style.display = 'none';
    }
    updateWizardEditModeUI();
  }
}

function closeWizard() {
  const modal = document.getElementById('wizardModal');
  if (modal) {
    modal.classList.remove('active');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('wizard-open');
    document.documentElement.classList.remove('wizard-open');

    stopChatHidingObserver();
    toggleChatWidget(true);

    window.wizardReturnToReview = false;
    updateReturnToReviewBanner();

    const headerBanner = document.getElementById('wiz-cart-product-header');
    if (headerBanner) {
      headerBanner.style.display = 'none';
    }
    window.WIZARD_EDIT_MODE = null;
    updateWizardEditModeUI();

    saveWizardStateToStorage();
    window.scrollTo(0, savedScrollY);
  }
}

function updateReturnToReviewBanner() {
  let banner = document.getElementById('wiz-return-review-banner');
  if (window.wizardReturnToReview && currentStep < 7) {
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'wiz-return-review-banner';
      banner.className = 'wiz-return-banner';
      const wizBody = document.querySelector('.wiz-body');
      if (wizBody && wizBody.parentNode) {
        wizBody.parentNode.insertBefore(banner, wizBody);
      }
    }
    banner.innerHTML = `
      <div class="wiz-return-inner">
        <span class="wiz-return-text">Editing selection from Review</span>
        <button type="button" class="btn-return-review" onclick="goToStep(7)">Return to Review & submit &rarr;</button>
      </div>
    `;
    banner.style.display = 'block';
  } else {
    if (banner) {
      banner.style.display = 'none';
    }
  }
}

function goToStep(targetStep) {
  if (targetStep === undefined || targetStep === null) return;
  targetStep = parseInt(targetStep, 10);
  if (isNaN(targetStep) || targetStep < 0 || targetStep > 7) return;
  if (targetStep === currentStep) return;

  // Track if coming from Review to allow quick return
  if (currentStep === 7 && targetStep < 7) {
    window.wizardReturnToReview = true;
  } else if (targetStep === 7) {
    window.wizardReturnToReview = false;
  }

  const currentPanel = document.getElementById('panel-' + currentStep);
  if (currentPanel) currentPanel.classList.remove('active');

  currentStep = targetStep;
  const targetPanel = document.getElementById('panel-' + currentStep);
  if (targetPanel) targetPanel.classList.add('active');

  buildProgress();
  updateReturnToReviewBanner();

  if (currentStep === 3) {
    if (typeof buildRibbonBtns === 'function') buildRibbonBtns();
    if (typeof renderRibbonInputs === 'function') renderRibbonInputs();
  }
  if (currentStep === 4) {
    if (typeof setupSpineStep === 'function') setupSpineStep();
  }
  if (currentStep === 7) {
    if (typeof updateSummary === 'function') updateSummary();
  }
  updateWizardEditModeUI();

  saveWizardStateToStorage();

  const modalContent = document.querySelector('.wizard-modal-content');
  if (modalContent) modalContent.scrollTop = 0;
}

function nextStep() {
  if (currentStep === 0) {
    if (!orderState.bibleSource) { showWizardAlert("Please select whether you are sending your own Bible or if you want us to source one."); return; }
    if (orderState.bibleSource === 'own') {
      if (!orderState.ownBibleType || !orderState.ownBibleType.trim()) { showWizardAlert("Please specify what kind of Bible you are sending."); return; }
      if (!orderState.bibleCondition) { showWizardAlert("Please select the condition of your Bible."); return; }
    }
    if (orderState.bibleSource === 'source' && !orderState.translation) { showWizardAlert("Please choose a translation."); return; }
  } else if (currentStep === 1) {
    if (!orderState.leather || !orderState.liner) { showWizardAlert("Please select a leather type and inner liner color."); return; }
    if (orderState.leather === 'custom') {
      if (!orderState.customLeatherText || !orderState.customLeatherText.trim()) { showWizardAlert("Please enter your custom leather details in the text box."); return; }
    } else {
      if (!orderState.color) { showWizardAlert("Please select a cover color."); return; }
    }
  } else if (currentStep === 2) {
    if (!orderState.coverStiffness || !orderState.yapp) { showWizardAlert("Please select both a cover stiffness and a yapp length."); return; }
  } else if (currentStep === 3) {
    if (orderState.ribbons === undefined) { showWizardAlert("Please select the number of ribbons."); return; }
    if (orderState.ribbons > 0) {
      if (!orderState.ribbonChoices || orderState.ribbonChoices.length < orderState.ribbons) {
        showWizardAlert(`Please specify a color for all ${orderState.ribbons} ribbon(s).`); return;
      }
      for (let i = 0; i < orderState.ribbons; i++) {
        if (!orderState.ribbonChoices[i] || !orderState.ribbonChoices[i].trim()) {
          showWizardAlert(`Please enter the color for Ribbon ${i + 1}.`); return;
        }
      }
    }
  } else if (currentStep === 4) {
    if (!orderState.hubStyle || !orderState.spineStampColor || !orderState.stampFont || !orderState.spineLogo) { showWizardAlert("Please select your spine details (Hub style, Stamping Color, Font, and Logo type)."); return; }
  } else if (currentStep === 5) {
    if (!orderState.coverStampType) { showWizardAlert("Please select your cover stamping options."); return; }
    if (orderState.coverStampType !== 'none' && (!orderState.coverStampPlacement || !orderState.coverStampColor)) { showWizardAlert("Please select placement and color for your cover stamp."); return; }
    if (orderState.coverStampType === 'text' && (!orderState.coverStampText || !orderState.coverStampText.trim())) { showWizardAlert("Please enter the custom text for your cover stamp."); return; }
    
    let missingInscText = false;
    for (let loc in orderState.inscriptions) {
      if (orderState.inscriptions[loc]) {
        const arr = Array.isArray(orderState.inscriptionTexts[loc])
          ? orderState.inscriptionTexts[loc].filter(t => t && t.trim())
          : (orderState.inscriptionTexts[loc] && orderState.inscriptionTexts[loc].trim() ? [orderState.inscriptionTexts[loc].trim()] : []);
        if (arr.length === 0) {
          missingInscText = true;
        }
      }
    }
    if (missingInscText) { showWizardAlert("Please enter the inscription text for all selected locations."); return; }
  } else if (currentStep === 6) {
    if (orderState.toggles['dye'] && (!orderState.dyeColor || !orderState.dyeColor.trim())) { showWizardAlert("Please enter your desired page dye color in the text box."); return; }
    if (orderState.toggles['dye'] && !orderState.dyeAck) { showWizardAlert("Please check the Acknowledgement box for Page Dye regarding page tabs before proceeding."); return; }
    if (orderState.toggles['speckle'] && !orderState.speckleAck) { showWizardAlert("Please check the Acknowledgement box for Page Edge Speckles regarding page tabs before proceeding."); return; }
    if (orderState.toggles['stitch'] && (!orderState.stitchColor || !orderState.stitchColor.trim())) { showWizardAlert("Please enter your desired thread color for hand stitching in the text box."); return; }
  }

  const currentPanel = document.getElementById('panel-' + currentStep);
  if (currentPanel) currentPanel.classList.remove('active');
  currentStep = Math.min(currentStep + 1, 7);
  const nextPanel = document.getElementById('panel-' + currentStep);
  if (nextPanel) nextPanel.classList.add('active');
  buildProgress();
  if (currentStep === 7) {
    window.wizardReturnToReview = false;
  }
  updateReturnToReviewBanner();
  if (currentStep === 3) { buildRibbonBtns(); renderRibbonInputs(); }
  if (currentStep === 4) { setupSpineStep(); }
  if (currentStep === 7) updateSummary();
  updateWizardEditModeUI();

  saveWizardStateToStorage();

  const modalContent = document.querySelector('.wizard-modal-content');
  if (modalContent) modalContent.scrollTop = 0;
}

function prevStep() {
  const currentPanel = document.getElementById('panel-' + currentStep);
  if (currentPanel) currentPanel.classList.remove('active');
  currentStep = Math.max(currentStep - 1, 0);
  const prevPanel = document.getElementById('panel-' + currentStep);
  if (prevPanel) prevPanel.classList.add('active');
  buildProgress();
  if (currentStep === 7) {
    window.wizardReturnToReview = false;
  }
  updateReturnToReviewBanner();
  updateWizardEditModeUI();

  saveWizardStateToStorage();

  const modalContent = document.querySelector('.wizard-modal-content');
  if (modalContent) modalContent.scrollTop = 0;
}

function updateColorLabelWithChip(leatherKey, colorName, dotEl) {
  const label = document.getElementById(`sel-color-${leatherKey}`);
  if (!label) return;
  if (!colorName) {
    label.innerHTML = '';
    return;
  }
  let bg = '';
  if (dotEl) {
    bg = dotEl.style.backgroundColor || dotEl.style.background || '';
  } else {
    const dot = document.querySelector(`#dots-${leatherKey} .ldot.sel`);
    if (dot) bg = dot.style.backgroundColor || dot.style.background || '';
  }
  label.innerHTML = `<span class="sel-color-txt">${colorName}</span>${bg ? `<span class="sel-color-chip" style="background:${bg};" title="${colorName}"></span>` : ''}`;
}

function updateLinerLabelWithChip(linerName, dotEl) {
  const label = document.getElementById('liner-name');
  if (!label) return;
  if (!linerName) {
    label.innerHTML = 'Select below';
    return;
  }
  let bg = '';
  if (dotEl) {
    bg = dotEl.style.backgroundColor || dotEl.style.background || '';
  } else {
    const dot = document.querySelector('.lnr-dot.sel');
    if (dot) bg = dot.style.backgroundColor || dot.style.background || '';
  }
  label.innerHTML = `<span class="sel-color-txt">${linerName} lambskin</span>${bg ? `<span class="sel-color-chip" style="background:${bg};" title="${linerName}"></span>` : ''}`;
}

function pickColor(key, el, name) {
  if (!window._isRestoringCartWizard && el && (el.classList.contains('oos') || el.getAttribute('data-oos') === 'true')) {
    return false;
  }
  document.querySelectorAll(`#dots-${key} .ldot`).forEach(d => d.classList.remove('sel'));
  if (el) el.classList.add('sel');
  orderState.color = name;
  updateColorLabelWithChip(key, name, el);
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step1-liner-divider, #step1-liner-heading, #step1-liner-section');
}

function pickLiner(el, name) {
  document.querySelectorAll('.lnr-dot').forEach(d => d.classList.remove('sel'));
  if (el) el.classList.add('sel');
  orderState.liner = name;
  updateLinerLabelWithChip(name, el);
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step1-nav-row');
}

function buildRibbonBtns() {
  const el = document.getElementById('ribbon-btns');
  if (!el) return;
  el.innerHTML = [0, 1, 2, 3, 4, 5, 6].map(n => {
    const isSelected = n === orderState.ribbons;
    return `<button class="rcount-btn ${isSelected ? 'selected' : ''}" onclick="pickRibbon(${n})">${n}</button>`;
  }).join('');
}

function renderRibbonInputs() {
  const container = document.getElementById('selected-ribbons-container');
  if (!container) return;
  const n = orderState.ribbons;
  if (n === undefined || n === null) {
    container.innerHTML = '<div style="font-size:12px;color:#706050;">Select the number of ribbons above.</div>';
    return;
  }
  if (n === 0) {
    container.innerHTML = '<div style="font-size:12px;color:#706050;">No ribbons selected.</div>';
    return;
  }
  if (!orderState.ribbonChoices) orderState.ribbonChoices = [];

  const allRibbonColors = [];
  if (typeof ribbonColors !== 'undefined') {
    Object.values(ribbonColors).forEach(arr => {
      arr.forEach(c => allRibbonColors.push(c));
    });
  }

  let html = '';
  // Determine which ribbon index should be open initially:
  // Open the first ribbon that doesn't have a choice yet, or index 0.
  let openIdx = 0;
  for (let k = 0; k < n; k++) {
    if (!orderState.ribbonChoices[k]) {
      openIdx = k;
      break;
    }
  }

  for (let i = 0; i < n; i++) {
    const val = orderState.ribbonChoices[i] || '';
    let chosenHex = '';
    const match = allRibbonColors.find(c => {
      const fl = (c.num && String(c.num).trim()) ? `${c.name} (#${c.num})` : c.name;
      return val === fl ||
        val === c.name ||
        val.toLowerCase() === c.name.toLowerCase() ||
        val.toLowerCase() === fl.toLowerCase() ||
        (c.num && val.toLowerCase().includes(c.name.toLowerCase())) ||
        c.name.toLowerCase().includes(val.toLowerCase());
    });
    if (match) chosenHex = match.hex;

    const isOpen = (i === openIdx);

    html += `
      <div class="ribbon-select-card" id="ribbon-card-${i}">
        <div class="ribbon-card-header" onclick="toggleRibbonBody(${i})">
          <div class="ribbon-card-title-group">
            <span class="ribbon-num-pill">Ribbon ${i + 1}</span>
            <div class="ribbon-current-sel" id="ribbon-sel-text-${i}">
              ${val ? `
                <span class="ribbon-swatch-chip" style="background:${chosenHex || '#c9a96e'};"></span>
                <span class="ribbon-color-name">${val}</span>
              ` : `
                <span class="ribbon-unselected-msg">Tap a swatch below to choose</span>
              `}
            </div>
          </div>
          <span class="ribbon-toggle-arrow" id="ribbon-arrow-${i}">${isOpen ? '&#9662;' : '&#9656;'}</span>
        </div>
        
        <div class="ribbon-card-body" id="ribbon-body-${i}" style="display:${isOpen ? 'block' : 'none'};">
          <div class="ribbon-palette-header">
            <span class="ribbon-palette-hint">Tap any color swatch:</span>
          </div>

          <div class="ribbon-swatches-grid" id="ribbon-grid-${i}">
            ${allRibbonColors.map(c => {
              const fullLabel = (c.num && String(c.num).trim()) ? `${c.name} (#${c.num})` : c.name;
              const isSelected = val === fullLabel || val === c.name || val.toLowerCase() === c.name.toLowerCase() || (c.num && val.toLowerCase() === `${c.name} (#${c.num})`.toLowerCase());
              return `
                <button type="button" 
                  class="ribbon-swatch-btn ${isSelected ? 'sel' : ''}" 
                  style="background-color: ${c.hex};" 
                  title="${fullLabel}" 
                  aria-label="${fullLabel}"
                  onclick="selectRibbonSwatch(${i}, '${c.name.replace(/'/g, "\\'")}', '${c.num || ''}', '${c.hex}')">
                  <span class="ribbon-check-mark">&#10003;</span>
                </button>
              `;
            }).join('')}
          </div>

          <div class="ribbon-custom-wrap">
            <input type="text" class="ribbon-color-input" id="ribbon-input-${i}" placeholder="Or type color (e.g. Navy Blue, Gold, etc.)" value="${val.replace(/"/g, '&quot;')}" oninput="updateRibbonChoice(${i}, this.value)">
          </div>
        </div>
      </div>
    `;
  }
  container.innerHTML = html;
}

function selectRibbonSwatch(idx, name, num, hex) {
  const fullLabel = (num && String(num).trim()) ? `${name} (#${num})` : name;
  if (!orderState.ribbonChoices) orderState.ribbonChoices = [];
  orderState.ribbonChoices[idx] = fullLabel;

  const grid = document.getElementById(`ribbon-grid-${idx}`);
  if (grid) {
    grid.querySelectorAll('.ribbon-swatch-btn').forEach(b => b.classList.remove('sel'));
    const clickedBtn = grid.querySelector(`[title="${fullLabel}"]`) || grid.querySelector(`[title="${name}"]`);
    if (clickedBtn) clickedBtn.classList.add('sel');
  }

  const selText = document.getElementById(`ribbon-sel-text-${idx}`);
  if (selText) {
    selText.innerHTML = `
      <span class="ribbon-swatch-chip" style="background:${hex};"></span>
      <span class="ribbon-color-name">${fullLabel}</span>
    `;
  }

  const input = document.getElementById(`ribbon-input-${idx}`);
  if (input) input.value = fullLabel;

  updateSummary();
  saveWizardStateToStorage();

  // 1. Collapse the current ribbon
  const currentBody = document.getElementById(`ribbon-body-${idx}`);
  const currentArrow = document.getElementById(`ribbon-arrow-${idx}`);
  if (currentBody) currentBody.style.display = 'none';
  if (currentArrow) currentArrow.innerHTML = '&#9656;';

  // 2. Expand and scroll to the next ribbon or scroll to Next button
  const nextIdx = idx + 1;
  if (nextIdx < orderState.ribbons) {
    const nextBody = document.getElementById(`ribbon-body-${nextIdx}`);
    const nextArrow = document.getElementById(`ribbon-arrow-${nextIdx}`);
    if (nextBody) nextBody.style.display = 'block';
    if (nextArrow) nextArrow.innerHTML = '&#9662;';
    wizardAutoScroll('#ribbon-card-' + nextIdx);
  } else {
    wizardAutoScroll('#panel-3 .nav-row');
  }
}

function toggleRibbonBody(idx) {
  const body = document.getElementById(`ribbon-body-${idx}`);
  const arrow = document.getElementById(`ribbon-arrow-${idx}`);
  if (!body) return;
  const isHidden = (body.style.display === 'none' || window.getComputedStyle(body).display === 'none');
  if (isHidden) {
    body.style.display = 'block';
    if (arrow) arrow.innerHTML = '&#9662;';
    wizardAutoScroll('#ribbon-card-' + idx);
  } else {
    body.style.display = 'none';
    if (arrow) arrow.innerHTML = '&#9656;';
  }
}

function updateRibbonChoice(idx, val) {
  if (!orderState.ribbonChoices) orderState.ribbonChoices = [];
  orderState.ribbonChoices[idx] = val;
  const selText = document.getElementById(`ribbon-sel-text-${idx}`);
  if (selText) {
    if (val.trim()) {
      let chosenHex = '';
      if (typeof ribbonColors !== 'undefined') {
        const allColors = Object.values(ribbonColors).flat();
        const m = allColors.find(c => {
          const fl = (c.num && String(c.num).trim()) ? `${c.name} (#${c.num})` : c.name;
          return val.toLowerCase() === c.name.toLowerCase() ||
            val.toLowerCase() === fl.toLowerCase() ||
            val.toLowerCase().includes(c.name.toLowerCase()) ||
            c.name.toLowerCase().includes(val.toLowerCase());
        });
        if (m) chosenHex = m.hex;
      }
      selText.innerHTML = `
        <span class="ribbon-swatch-chip" style="background:${chosenHex || '#c9a96e'};"></span>
        <span class="ribbon-color-name">${val}</span>
      `;
    } else {
      selText.innerHTML = `<span class="ribbon-unselected-msg">Tap a swatch below to choose</span>`;
    }
  }
  const input = document.getElementById(`ribbon-input-${idx}`);
  if (input && input.value !== val) {
    input.value = val;
  }
  updateSummary();
  saveWizardStateToStorage();
}

function pickRibbon(n) {
  orderState.ribbons = n;
  const prices = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.ribbonPrices) ? window.WIZARD_CONFIG.ribbonPrices : [0, 0, 5, 10, 15, 20, 25];
  orderState.ribbonsPrice = prices[n] || 0;
  if (!orderState.ribbonChoices) orderState.ribbonChoices = [];
  if (orderState.ribbonChoices.length > n) {
    orderState.ribbonChoices = orderState.ribbonChoices.slice(0, n);
  } else {
    while (orderState.ribbonChoices.length < n) {
      orderState.ribbonChoices.push('');
    }
  }
  buildRibbonBtns();
  renderRibbonInputs();
  updatePriceBar();
  saveWizardStateToStorage();
  if (n === 0) {
    wizardAutoScroll('#panel-3 .nav-row');
  } else {
    wizardAutoScroll('#selected-ribbons-container');
  }
}

function updateOwnBibleType(val) { orderState.ownBibleType = val; updateSummary(); saveWizardStateToStorage(); }

function selectOpt(el, group) {
  const gridContainer = el.closest('.option-grid');
  if (gridContainer) { gridContainer.querySelectorAll('.opt-card').forEach(c => c.classList.remove('selected')); }
  el.classList.add('selected');
  const price = parseInt(el.dataset.price) || 0;
  const opt = el.dataset.opt;
  const nameEl = el.querySelector('.opt-card-title');
  const name = nameEl ? nameEl.innerText : opt;
  if (group === 'bible-source') {
    orderState.bibleSource = opt;
    const translationSection = document.getElementById('translation-section');
    const ownBibleSection = document.getElementById('own-bible-section');
    if (translationSection) translationSection.style.display = opt === 'source' ? 'block' : 'none';
    if (ownBibleSection) ownBibleSection.style.display = opt === 'own' ? 'block' : 'none';
    wizardAutoScroll(opt === 'source' ? translationSection : ownBibleSection);
  } else if (group === 'bible-condition') { 
    orderState.bibleCondition = name; orderState.bibleConditionPrice = price;
    wizardAutoScroll('#panel-0 .nav-row');
  } else if (group === 'translation') { 
    orderState.translation = name; orderState.translationPrice = price;
    wizardAutoScroll('#panel-0 .nav-row');
  } else if (group === 'cover-type') { 
    orderState.coverStiffness = name; orderState.coverStiffnessPrice = price;
    wizardAutoScroll('#step2-yapp-heading');
  } else if (group === 'yapp') { 
    orderState.yapp = name; orderState.yappPrice = price;
    wizardAutoScroll('#step2-tooling-heading');
  } else if (group === 'tooling') { 
    orderState.tooling = opt; orderState.toolingPrice = price;
    wizardAutoScroll('#step2-nav-row');
  } else if (group === 'hub') { 
    orderState.hubStyle = name; orderState.hubPrice = price; 
    wizardAutoScroll('#step4-stamping-color-heading');
  }
  updatePriceBar();
  saveWizardStateToStorage();
}

function updateBuffaloStockBadge() {
  const badge = document.getElementById('buffalo-stock-status');
  if (!badge) return;
  const isAvailable = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.buffaloAvailable !== undefined) ? window.WIZARD_CONFIG.buffaloAvailable : true;
  const qty = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.buffaloInventory !== undefined && window.WIZARD_CONFIG.buffaloInventory !== null)
    ? parseInt(window.WIZARD_CONFIG.buffaloInventory, 10)
    : 10;

  if (!isAvailable || qty <= 0) {
    badge.classList.add('oos');
    badge.innerHTML = '<span class="stock-pulse-dot"></span><span class="stock-status-text"><strong>Out of Stock</strong> &mdash; Sold Out</span>';
  } else {
    badge.classList.remove('oos');
    const qtyText = (qty === 1) ? '1 remaining' : (qty + ' remaining');
    badge.innerHTML = `<span class="stock-pulse-dot"></span><span class="stock-status-text">Limited Supply &mdash; Only <strong class="stock-qty-val">${qtyText}</strong> in stock</span>`;
  }
}
window.updateBuffaloStockBadge = updateBuffaloStockBadge;

function selectLeather(key) {
  const tab = document.getElementById('tab-' + key);
  if (!window._isRestoringCartWizard && tab && (tab.classList.contains('oos') || tab.getAttribute('data-oos') === 'true')) {
    return false;
  }
  document.querySelectorAll('.ltab').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.leather-panel').forEach(p => p.style.display = 'none');
  if (tab) tab.classList.add('active');
  const panel = document.getElementById('panel-' + key);
  if (panel) panel.style.display = 'block';
  const prices = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.leatherPrices) ? window.WIZARD_CONFIG.leatherPrices : { waxy: 0, buffalo: 100, minerva: 0, lochness: 50, capra: 70, levant: 60, bisanzio: 100, sauvage: 60, pullup: 40, capra3: 0, custom: 100 };
  const names = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.leatherNames) ? window.WIZARD_CONFIG.leatherNames : { waxy: 'Badalassi Waxy Cowhide', buffalo: 'Wild Cape Buffalo', minerva: 'Badalassi Minerva Cowhide', lochness: 'Badalassi Loch Ness Cowhide', capra: 'Sokoto Goatskin', levant: 'Black Patina Sauvage Goatskin', bisanzio: 'Conceria Puccini Bisanzio Rustic Metallic', sauvage: 'Alran Patina Sauvage Chevre', pullup: 'Siegel Vegetable Goat Pull Up', capra3: 'Badalassi Pueblo Cowhide', custom: 'Custom Leather' };
  orderState.leatherPrice = prices[key] !== undefined ? prices[key] : 100;
  orderState.leatherName = names[key] || 'Custom Leather';
  orderState.leather = key;
  if (key === 'custom') {
    const custInput = document.getElementById('custom-leather-text');
    orderState.color = custInput && custInput.value.trim() ? custInput.value.trim() : (orderState.customLeatherText || 'Custom Leather');
  } else if (key === 'buffalo') {
    updateBuffaloStockBadge();
    let dot = document.querySelector('#dots-buffalo .ldot.sel');
    if (!dot) {
      dot = document.querySelector('#dots-buffalo .ldot');
      if (dot && !dot.classList.contains('oos') && dot.getAttribute('data-oos') !== 'true') {
        dot.classList.add('sel');
      }
    }
    if (dot && dot.classList.contains('sel')) {
      orderState.color = 'Storm Blue';
      updateColorLabelWithChip('buffalo', 'Storm Blue', dot);
    } else {
      orderState.color = '';
      updateColorLabelWithChip('buffalo', '', null);
    }
  } else {
    const activeDot = document.querySelector(`#dots-${key} .ldot.sel`);
    if (activeDot) {
      orderState.color = activeDot.getAttribute('title') || '';
      updateColorLabelWithChip(key, orderState.color, activeDot);
    } else {
      orderState.color = '';
      updateColorLabelWithChip(key, '', null);
    }
  }
  updatePriceBar();
  saveWizardStateToStorage();
}

function updateCustomLeather(val) {
  orderState.customLeatherText = val;
  if (orderState.leather === 'custom') {
    orderState.color = val.trim() ? val.trim() : 'Custom Leather';
  }
  updateSummary();
  saveWizardStateToStorage();
}

function toggleSwitch(id) {
  orderState.toggles[id] = !orderState.toggles[id];
  const el = document.getElementById('toggle-' + id);
  if (el) { if (orderState.toggles[id]) { el.classList.add('on'); } else { el.classList.remove('on'); } }
  updatePriceBar();
}

function getSpineFontDetails(el) {
  const preview = el?.querySelector('.font-preview');
  if (!preview) return null;
  const computed = window.getComputedStyle ? window.getComputedStyle(preview) : null;
  return { name: el.querySelector('.font-name')?.textContent || orderState.stampFont, family: preview.style.fontFamily || computed?.fontFamily || orderState.stampFontFamily, style: preview.style.fontStyle || computed?.fontStyle || orderState.stampFontStyle || 'normal' };
}

function updateByrdBoundPreview() {
  const preview = document.getElementById('prev-6');
  if (!preview) return;
  const hasByrdText = orderState.spineLogo === 'text' || preview.querySelector('span')?.textContent?.includes('BYRD');
  if (!hasByrdText) return;
  const span = document.createElement('span');
  span.innerHTML = 'BYRD<br>BOUND';
  const previewFont = orderState.stampFontFamily;
  const isItalic = orderState.stampFontStyle === 'italic';
  span.style.fontFamily = previewFont;
  span.style.fontStyle = isItalic ? 'italic' : 'normal';
  span.style.fontSize = '12px';
  span.style.fontWeight = '600';
  span.style.lineHeight = '1.3';
  span.style.letterSpacing = '1px';
  preview.innerHTML = '';
  preview.appendChild(span);
}

function syncSelectedSpineFont() {
  let selCard = document.querySelector('#panel-4 .font-card.sel');
  if (!selCard) {
    selCard = document.querySelector('#panel-4 .font-card');
    if (selCard) selCard.classList.add('sel');
  }
  if (selCard) {
    const details = getSpineFontDetails(selCard);
    if (details) {
      orderState.stampFont = details.name;
      orderState.stampFontFamily = details.family;
      orderState.stampFontStyle = details.style;
    }
  }
  
  const previewFont = orderState.stampFontFamily;
  const isItalic = orderState.stampFontStyle === 'italic';
  for (let i = 1; i <= 5; i++) {
    const prevSpan = document.querySelector(`#prev-${i} span`);
    if (prevSpan) { prevSpan.style.fontFamily = previewFont; prevSpan.style.fontStyle = isItalic ? 'italic' : 'normal'; }
    const inputField = document.getElementById(`spine${i}`);
    if (inputField) { inputField.style.fontFamily = previewFont; inputField.style.fontStyle = isItalic ? 'italic' : 'normal'; }
  }

  document.querySelectorAll('.mand-card').forEach(c => c.classList.remove('sel'));
  
  let mandId = 'mand-both';
  if (orderState.spineLogo === 'text') mandId = 'mand-text';
  else if (orderState.spineLogo === 'logo') mandId = 'mand-logo';
  else if (orderState.spineLogo && orderState.spineLogo !== 'both') mandId = 'mand-custom';
  
  const mandCard = document.getElementById(mandId);
  if (mandCard) mandCard.classList.add('sel');
  updateByrdBoundPreview();
}

function setupSpineStep() {
  document.querySelectorAll('.hub-card').forEach(c => c.classList.remove('sel'));
  document.querySelectorAll('.hub-card').forEach(c => { const name = c.querySelector('.hub-name')?.textContent; if (name === orderState.hubStyle) c.classList.add('sel'); });
  document.querySelectorAll('.stamp-color').forEach(c => c.classList.remove('sel'));
  document.querySelectorAll('.stamp-color').forEach(c => { const nameEl = c.querySelector('.sc-name'); if (nameEl && nameEl.textContent === orderState.spineStampColor) c.classList.add('sel'); });
  const selColorNameEl = document.getElementById('sel-color-name');
  if (selColorNameEl) selColorNameEl.textContent = orderState.spineStampColor || 'Gold';
  syncSelectedSpineFont();
  updateByrdBoundPreview();
}

function selectHub(el, cost) {
  document.querySelectorAll('.hub-card').forEach(c => c.classList.remove('sel'));
  el.classList.add('sel');
  const hubNameEl = el.querySelector('.hub-name');
  orderState.hubStyle = hubNameEl ? hubNameEl.textContent : '';
  orderState.hubPrice = cost;
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step4-stamping-color-heading');
}

function selColor(el, colorName) {
  document.querySelectorAll('.stamp-color').forEach(c => c.classList.remove('sel'));
  el.classList.add('sel');
  orderState.spineStampColor = colorName;
  const prices = { Gold: 0, Silver: 0, Blind: 0, Black: 0, Red: 0, 'Royal Blue': 0, White: 0 };
  orderState.spineStampColorPrice = prices[colorName] || 0;
  const selColorNameEl = document.getElementById('sel-color-name');
  if (selColorNameEl) selColorNameEl.textContent = colorName;
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step4-sections-heading');
}

function updateSec(sectionNum, value) {
  syncSelectedSpineFont();
  const input = document.getElementById('spine' + sectionNum);
  if (input && input.value !== value) input.value = value;
  const preview = document.getElementById('prev-' + sectionNum);
  const row = document.getElementById('row-' + sectionNum);
  if (value.trim()) {
    let displayValue = value;
    if (sectionNum === 1) { displayValue = value.replace(/ /g, '<br>'); }
    if (preview) {
      preview.innerHTML = '<span style="color:#c9a96e;font-size:11px;font-weight:700;line-height:1.3;">' + displayValue + '</span>';
      if (orderState.stampFontFamily) { preview.querySelector('span').style.fontFamily = orderState.stampFontFamily; preview.querySelector('span').style.fontStyle = orderState.stampFontStyle || 'normal'; }
    }
    if (row) row.classList.add('used');
    orderState.spineSections[sectionNum] = value.trim();
  } else {
    if (sectionNum === 3) {
      let isLogo = false;
      function getLogoImgUrl(optId, cfgKey, fallback) {
        const cardImg = document.getElementById(optId)?.querySelector('img');
        if (cardImg && cardImg.src) return cardImg.src;
        if (window.WIZARD_CONFIG && window.WIZARD_CONFIG.logos && window.WIZARD_CONFIG.logos[cfgKey]) {
          return window.WIZARD_CONFIG.logos[cfgKey];
        }
        return fallback;
      }

      if (document.getElementById('chirho-opt')?.classList.contains('sel')) {
        var logoUrl1 = getLogoImgUrl('chirho-opt', 'step4_logo1', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/download_9.jpg?v=1777354845');
        if (preview) preview.innerHTML = '<img src="' + logoUrl1 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'Chi Rho'; if (row) row.classList.add('used');
        isLogo = true;
      } else if (document.getElementById('latincross-opt')?.classList.contains('sel')) {
        var logoUrl2 = getLogoImgUrl('latincross-opt', 'step4_logo2', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/photo_6307814585997659798_y.jpg?v=1777517634');
        if (preview) preview.innerHTML = '<img src="' + logoUrl2 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'Latin Cross'; if (row) row.classList.add('used');
        isLogo = true;
      } else if (document.getElementById('sword-opt')?.classList.contains('sel')) {
        var logoUrl3 = getLogoImgUrl('sword-opt', 'step4_logo3', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/download_19.jpg?v=1777371655');
        if (preview) preview.innerHTML = '<img src="' + logoUrl3 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'Sword'; if (row) row.classList.add('used');
        isLogo = true;
      } else if (document.getElementById('ichthys-opt')?.classList.contains('sel')) {
        var logoUrl4 = getLogoImgUrl('ichthys-opt', 'step4_logo_ichthys', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/Fish_7_8_long.jpg?v=1790773598');
        if (preview) preview.innerHTML = '<img src="' + logoUrl4 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'Ichthys (Fish)'; if (row) row.classList.add('used');
        isLogo = true;
      } else if (document.getElementById('fishbread-opt')?.classList.contains('sel')) {
        var logoUrl5 = getLogoImgUrl('fishbread-opt', 'step4_logo_bread', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/Untitled_design_19.png');
        if (preview) preview.innerHTML = '<img src="' + logoUrl5 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'Fish + Bread'; if (row) row.classList.add('used');
        isLogo = true;
      } else if (document.getElementById('ark-opt')?.classList.contains('sel')) {
        var logoUrl6 = getLogoImgUrl('ark-opt', 'step4_logo_ark', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/Ark_copy.png?v=1790774057');
        if (preview) preview.innerHTML = '<img src="' + logoUrl6 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'Ark'; if (row) row.classList.add('used');
        isLogo = true;
      } else if (document.getElementById('ega-opt')?.classList.contains('sel')) {
        var logoUrl7 = getLogoImgUrl('ega-opt', 'step4_logo_ega', 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/ega.png?v=1790773996');
        if (preview) preview.innerHTML = '<img src="' + logoUrl7 + '" style="width:48px;height:48px;max-width:48px;max-height:48px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);display:block;margin:0 auto;">';
        orderState.spineSections[3] = 'EGA'; if (row) row.classList.add('used');
        isLogo = true;
      } else {
        if (preview) preview.innerHTML = '<span style="color:#2e2418;font-size:11px;">section ' + sectionNum + '</span>';
        if (row) row.classList.remove('used'); delete orderState.spineSections[sectionNum];
        isLogo = false;
      }
      
      const prev4 = document.getElementById('prev-4');
      const hub3_4 = preview ? preview.nextElementSibling : null;
      if (isLogo) {
        if (prev4) prev4.style.display = 'none';
        if (hub3_4 && hub3_4.classList.contains('spine-hub')) hub3_4.style.display = 'none';
        if (preview) preview.style.flexGrow = '2';
      } else {
        if (prev4) prev4.style.display = '';
        if (hub3_4 && hub3_4.classList.contains('spine-hub')) hub3_4.style.display = '';
        if (preview) preview.style.flexGrow = '';
      }
    } else {
      if (preview) preview.innerHTML = '<span style="color:#2e2418;font-size:11px;">section ' + sectionNum + '</span>';
      if (row) row.classList.remove('used'); delete orderState.spineSections[sectionNum];
    }
  }
  const sectionsTotal = Object.keys(orderState.spineSections).filter(s => s !== '1' && s !== '2' && s !== '6' && orderState.spineSections[s] && (orderState.spineSections[s] === 'Chi Rho' || orderState.spineSections[s] === 'Latin Cross' || orderState.spineSections[s] === 'Sword' || orderState.spineSections[s] === 'Ichthys (Fish)' || orderState.spineSections[s] === 'Fish + Bread' || orderState.spineSections[s] === 'Ark' || orderState.spineSections[s] === 'EGA' || String(orderState.spineSections[s]).trim())).length * ((window.WIZARD_CONFIG && window.WIZARD_CONFIG.spineSecPrice !== undefined) ? window.WIZARD_CONFIG.spineSecPrice : 15);
  const secTotalEl = document.getElementById('sec-total');
  if (secTotalEl) secTotalEl.textContent = '$' + sectionsTotal;
  updatePriceBar();
  saveWizardStateToStorage();
}

function pickSec3(type) {
  const chirhoOpt = document.getElementById('chirho-opt');
  const latincrossOpt = document.getElementById('latincross-opt');
  const swordOpt = document.getElementById('sword-opt');
  const ichthysOpt = document.getElementById('ichthys-opt');
  const fishbreadOpt = document.getElementById('fishbread-opt');
  const arkOpt = document.getElementById('ark-opt');
  const egaOpt = document.getElementById('ega-opt');
  const textOpt = document.getElementById('text3-opt');
  const blankOpt = document.getElementById('blank3-opt');
  const input = document.getElementById('spine3');
  const row = document.getElementById('row-3');

  if(chirhoOpt) chirhoOpt.classList.remove('sel');
  if(latincrossOpt) latincrossOpt.classList.remove('sel');
  if(swordOpt) swordOpt.classList.remove('sel');
  if(ichthysOpt) ichthysOpt.classList.remove('sel');
  if(fishbreadOpt) fishbreadOpt.classList.remove('sel');
  if(arkOpt) arkOpt.classList.remove('sel');
  if(egaOpt) egaOpt.classList.remove('sel');
  if(textOpt) textOpt.classList.remove('sel');
  if(blankOpt) blankOpt.classList.remove('sel');

  const input4 = document.getElementById('spine4');
  const row4 = document.getElementById('row-4');
  const price4 = document.getElementById('price-4');

  const logoTypes = ['chirho', 'latincross', 'sword', 'ichthys', 'fishbread', 'ark', 'ega'];

  if (logoTypes.includes(type)) {
    if (type === 'chirho' && chirhoOpt) chirhoOpt.classList.add('sel');
    if (type === 'latincross' && latincrossOpt) latincrossOpt.classList.add('sel');
    if (type === 'sword' && swordOpt) swordOpt.classList.add('sel');
    if (type === 'ichthys' && ichthysOpt) ichthysOpt.classList.add('sel');
    if (type === 'fishbread' && fishbreadOpt) fishbreadOpt.classList.add('sel');
    if (type === 'ark' && arkOpt) arkOpt.classList.add('sel');
    if (type === 'ega' && egaOpt) egaOpt.classList.add('sel');

    if (input) { input.disabled = true; input.style.opacity = '0.4'; input.value = ''; }
    updateSec(3, '');
    
    // Disable Section 4
    if (input4) {
      input4.disabled = true;
      input4.style.opacity = '0.4';
      input4.value = '';
      input4.placeholder = 'Replaced by Section 3 Logo';
    }
    if (row4) {
      row4.style.opacity = '0.5';
      row4.style.pointerEvents = 'none';
      if (price4) {
        price4.textContent = 'Included';
        price4.style.color = '#706050';
      }
    }
    updateSec(4, '');
  } else if (type === 'text') {
    if (textOpt) textOpt.classList.add('sel');
    if (input) { input.disabled = false; input.style.opacity = '1'; try { input.focus(); } catch(e){} updateSec(3, input.value); }
    else { updateSec(3, ''); }
    
    // Enable Section 4
    if (input4) {
      input4.disabled = false;
      input4.style.opacity = '1';
      input4.placeholder = 'e.g. your name, a scripture...';
    }
    if (row4) {
      row4.style.opacity = '1';
      row4.style.pointerEvents = 'auto';
      if (typeof updateSpineSectionPrices === 'function') updateSpineSectionPrices();
    }
  } else {
    if (blankOpt) blankOpt.classList.add('sel');
    if (input) { input.disabled = true; input.style.opacity = '0.4'; input.value = ''; }
    updateSec(3, '');
    
    // Enable Section 4
    if (input4) {
      input4.disabled = false;
      input4.style.opacity = '1';
      input4.placeholder = 'e.g. your name, a scripture...';
    }
    if (row4) {
      row4.style.opacity = '1';
      row4.style.pointerEvents = 'auto';
      if (typeof updateSpineSectionPrices === 'function') updateSpineSectionPrices();
    }
  }
  saveWizardStateToStorage();
}

function selMand(el, type) {
  document.querySelectorAll('.mand-card').forEach(c => c.classList.remove('sel'));
  el.classList.add('sel');
  
  if (type === 'custom') {
    const customLabel = el.querySelector('.mand-label');
    orderState.spineLogo = customLabel ? customLabel.innerText : 'Cursive Logo';
  } else {
    orderState.spineLogo = type;
  }
  
  const preview = document.getElementById('prev-6');
  if (preview) {
  if (type === 'logo') {
    var mandLogoUrl = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.logos && window.WIZARD_CONFIG.logos.step4_mand_logo) ? window.WIZARD_CONFIG.logos.step4_mand_logo : 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/photo_6312264266605596872_y_af07d7fa-5069-4d00-abdb-f1244a6dbf59.jpg?v=1777874192';
    preview.innerHTML = '<img src="' + mandLogoUrl + '" style="width:100%;max-width:40px;height:auto;max-height:40px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);">';
  }
  else if (type === 'both') {
    var mandBothUrl = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.logos && window.WIZARD_CONFIG.logos.step4_mand_both) ? window.WIZARD_CONFIG.logos.step4_mand_both : 'https://cdn.shopify.com/s/files/1/0717/6116/6473/files/photo_6312264266605596871_y_c032de9c-221a-4a52-ac4a-878b395f02b2.jpg?v=1777874193';
    preview.innerHTML = '<img src="' + mandBothUrl + '" style="width:100%;max-width:40px;height:auto;max-height:40px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);">';
  }
  else if (type === 'custom') {
    var logo4Url = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.logos && window.WIZARD_CONFIG.logos.step4_logo4) ? window.WIZARD_CONFIG.logos.step4_logo4 : "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'><rect width='48' height='48' fill='none'/></svg>";
    preview.innerHTML = '<img src="' + logo4Url + '" style="width:100%;max-width:40px;height:auto;max-height:40px;object-fit:contain;filter: invert(0.7) sepia(0.5) saturate(2) hue-rotate(5deg);">';
  }
    else { updateByrdBoundPreview(); }
  }
  saveWizardStateToStorage();
  wizardAutoScroll('#step4-font-heading, #step4-nav-row');
}

function selFont(el) {
  document.querySelectorAll('#panel-4 .font-card').forEach(c => c.classList.remove('sel'));
  el.classList.add('sel');
  syncSelectedSpineFont();
  saveWizardStateToStorage();
  wizardAutoScroll('#step4-nav-row');
}

function selectCoverStamp(el, type, cost) {
  document.querySelectorAll('.stamp-card, .stamp-custom-card').forEach(c => c.classList.remove('selected'));
  el.classList.add('selected');
  orderState.coverStampType = type;
  if (type === 'text') {
    const textInput = document.getElementById('cover-stamp-text-input');
    const val = textInput ? textInput.value : (orderState.coverStampText || '');
    orderState.coverStampCost = val.length * 1;
    const charCountEl = document.getElementById('cover-stamp-char-count');
    if (charCountEl) {
      charCountEl.textContent = val.length + ' character' + (val.length === 1 ? '' : 's') + ' (+$' + val.length + '.00)';
    }
  } else {
    orderState.coverStampCost = cost;
  }
  const brassNote = document.getElementById('brass-note');
  if (brassNote) brassNote.style.display = type === 'custom' ? 'block' : 'none';
  const textWrap = document.getElementById('cover-stamp-text-wrap');
  if (textWrap) textWrap.style.display = type === 'text' ? 'block' : 'none';
  updatePriceBar();
  saveWizardStateToStorage();
  if (type === 'none') {
    wizardAutoScroll('#step5-inscription-heading');
  } else if (type === 'text') {
    wizardAutoScroll('#cover-stamp-text-wrap');
  } else {
    wizardAutoScroll('#step5-placement-label, #placement-label');
  }
}

function selectPlacement(el, placement) {
  document.querySelectorAll('.place-card').forEach(c => c.classList.remove('selected'));
  el.classList.add('selected');
  orderState.coverStampPlacement = placement;
  const placementOther = document.getElementById('placement-other-input');
  if (placementOther) placementOther.style.display = placement === 'other' ? 'block' : 'none';
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step5-stamp-color-heading, #cover-stamp-color-row');
}

function selectCoverStampColor(el, color, cost) {
  document.querySelectorAll('.stamp-color-card').forEach(c => c.classList.remove('selected'));
  el.classList.add('selected');
  orderState.coverStampColor = color;
  orderState.coverStampColorCost = cost;
  const selCoverStampColor = document.getElementById('selected-cover-stamp-color');
  if (selCoverStampColor) selCoverStampColor.textContent = color;
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step5-inscription-heading');
}

function updateCoverStampText(val) {
  orderState.coverStampText = val;
  if (orderState.coverStampType === 'text') {
    orderState.coverStampCost = val.length * 1;
    const charCountEl = document.getElementById('cover-stamp-char-count');
    if (charCountEl) {
      charCountEl.textContent = val.length + ' character' + (val.length === 1 ? '' : 's') + ' (+$' + val.length + '.00)';
    }
  }
  updatePriceBar();
  updateSummary();
  saveWizardStateToStorage();
}

function renderInscriptionInputs(loc, unitCost) {
  const cost = unitCost !== undefined ? unitCost : (window.WIZARD_CONFIG && window.WIZARD_CONFIG.inscriptionPrice !== undefined ? window.WIZARD_CONFIG.inscriptionPrice : 15);
  const container = document.getElementById('extra-insc-' + loc + '-container');
  const mainInput = document.getElementById('inscription-text-' + loc);
  if (!Array.isArray(orderState.inscriptionTexts[loc])) {
    orderState.inscriptionTexts[loc] = [orderState.inscriptionTexts[loc] || ''];
  }
  const arr = orderState.inscriptionTexts[loc];
  if (mainInput) {
    mainInput.value = arr[0] || '';
  }
  if (!container) return;
  container.innerHTML = '';
  for (let i = 1; i < arr.length; i++) {
    const row = document.createElement('div');
    row.className = 'extra-insc-row';
    row.style.cssText = 'display:flex; align-items:center; gap:8px; margin-bottom:8px;';
    
    const input = document.createElement('input');
    input.className = 'spine-input inscription-input-field';
    input.type = 'text';
    input.maxLength = 30;
    input.placeholder = 'Name ' + (i + 1) + ' — e.g. Jane Smith';
    input.value = arr[i] || '';
    input.style.flex = '1';
    const currIdx = i;
    input.oninput = function() {
      updateInscriptionText(loc, currIdx, this.value);
    };
    
    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-insc-name-btn';
    removeBtn.innerHTML = '✕';
    removeBtn.title = 'Remove this name';
    removeBtn.style.cssText = 'background:#2a1410; border:1px solid #7a2018; color:#f08070; width:34px; height:38px; border-radius:4px; cursor:pointer; font-size:14px; font-weight:bold; display:flex; align-items:center; justify-content:center; transition:all 0.2s; flex-shrink:0;';
    removeBtn.onclick = function() {
      removeExtraInscriptionName(loc, currIdx, cost);
    };
    
    row.appendChild(input);
    row.appendChild(removeBtn);
    container.appendChild(row);
  }
}

function recalcInscriptionCost(unitCost) {
  const cost = unitCost !== undefined ? unitCost : (window.WIZARD_CONFIG && window.WIZARD_CONFIG.inscriptionPrice !== undefined ? window.WIZARD_CONFIG.inscriptionPrice : 15);
  let totalNames = 0;
  for (let loc in orderState.inscriptions) {
    if (orderState.inscriptions[loc]) {
      const arr = Array.isArray(orderState.inscriptionTexts[loc]) ? orderState.inscriptionTexts[loc] : [orderState.inscriptionTexts[loc]];
      totalNames += Math.max(1, arr.length);
    }
  }
  orderState.inscriptionCost = totalNames * cost;
  updatePriceBar();
  updateSummary();
}

function addExtraInscriptionName(loc, cost) {
  if (!orderState.inscriptions[loc]) return;
  if (!Array.isArray(orderState.inscriptionTexts[loc])) {
    orderState.inscriptionTexts[loc] = [orderState.inscriptionTexts[loc] || ''];
  }
  orderState.inscriptionTexts[loc].push('');
  renderInscriptionInputs(loc, cost);
  recalcInscriptionCost(cost);
  saveWizardStateToStorage();
  setTimeout(() => {
    const container = document.getElementById('extra-insc-' + loc + '-container');
    const inputs = container ? container.querySelectorAll('input') : [];
    if (inputs.length) inputs[inputs.length - 1].focus();
  }, 50);
}

function removeExtraInscriptionName(loc, idx, cost) {
  if (!Array.isArray(orderState.inscriptionTexts[loc])) return;
  orderState.inscriptionTexts[loc].splice(idx, 1);
  if (orderState.inscriptionTexts[loc].length === 0) {
    orderState.inscriptionTexts[loc] = [''];
  }
  renderInscriptionInputs(loc, cost);
  recalcInscriptionCost(cost);
  saveWizardStateToStorage();
}

function toggleInscription(el, location, cost) {
  const noInscCard = document.querySelector('.insc-card[data-inscription="none"]');
  if (location === 'none') {
    orderState.inscriptions.front = false;
    orderState.inscriptions.liner = false;
    orderState.inscriptions.back = false;
    orderState.inscriptionTexts = { front: [''], liner: [''], back: [''] };
    document.querySelectorAll('.insc-card').forEach(c => c.classList.remove('selected'));
    el.classList.add('selected');
  } else {
    orderState.inscriptions[location] = !orderState.inscriptions[location];
    if (noInscCard) noInscCard.classList.remove('selected');
    
    if (orderState.inscriptions[location]) {
      el.classList.add('selected');
      if (!Array.isArray(orderState.inscriptionTexts[location]) || orderState.inscriptionTexts[location].length === 0) {
        orderState.inscriptionTexts[location] = [''];
      }
    } else {
      el.classList.remove('selected');
      orderState.inscriptionTexts[location] = [''];
    }
    
    if (!orderState.inscriptions.front && !orderState.inscriptions.liner && !orderState.inscriptions.back) {
      if (noInscCard) noInscCard.classList.add('selected');
    }
  }
  
  let activeLocs = 0;
  for (let l in orderState.inscriptions) {
    if (orderState.inscriptions[l]) activeLocs++;
  }
  
  const inputWrap = document.getElementById('inscription-input-wrap');
  if (activeLocs > 0) {
    if (inputWrap) inputWrap.style.display = 'block';
    const wrapFront = document.getElementById('insc-front-input-wrap');
    if (wrapFront) {
      wrapFront.style.display = orderState.inscriptions.front ? 'block' : 'none';
      if (orderState.inscriptions.front) renderInscriptionInputs('front', cost);
    }
    const wrapLiner = document.getElementById('insc-liner-input-wrap');
    if (wrapLiner) {
      wrapLiner.style.display = orderState.inscriptions.liner ? 'block' : 'none';
      if (orderState.inscriptions.liner) renderInscriptionInputs('liner', cost);
    }
    const wrapBack = document.getElementById('insc-back-input-wrap');
    if (wrapBack) {
      wrapBack.style.display = orderState.inscriptions.back ? 'block' : 'none';
      if (orderState.inscriptions.back) renderInscriptionInputs('back', cost);
    }
    wizardAutoScroll('#inscription-input-wrap');
  } else {
    if (inputWrap) inputWrap.style.display = 'none';
    wizardAutoScroll('#step5-nav-row');
  }
  
  recalcInscriptionCost(cost);
  saveWizardStateToStorage();
}

function updateInscriptionText(loc, idx, val) {
  if (typeof idx === 'string') {
    val = idx;
    idx = 0;
  }
  if (!Array.isArray(orderState.inscriptionTexts[loc])) {
    orderState.inscriptionTexts[loc] = [orderState.inscriptionTexts[loc] || ''];
  }
  orderState.inscriptionTexts[loc][idx] = val;
  updateSummary();
  saveWizardStateToStorage();
}

function selectInscriptionFont(el, font) {
  document.querySelectorAll('#inscription-input-wrap .font-card').forEach(c => c.classList.remove('selected'));
  el.classList.add('selected');
  orderState.inscriptionFont = font;
  updateSummary();
  saveWizardStateToStorage();
  wizardAutoScroll('#step5-nav-row');
}

function addToCartAndGoCart() {
  const form = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.sectionId ? document.querySelector('.hero-' + window.WIZARD_CONFIG.sectionId + ' form') : null) || document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
  if (!form) { alert('Error: Form not found. Please refresh and try again.'); return; }
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput || !idInput.value) { alert('Error: No product variant found.'); return; }
  const btn = form.querySelector('button.btn-primary');
  if (btn) { btn.classList.add('m-spinner-button--loading'); btn.disabled = true; }
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(idInput.value), quantity: 1 }) })
    .then(res => { if (res.ok) { window.location.href = '/cart'; } else { throw new Error('Failed to add to cart'); } })
    .catch(err => { console.error('Add to cart error:', err); showWizardAlert('Error adding to cart. Please try again.'); if (btn) { btn.classList.remove('m-spinner-button--loading'); btn.disabled = false; } });
}

function showWizardAlert(msg) {
  let alertBox = document.getElementById('wizard-alert-box');
  if (!alertBox) {
    alertBox = document.createElement('div');
    alertBox.id = 'wizard-alert-box';
    alertBox.style.cssText = 'position:fixed;top:30px;left:50%;transform:translate(-50%,-50px);background:#1e1a10;border:1px solid #c9a96e;color:#e8e0d0;padding:16px 24px;border-radius:6px;box-shadow:0 12px 35px rgba(0,0,0,0.6);z-index:9999999;font-family:var(--sans);font-size:15px;display:flex;align-items:center;gap:12px;opacity:0;transition:all 0.4s cubic-bezier(0.175,0.885,0.32,1.275);';
    document.body.appendChild(alertBox);
  }
  alertBox.innerHTML = '<div style="color:#c9a96e;font-weight:bold;font-size:22px;line-height:1;">!</div><div>' + msg + '</div>';
  alertBox.style.display = 'flex';
  void alertBox.offsetWidth;
  alertBox.style.opacity = '1';
  alertBox.style.transform = 'translate(-50%, 0)';
  setTimeout(() => { alertBox.style.opacity = '0'; alertBox.style.transform = 'translate(-50%, -50px)'; setTimeout(() => { alertBox.style.display = 'none'; }, 400); }, 4000);
}

function buildCurrentOrderProperties() {
  let properties = {};
  properties['_item_type'] = 'custom_rebind';
  properties['Order Type'] = 'Custom Bible Rebind';
  if (orderState.bibleSource === 'own') {
    properties['Bible Source'] = `Sending my own (${orderState.ownBibleType || 'Not specified'})`;
    if (orderState.bibleCondition) {
      properties['Bible Condition'] = orderState.bibleCondition;
    }
  } else if (orderState.translation) {
    properties['Bible Source'] = `Sourced: ${orderState.translation}`;
  } else if (window.WIZARD_EDIT_MODE?.originalProps?.['Bible Source']) {
    properties['Bible Source'] = window.WIZARD_EDIT_MODE.originalProps['Bible Source'];
  } else {
    properties['Bible Source'] = 'Sourced: ESV';
  }

  if (orderState.leather === 'custom') {
    properties['Leather'] = 'Custom Leather';
    properties['Color'] = orderState.customLeatherText || orderState.color || 'Custom';
  } else {
    properties['Leather'] = orderState.leatherName || 'Badalassi Waxy Cowhide';
    properties['Color'] = orderState.color || 'Bone';
  }

  properties['Cover'] = `${orderState.coverStiffness || 'Floppy'} · ${orderState.yapp || 'Standard 3/8"'}`;
  properties['Liner'] = `${orderState.liner || 'Kelly Green'} lambskin`;
  properties['Ribbons'] = (orderState.ribbons !== undefined ? orderState.ribbons : 0).toString();
  if (orderState.ribbons > 0) {
    let ribbonText = '';
    if (orderState.ribbonChoices && orderState.ribbonChoices.length > 0) {
      ribbonText = orderState.ribbonChoices.map((c, i) => `Ribbon ${i + 1}: ${c.trim()}`).join(' | ');
    }
    properties['Ribbon Color'] = ribbonText || 'Not specified';
  }
  properties['Hub Style'] = orderState.hubStyle || 'Raised Hubs';
  properties['Spine Stamping Color'] = orderState.spineStampColor || 'Gold';
  properties['Stamping Font'] = orderState.stampFont || 'Goudy Light';
  for (let i = 1; i <= 5; i++) {
    const input = document.getElementById(`spine${i}`);
    if (input) {
      if (input.value.trim()) {
        properties[`Spine Section ${i}`] = input.value.trim();
      } else if (i === 3) {
        if (document.getElementById('chirho-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'Chi Rho';
        } else if (document.getElementById('latincross-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'Latin Cross';
        } else if (document.getElementById('sword-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'Sword';
        } else if (document.getElementById('ichthys-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'Ichthys (Fish)';
        } else if (document.getElementById('fishbread-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'Fish + Bread';
        } else if (document.getElementById('ark-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'Ark';
        } else if (document.getElementById('ega-opt')?.classList.contains('sel')) {
          properties[`Spine Section 3`] = 'EGA';
        }
      }
    }
  }
  properties['Spine Logo Type'] = orderState.spineLogo || 'both';
  properties['Cover Stamp Type'] = orderState.coverStampType || 'none';
  if (orderState.coverStampType && orderState.coverStampType !== 'none') {
    properties['Cover Stamp Placement'] = orderState.coverStampPlacement || 'front-center';
    properties['Cover Stamp Color'] = orderState.coverStampColor || 'Gold';
    if (orderState.coverStampType === 'text') {
      properties['Cover Stamp Text'] = orderState.coverStampText;
    }
  }
  let hasInscription = false;
  const inscLocations = { front: 'Front Cover Bottom Right', liner: 'Front Liner Bottom Middle', back: 'Back Cover Bottom Left' };
  for (let loc in orderState.inscriptions) {
    if (orderState.inscriptions[loc]) {
      hasInscription = true;
      const arr = Array.isArray(orderState.inscriptionTexts[loc])
        ? orderState.inscriptionTexts[loc].filter(t => t && t.trim())
        : (orderState.inscriptionTexts[loc] && orderState.inscriptionTexts[loc].trim() ? [orderState.inscriptionTexts[loc].trim()] : []);
      if (arr.length === 1) {
        properties[`Inscription Location (${inscLocations[loc]})`] = arr[0];
      } else if (arr.length > 1) {
        for (let i = 0; i < arr.length; i++) {
          properties[`Inscription Location (${inscLocations[loc]} - Name ${i + 1})`] = arr[i];
        }
        properties[`Inscription (${inscLocations[loc]})`] = arr.join(', ');
      } else {
        properties[`Inscription Location (${inscLocations[loc]})`] = 'Not specified';
      }
    }
  }
  if (hasInscription) {
    properties['Inscription Font'] = orderState.inscriptionFont || 'Goudy Light';
  }
  let extras = [];
  if (orderState.toggles.stitch) extras.push('Hand stitching: ' + (orderState.stitchColor || 'Not specified'));
  if (orderState.tooling && orderState.tooling !== 'no-tooling') extras.push('Edge tooling (' + orderState.tooling.replace('-tooling', '') + ')');
  if (orderState.toggles.gilt1) extras.push('Single gilt lines: ' + orderState.gilt1Color);
  if (orderState.toggles.gilt2) extras.push('Double gilt lines: ' + orderState.gilt2Color);
  if (orderState.toggles.dye) { let dyeStr = 'Page edge dyeing: ' + (orderState.dyeColor || 'Not specified'); if (orderState.dyeSandoff) dyeStr += ' (Sand off existing gilt)'; extras.push(dyeStr); }
  if (orderState.toggles.speckle) { let spColors = [orderState.speckle1, orderState.speckle2, orderState.speckle3].filter(Boolean).join(', '); extras.push('Speckled art edges: ' + spColors); }
  if (extras.length) properties['Extras'] = extras.join(' | ');
  const notes = document.getElementById('notes');
  if (notes && notes.value.trim()) {
    properties['Notes'] = notes.value.trim();
  } else if (window.WIZARD_EDIT_MODE?.originalProps?.['Notes']) {
    properties['Notes'] = window.WIZARD_EDIT_MODE.originalProps['Notes'];
  }

  const total = calcTotal();
  const deposit = 200;
  properties['_unit_expected'] = total.toString();
  properties['_unit_due'] = Math.max(0, total - deposit).toString();
  properties['Total Expected Price'] = '$' + total;
  const due = Math.max(0, total - deposit);
  properties['Due Later'] = '$' + due;
  properties['Deposit Paid Today'] = '$' + deposit;

  return properties;
}

function saveCartItemFromWizard(triggerBtn) {
  if (!window.WIZARD_EDIT_MODE || !window.WIZARD_EDIT_MODE.isEditing || !window.WIZARD_EDIT_MODE.lineIndex) {
    submitOrder();
    return;
  }

  const allSaveButtons = document.querySelectorAll('.wiz-cart-quick-save-btn, .btn-step-quick-save, .btn-sticky-save, #submit-btn-new');
  allSaveButtons.forEach(b => {
    b.disabled = true;
    b.setAttribute('data-original-html', b.innerHTML);
    b.innerHTML = '<span class="wiz-save-spinner"></span> Saving...';
  });

  const properties = buildCurrentOrderProperties();
  const lineIdx = parseInt(window.WIZARD_EDIT_MODE.lineIndex, 10);
  const lineItemEl = document.querySelector(`[data-line-index="${lineIdx}"]`) || document.getElementById(`MinimogCart-Item-${lineIdx}`);
  const currentItemQty = lineItemEl ? (parseInt(lineItemEl.querySelector('input[name="updates[]"]')?.value || '1', 10) || 1) : (window.WIZARD_EDIT_MODE.originalQty || 1);
  if (currentItemQty > 1) {
    const unitExp = parseFloat(properties['_unit_expected']) || calcTotal();
    const unitDue = parseFloat(properties['_unit_due']) || Math.max(0, unitExp - 200);
    properties['Total Expected Price'] = '$' + Math.round(unitExp * currentItemQty);
    properties['Due Later'] = '$' + Math.round(unitDue * currentItemQty);
    properties['Deposit Paid Today'] = '$' + Math.round(200 * currentItemQty);
  }
  const originalProps = window.WIZARD_EDIT_MODE.originalProps || {};
  for (let origKey in originalProps) {
    if (origKey.startsWith('_') || origKey === 'optionSetId') {
      if (!properties.hasOwnProperty(origKey)) {
        properties[origKey] = originalProps[origKey];
      }
    } else if (!properties.hasOwnProperty(origKey)) {
      properties[origKey] = '';
    }
  }

  if (originalProps['Custom Logo File'] && !properties['Custom Logo File']) {
    properties['Custom Logo File'] = originalProps['Custom Logo File'];
  }

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/');
  fetch(rootUrl + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: parseInt(window.WIZARD_EDIT_MODE.lineIndex, 10),
      properties: properties
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Failed to update cart item');

    const isNowBuffalo = orderState.leather === 'buffalo';
    const buffaloVariantId = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.buffaloVariantId) ? window.WIZARD_CONFIG.buffaloVariantId : null;

    return fetch(rootUrl + 'cart.js')
      .then(r => r.json())
      .then(cartData => {
        const items = cartData.items || [];
        const buffaloItem = items.find(it => {
          const h = (it.handle || '').toLowerCase();
          const t = (it.product_title || it.title || '').toLowerCase();
          const pType = it.properties && it.properties['_item_type'];
          return h === 'wild-cape-buffalo' || t.includes('wild cape buffalo') || pType === 'leather_add_on';
        });

        const rebindItem = items.find(it => {
          const h = (it.handle || '').toLowerCase();
          const t = (it.product_title || it.title || '').toLowerCase();
          const pType = it.properties && it.properties['_item_type'];
          return h === 'custom-bible-rebind' || t.includes('custom bible') || pType === 'custom_rebind';
        });
        const rebindQty = rebindItem ? rebindItem.quantity : 1;

        if (!isNowBuffalo && buffaloItem) {
          // Leather changed from Buffalo to something else -> REMOVE Wild Cape Buffalo!
          return fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: buffaloItem.key, quantity: 0 })
          });
        } else if (isNowBuffalo && !buffaloItem && buffaloVariantId) {
          // Leather changed to Buffalo -> ADD Wild Cape Buffalo!
          const buffaloPriceProp = `$${rebindQty * 100} included with Custom Bible Rebind`;
          return fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: buffaloVariantId,
              quantity: rebindQty,
              properties: {
                '_item_type': 'leather_add_on',
                '_parent_rebind': 'Custom Bible Rebind',
                'Price': buffaloPriceProp,
                'Color': 'Storm Blue'
              }
            })
          });
        } else if (isNowBuffalo && buffaloItem) {
          // Sync Buffalo quantity and property to Rebind quantity
          const buffaloPriceProp = `$${rebindQty * 100} included with Custom Bible Rebind`;
          return fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: buffaloItem.key,
              quantity: rebindQty,
              properties: Object.assign({}, buffaloItem.properties || {}, {
                '_item_type': 'leather_add_on',
                '_parent_rebind': 'Custom Bible Rebind',
                'Price': buffaloPriceProp,
                'Color': buffaloItem.properties?.['Color'] || 'Storm Blue'
              })
            })
          });
        }
      });
  })
  .then(() => {
    allSaveButtons.forEach(b => {
      b.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:6px;"><polyline points="20 6 9 17 4 12"></polyline></svg> Saved to Cart!';
      b.style.background = '#27ae60';
      b.style.borderColor = '#27ae60';
      b.style.color = '#ffffff';
    });
    setTimeout(() => {
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      } else {
        window.location.href = '/cart';
      }
    }, 350);
  })
  .catch(err => {
    console.error('Cart edit quick save error:', err);
    alert('Error saving your changes to the cart. Please try again.');
    allSaveButtons.forEach(b => {
      b.disabled = false;
      const orig = b.getAttribute('data-original-html');
      if (orig) b.innerHTML = orig;
    });
  });
}

function updateWizardEditModeUI() {
  const isEditing = !!(window.WIZARD_EDIT_MODE && window.WIZARD_EDIT_MODE.isEditing);
  const lineIndex = isEditing ? (window.WIZARD_EDIT_MODE.lineIndex || 1) : 1;
  
  // 1. Header Banner
  const headerBanner = document.getElementById('wiz-cart-product-header');
  if (headerBanner) {
    if (isEditing) {
      headerBanner.style.display = 'flex';
      const lineTag = headerBanner.querySelector('#wiz-cart-prod-line');
      if (lineTag) lineTag.textContent = `Cart Item #${lineIndex}`;
      const rightWrap = headerBanner.querySelector('.wiz-cart-prod-right');
      if (rightWrap && !rightWrap.querySelector('.wiz-cart-quick-save-btn')) {
        const saveBtn = document.createElement('button');
        saveBtn.type = 'button';
        saveBtn.className = 'wiz-cart-quick-save-btn';
        saveBtn.innerHTML = `
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:5px;flex-shrink:0;">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
            <polyline points="17 21 17 13 7 13 7 21"></polyline>
            <polyline points="7 3 7 8 15 8"></polyline>
          </svg>
          Save Changes
        `;
        saveBtn.onclick = function() { saveCartItemFromWizard(this); };
        const jumpBtn = rightWrap.querySelector('.wiz-cart-review-jump-btn');
        if (jumpBtn) {
          rightWrap.insertBefore(saveBtn, jumpBtn);
        } else {
          rightWrap.appendChild(saveBtn);
        }
      }
    } else {
      headerBanner.style.display = 'none';
    }
  }

  // 2. Sticky Floating Bottom Bar (show on Steps 0-6 in edit mode; hide on Step 7)
  let stickyBar = document.getElementById('wiz-edit-sticky-bar');
  if (isEditing && currentStep < 7) {
    if (!stickyBar) {
      stickyBar = document.createElement('div');
      stickyBar.id = 'wiz-edit-sticky-bar';
      stickyBar.className = 'wiz-edit-sticky-bar';
      stickyBar.innerHTML = `
        <div class="wiz-sticky-left">
          <span class="wiz-sticky-dot"></span>
          <div class="wiz-sticky-text-wrap">
            <span class="wiz-sticky-title" id="wiz-sticky-title">Editing Cart Item #${lineIndex}</span>
            <span class="wiz-sticky-sub">Save changes directly without reviewing all steps</span>
          </div>
        </div>
        <div class="wiz-sticky-right">
          <button type="button" class="btn-sticky-save" onclick="saveCartItemFromWizard(this)">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:6px;flex-shrink:0;">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
            Save Changes to Cart
          </button>
          <button type="button" class="btn-sticky-review" onclick="goToStep(7)">
            Review All &rarr;
          </button>
        </div>
      `;
      const wizContent = document.querySelector('.wizard-modal-content .wiz') || document.querySelector('.wiz');
      if (wizContent) {
        wizContent.appendChild(stickyBar);
      }
    }
    if (stickyBar) {
      const titleEl = stickyBar.querySelector('#wiz-sticky-title');
      if (titleEl) titleEl.textContent = `Editing Cart Item #${lineIndex}`;
      stickyBar.style.display = 'flex';
    }
  } else {
    if (stickyBar) {
      stickyBar.style.display = 'none';
    }
  }

  // 3. Step Panels Navigation Row Buttons
  document.querySelectorAll('.step-panel').forEach((panel, pIdx) => {
    if (pIdx >= 7) return; // Step 7 has its own submit button
    const navRow = panel.querySelector('.nav-row');
    if (navRow) {
      let stepSaveBtn = navRow.querySelector('.btn-step-quick-save');
      if (isEditing) {
        navRow.classList.add('is-editing');
        if (!stepSaveBtn) {
          stepSaveBtn = document.createElement('button');
          stepSaveBtn.type = 'button';
          stepSaveBtn.className = 'btn-step-quick-save';
          stepSaveBtn.innerHTML = `
            <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:6px;flex-shrink:0;">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
            Save Changes to Cart
          `;
          stepSaveBtn.onclick = function() { saveCartItemFromWizard(this); };
          const nextBtn = navRow.querySelector('.btn-next');
          if (nextBtn) {
            navRow.insertBefore(stepSaveBtn, nextBtn);
          } else {
            navRow.appendChild(stepSaveBtn);
          }
        }
        stepSaveBtn.style.display = 'inline-flex';
      } else {
        navRow.classList.remove('is-editing');
        if (stepSaveBtn) {
          stepSaveBtn.style.display = 'none';
        }
      }
    }
  });

  // 4. Update Step 7 submit button text if editing
  const submitBtn = document.getElementById('submit-btn-new') || document.querySelector('.submit-btn-new');
  if (submitBtn) {
    if (isEditing) {
      submitBtn.textContent = 'UPDATE CUSTOMIZATION IN CART →';
    } else {
      submitBtn.textContent = 'SUBMIT MY ORDER →';
    }
  }
}

function submitOrder() {
  if (typeof clearWizardStateFromStorage === 'function') {
    clearWizardStateFromStorage();
  }
  const submitBtn = document.getElementById('submit-btn-new') || document.querySelector('.submit-btn-new') || document.querySelector('.submit-btn');
  if (submitBtn) { submitBtn.textContent = 'Processing...'; submitBtn.disabled = true; submitBtn.style.opacity = '0.7'; }
  
  const properties = buildCurrentOrderProperties();

  if (window.WIZARD_EDIT_MODE && window.WIZARD_EDIT_MODE.isEditing && window.WIZARD_EDIT_MODE.lineIndex) {
    saveCartItemFromWizard(submitBtn);
    return;
  }

  const form = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.sectionId ? document.querySelector('#shopify-section-' + window.WIZARD_CONFIG.sectionId + ' form[data-type="add-to-cart-form"]') : null) || document.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  const variantId = idInput ? idInput.value : ((window.WIZARD_CONFIG && window.WIZARD_CONFIG.variantId) ? window.WIZARD_CONFIG.variantId : '');
  if (!variantId) { alert("Error: No product variant found. Please ensure a product is selected in settings."); if (submitBtn) { submitBtn.textContent = 'Submit My Order'; submitBtn.disabled = false; submitBtn.style.opacity = '1'; } return; }
  let formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  for (let key in properties) {
    formData.append(`properties[${key}]`, properties[key]);
  }

  if (orderState.coverStampType === 'custom') {
    const fileInput = document.getElementById('custom-logo-upload');
    if (fileInput && fileInput.files.length) {
      formData.append('properties[Custom Logo File]', fileInput.files[0]);
    }
  }

  const buffaloVariantId = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.buffaloVariantId) ? window.WIZARD_CONFIG.buffaloVariantId : null;

  // Add Wild Cape Buffalo add-on FIRST so that Custom Bible Rebind (added SECOND) renders at the TOP of Checkout (Shopify LIFO line item order)
  const addBuffaloFirst = (orderState.leather === 'buffalo' && buffaloVariantId)
    ? fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: buffaloVariantId,
          quantity: 1,
          properties: {
            '_item_type': 'leather_add_on',
            '_parent_rebind': 'Custom Bible Rebind',
            'Price': '$100 included with Custom Bible Rebind',
            'Color': 'Storm Blue'
          }
        })
      }).then(bRes => {
        if (!bRes.ok) console.warn('Could not bundle buffalo product:', bRes);
        return true;
      }).catch(err => {
        console.warn('Buffalo item add error:', err);
        return true;
      })
    : Promise.resolve(true);

  addBuffaloFirst
    .then(() => fetch('/cart/add.js', { method: 'POST', body: formData }))
    .then((res) => {
      if (!res.ok) throw new Error('Failed to add main product');
      window.location.href = '/checkout';
    })
    .catch(err => {
      console.error('Submit order error:', err);
      alert('Error adding to cart. Please try again.');
      if (submitBtn) {
        submitBtn.textContent = 'SUBMIT MY ORDER →';
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
      }
    });
}

document.addEventListener('DOMContentLoaded', function() {
  for (let i = 1; i <= 5; i++) {
    const input = document.getElementById(`spine${i}`);
    if (input) { input.addEventListener('input', function() { updateSec(i, this.value); }); }
  }
});

function toggleExtraOpt(id, cost, e) {
  if(e && e.target.closest('.opt-body')) return;
  const row = document.getElementById('row-' + id);
  const active = row.classList.toggle('active');
  const toggleKeyMap = { 'single': 'gilt1', 'double': 'gilt2', 'dye': 'dye', 'speckle': 'speckle', 'stitch': 'stitch' };
  const toggleKey = toggleKeyMap[id];
  if(active){
    orderState.toggles[toggleKey] = true;
    if(id === 'single' && orderState.toggles['gilt2']) { orderState.toggles['gilt2'] = false; const rd = document.getElementById('row-double'); if (rd) rd.classList.remove('active'); }
    if(id === 'double' && orderState.toggles['gilt1']) { orderState.toggles['gilt1'] = false; const rs = document.getElementById('row-single'); if (rs) rs.classList.remove('active'); }
    if(id === 'speckle' && !orderState.toggles['dye']){ orderState.toggles['dye'] = true; const rdy = document.getElementById('row-dye'); if (rdy) rdy.classList.add('active'); }
    wizardAutoScroll(row);
  } else {
    orderState.toggles[toggleKey] = false;
    if(id === 'speckle'){
      document.querySelectorAll('#sp1 .sp-dot, #sp2 .sp-dot, #sp3 .sp-dot').forEach(d => d.classList.remove('sel'));
      const sp1 = document.getElementById('sp1-label'); if (sp1) sp1.textContent = '— select a color';
      const sp2 = document.getElementById('sp2-label'); if (sp2) sp2.textContent = '— select a color';
      const sp3 = document.getElementById('sp3-label'); if (sp3) sp3.textContent = '— optional +$15';
      orderState.speckle1 = ''; orderState.speckle2 = ''; orderState.speckle3 = '';
    }
  }
  if (!orderState.toggles['dye']) { orderState.dyeAck = false; const row = document.getElementById('dye-ack-row'); if (row) row.classList.remove('checked'); const box = document.getElementById('dye-ack-box'); if (box) box.textContent = ''; }
  if (!orderState.toggles['speckle']) { orderState.speckleAck = false; const row = document.getElementById('speckle-ack-row'); if (row) row.classList.remove('checked'); const box = document.getElementById('speckle-ack-box'); if (box) box.textContent = ''; }
  updateExtrasSummary();
  updatePriceBar();
  saveWizardStateToStorage();
}

function toggleDyeAck(el, type) {
  const isChecked = !el.classList.contains('checked');
  if (type === 'dye') { orderState.dyeAck = isChecked; const box = document.getElementById('dye-ack-box'); if (box) box.textContent = isChecked ? '✓' : ''; }
  else if (type === 'speckle') { orderState.speckleAck = isChecked; const box = document.getElementById('speckle-ack-box'); if (box) box.textContent = isChecked ? '✓' : ''; }
  if (isChecked) el.classList.add('checked'); else el.classList.remove('checked');
  saveWizardStateToStorage();
}

function toggleSandoff(el) {
  el.classList.toggle('checked');
  orderState.dyeSandoff = el.classList.contains('checked');
  const sandBox = document.getElementById('sandoff-box');
  if (sandBox) sandBox.textContent = orderState.dyeSandoff ? '✓' : '';
  saveWizardStateToStorage();
}

function selExtraColor(group, el, name, upcharge) {
  document.querySelectorAll('#colors-' + group + ' .sc-extra').forEach(c => c.classList.remove('sel'));
  el.classList.add('sel');
  if (group === 'single') { orderState.gilt1Color = name; orderState.gilt1Upcharge = upcharge; }
  else if (group === 'double') { orderState.gilt2Color = name; orderState.gilt2Upcharge = upcharge; }
  updateExtrasSummary();
  updatePriceBar();
  saveWizardStateToStorage();
  wizardAutoScroll('#step6-nav-row');
}

function pickSp(slot, el, name) {
  document.querySelectorAll('#sp' + slot + ' .sp-dot').forEach(d => d.classList.remove('sel'));
  el.classList.add('sel');
  const spSlot = document.getElementById('sp' + slot + '-label');
  if (spSlot) spSlot.textContent = name;
  if (slot === 1) orderState.speckle1 = name;
  if (slot === 2) orderState.speckle2 = name;
  if (slot === 3) orderState.speckle3 = name;
  updateExtrasSummary();
  updatePriceBar();
  saveWizardStateToStorage();
}

function updateExtrasSummary() {
  let total = 0;
  const pGilt1 = (togglePrices.gilt1 !== undefined ? togglePrices.gilt1 : 20);
  const pGilt2 = (togglePrices.gilt2 !== undefined ? togglePrices.gilt2 : 40);
  const pDye = (togglePrices.dye !== undefined ? togglePrices.dye : 40);
  const pSpeckle = (togglePrices.speckle !== undefined ? togglePrices.speckle : 100);
  const pStitch = (togglePrices.stitch !== undefined ? togglePrices.stitch : 100);

  if (orderState.toggles.gilt1) total += pGilt1 + orderState.gilt1Upcharge;
  if (orderState.toggles.gilt2) total += pGilt2 + orderState.gilt2Upcharge;
  if (orderState.toggles.dye) total += pDye;
  if (orderState.toggles.speckle) { let spCost = pSpeckle; if (orderState.speckle3) spCost += 15; total += spCost; }
  if (orderState.toggles.stitch) total += pStitch;
  const extrasTotal = document.getElementById('extras-total');
  if (extrasTotal) extrasTotal.textContent = '$' + total;
  const parts = [];
  if (orderState.toggles.gilt1) parts.push('Single gilt +$' + (pGilt1 + orderState.gilt1Upcharge));
  if (orderState.toggles.gilt2) parts.push('Double gilt +$' + (pGilt2 + orderState.gilt2Upcharge));
  if (orderState.toggles.dye) parts.push('Page dye +$' + pDye);
  if (orderState.toggles.speckle) { let spCost = pSpeckle; if (orderState.speckle3) spCost += 15; parts.push('Speckles +$' + spCost); }
  if (orderState.toggles.stitch) parts.push('Hand stitching +$' + pStitch);
  const extrasBreakdown = document.getElementById('extras-breakdown');
  if (extrasBreakdown) extrasBreakdown.textContent = parts.length ? parts.join(' · ') : 'Nothing selected — all extras are optional';
}

function initWizardScripts() {
  window._isInitializingWizard = true;
  try {
    const restored = restoreWizardStateFromStorage();
    if (restored && typeof restored.savedStep === 'number' && !isNaN(restored.savedStep)) {
      currentStep = restored.savedStep;
    }

    const notesEl = document.getElementById('notes');
    if (notesEl) notesEl.addEventListener('input', function() { orderState.notes = this.value; saveWizardStateToStorage(); });
    const dyeInput = document.getElementById('dye-color');
    if (dyeInput) dyeInput.addEventListener('input', function() { orderState.dyeColor = this.value; saveWizardStateToStorage(); });
    const stitchInput = document.getElementById('stitch-color');
    if (stitchInput) stitchInput.addEventListener('input', function() { orderState.stitchColor = this.value; saveWizardStateToStorage(); });
    const ownInput = document.getElementById('own-bible-type');
    if (ownInput) ownInput.addEventListener('input', function() { orderState.ownBibleType = this.value; saveWizardStateToStorage(); });
    const custLeathInput = document.getElementById('custom-leather-text');
    if (custLeathInput) custLeathInput.addEventListener('input', function() { orderState.customLeatherText = this.value; saveWizardStateToStorage(); });
    const coverStampTextInput = document.getElementById('cover-stamp-text-input');
    if (coverStampTextInput) coverStampTextInput.addEventListener('input', function() { orderState.coverStampText = this.value; saveWizardStateToStorage(); });

    if (window.wizardOverrides) {
      Object.keys(window.wizardOverrides.steps).forEach(stepId => {
        const stepData = window.wizardOverrides.steps[stepId];
        const panel = document.getElementById('panel-' + stepId.replace('step', ''));
        if (panel) {
          if (stepData.title) { const titleEl = panel.querySelector('.sec-title, .step-title'); if (titleEl) titleEl.innerHTML = stepData.title; }
          if (stepData.subtitle) { const subEl = panel.querySelector('.sec-sub, .step-sub'); if (subEl) subEl.innerHTML = stepData.subtitle; }
        }
      });
      Object.keys(window.wizardOverrides.options).forEach(optId => {
        const optData = window.wizardOverrides.options[optId];
        let card = document.querySelector(`.opt-card[data-opt="${optId}"]`);
        if (!card) card = document.getElementById(optId + '-opt') || document.getElementById('mand-' + optId);
        if (card) {
          if (optData.title) { const tEl = card.querySelector('.opt-card-title, .hub-name, .mand-label, .logo-opt-label'); if (tEl) tEl.innerHTML = optData.title; }
          if (optData.description) { const dEl = card.querySelector('.opt-card-desc, .hub-desc, .mand-sub, .logo-opt-sub'); if (dEl) dEl.innerHTML = optData.description; }
          if (optData.price !== null && optData.price !== '') { const pEl = card.querySelector('.opt-card-price, .hub-price'); if (pEl) pEl.innerHTML = optData.price == 0 ? 'Free' : '+$' + optData.price; card.dataset.price = optData.price; }
          if (optData.image) { const imgEl = card.querySelector('img'); if (imgEl) imgEl.src = optData.image; }
        }
      });
    }

    var firstLeatherKey = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.firstLeatherKey) ? window.WIZARD_CONFIG.firstLeatherKey : 'minerva';
    if (!orderState.leather) { selectLeather(firstLeatherKey); }

    const params = new URLSearchParams(window.location.search);
    if (params.get('openWizard') === '1' || params.get('openWizard') === 'true' || params.get('wizard') === 'open') {
      openWizard();
    }
  } finally {
    window._isInitializingWizard = false;
  }

  initWizardHDLightbox();
}

function initWizardHDLightbox() {
  const zoomOverlay = document.getElementById('image-zoom-overlay');
  if (!zoomOverlay) return;

  // Upgrade inner markup for mobile-first HD Lightbox if not already present
  if (!zoomOverlay.querySelector('.bb-lightbox-bar')) {
    zoomOverlay.classList.add('bb-lightbox');
    const existingImg = document.getElementById('zoom-img');
    const currentImgSrc = existingImg ? existingImg.getAttribute('src') : '';

    zoomOverlay.innerHTML = `
      <div class="bb-lightbox-bar">
        <div class="bb-lightbox-title" id="bb-lightbox-title">Image Details</div>
        <div class="bb-lightbox-actions">
          <button type="button" class="bb-lightbox-btn" id="bb-zoom-out" title="Zoom Out" aria-label="Zoom Out">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          </button>
          <span class="bb-lightbox-level" id="bb-zoom-level">100%</span>
          <button type="button" class="bb-lightbox-btn" id="bb-zoom-in" title="Zoom In" aria-label="Zoom In">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          </button>
          <button type="button" class="bb-lightbox-btn" id="bb-zoom-reset" title="Reset Zoom" aria-label="Reset Zoom">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path></svg>
          </button>
          <button type="button" class="bb-lightbox-btn bb-lightbox-close" id="zoom-close" title="Close" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
      </div>
      <div class="bb-lightbox-stage" id="bb-lightbox-stage">
        <div class="bb-lightbox-wrap" id="bb-lightbox-wrap">
          <img id="zoom-img" class="bb-lightbox-img" src="${currentImgSrc || ''}" alt="Full preview">
        </div>
      </div>
      <div class="bb-lightbox-hint" id="bb-lightbox-hint">
        <span>Double-tap or pinch to zoom &bull; Drag to pan</span>
      </div>
    `;
  }

  const zoomImg = document.getElementById('zoom-img');
  const zoomStage = document.getElementById('bb-lightbox-stage');
  const zoomWrap = document.getElementById('bb-lightbox-wrap') || zoomStage;
  const zoomTitle = document.getElementById('bb-lightbox-title');
  const zoomLevel = document.getElementById('bb-zoom-level');
  const btnZoomIn = document.getElementById('bb-zoom-in');
  const btnZoomOut = document.getElementById('bb-zoom-out');
  const btnZoomReset = document.getElementById('bb-zoom-reset');
  const zoomCloseBtn = document.getElementById('zoom-close');

  let scale = 1.0;
  let translateX = 0;
  let translateY = 0;
  let isDragging = false;
  let startX = 0;
  let startY = 0;
  let startTranslateX = 0;
  let startTranslateY = 0;
  let lastTapTime = 0;
  let lastTapPos = { x: 0, y: 0 };
  let initialPinchDistance = 0;
  let initialScale = 1.0;
  let hintTimeout = null;

  function updateTransform(animate) {
    if (!zoomImg) return;
    if (animate) {
      zoomImg.style.transition = 'transform 0.22s cubic-bezier(0.2, 0, 0, 1)';
    } else {
      zoomImg.style.transition = 'none';
    }
    zoomImg.style.transform = `translate3d(${translateX}px, ${translateY}px, 0px) scale(${scale})`;
    if (zoomLevel) {
      zoomLevel.textContent = Math.round(scale * 100) + '%';
    }
    if (zoomStage) {
      if (scale > 1.02) {
        zoomStage.classList.add('is-zoomed');
      } else {
        zoomStage.classList.remove('is-zoomed');
      }
    }
  }

  function clampPosition() {
    if (!zoomImg || !zoomStage) return;
    const stageRect = zoomStage.getBoundingClientRect();
    const imgRect = zoomImg.getBoundingClientRect();

    const maxDragX = Math.max(0, (imgRect.width - stageRect.width) / 2);
    const maxDragY = Math.max(0, (imgRect.height - stageRect.height) / 2);

    if (scale <= 1.02) {
      translateX = 0;
      translateY = 0;
    } else {
      translateX = Math.max(-maxDragX - 40, Math.min(maxDragX + 40, translateX));
      translateY = Math.max(-maxDragY - 40, Math.min(maxDragY + 40, translateY));
    }
  }

  function setScale(newScale, focalX, focalY, animate) {
    const minScale = 1.0;
    const maxScale = 4.0;
    const prevScale = scale;
    scale = Math.max(minScale, Math.min(maxScale, newScale));

    if (focalX !== undefined && focalY !== undefined && zoomStage) {
      const stageRect = zoomStage.getBoundingClientRect();
      const centerX = stageRect.left + stageRect.width / 2;
      const centerY = stageRect.top + stageRect.height / 2;
      const offsetX = focalX - centerX;
      const offsetY = focalY - centerY;
      const ratio = scale / prevScale;
      translateX = translateX * ratio + (offsetX * (1 - ratio));
      translateY = translateY * ratio + (offsetY * (1 - ratio));
    }

    if (scale <= 1.02) {
      translateX = 0;
      translateY = 0;
    } else {
      clampPosition();
    }
    updateTransform(animate);
  }

  function resetZoom(animate) {
    scale = 1.0;
    translateX = 0;
    translateY = 0;
    updateTransform(animate !== false);
  }

  function getTouchDistance(e) {
    if (e.touches.length < 2) return 0;
    const dx = e.touches[0].clientX - e.touches[1].clientX;
    const dy = e.touches[0].clientY - e.touches[1].clientY;
    return Math.hypot(dx, dy);
  }

  function getTouchMidpoint(e) {
    if (e.touches.length < 2) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    return {
      x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
      y: (e.touches[0].clientY + e.touches[1].clientY) / 2
    };
  }

  function handleDoubleTap(clientX, clientY) {
    if (scale > 1.2) {
      resetZoom(true);
    } else {
      setScale(2.5, clientX, clientY, true);
    }
  }

  window.openWizardHDLightbox = function(src, title) {
    if (!zoomOverlay || !zoomImg) return;
    if (!src || src.includes('placeholder')) return;

    let cleanSrc = src;
    if (cleanSrc.includes('?')) {
      const parts = cleanSrc.split('?');
      cleanSrc = parts[0] + (parts[1] ? '?' + parts[1] : '');
    }

    zoomImg.src = cleanSrc;
    if (zoomTitle) {
      zoomTitle.textContent = title || 'Detail Inspection';
    }
    resetZoom(false);
    zoomOverlay.style.display = 'flex';
    document.body.classList.add('bb-lightbox-open');

    const hintEl = document.getElementById('bb-lightbox-hint');
    if (hintEl) {
      hintEl.style.opacity = '1';
      hintEl.style.display = 'block';
      if (hintTimeout) clearTimeout(hintTimeout);
      hintTimeout = setTimeout(() => {
        hintEl.style.opacity = '0';
        setTimeout(() => { if (hintEl.style.opacity === '0') hintEl.style.display = 'none'; }, 400);
      }, 3500);
    }
  };

  window.closeWizardHDLightbox = function() {
    if (!zoomOverlay) return;
    zoomOverlay.style.display = 'none';
    document.body.classList.remove('bb-lightbox-open');
    resetZoom(false);
  };

  if (btnZoomIn) {
    btnZoomIn.onclick = function(e) {
      e.stopPropagation();
      setScale(scale + 0.5, undefined, undefined, true);
    };
  }
  if (btnZoomOut) {
    btnZoomOut.onclick = function(e) {
      e.stopPropagation();
      setScale(scale - 0.5, undefined, undefined, true);
    };
  }
  if (btnZoomReset) {
    btnZoomReset.onclick = function(e) {
      e.stopPropagation();
      resetZoom(true);
    };
  }
  if (zoomCloseBtn) {
    zoomCloseBtn.onclick = function(e) {
      e.stopPropagation();
      window.closeWizardHDLightbox();
    };
  }

  if (zoomStage) {
    zoomStage.addEventListener('mousedown', function(e) {
      if (e.target.closest('.bb-lightbox-btn') || e.target.closest('.bb-lightbox-bar')) return;
      if (scale > 1.02) {
        isDragging = true;
        startX = e.clientX;
        startY = e.clientY;
        startTranslateX = translateX;
        startTranslateY = translateY;
        zoomStage.style.cursor = 'grabbing';
      }
    });

    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      translateX = startTranslateX + (e.clientX - startX);
      translateY = startTranslateY + (e.clientY - startY);
      clampPosition();
      updateTransform(false);
    });

    window.addEventListener('mouseup', function(e) {
      if (isDragging) {
        isDragging = false;
        if (zoomStage) zoomStage.style.cursor = scale > 1.02 ? 'grab' : 'zoom-in';
        clampPosition();
        updateTransform(true);
      }
    });

    zoomStage.addEventListener('touchstart', function(e) {
      if (e.target.closest('.bb-lightbox-btn') || e.target.closest('.bb-lightbox-bar')) return;

      if (e.touches.length === 2) {
        isDragging = false;
        initialPinchDistance = getTouchDistance(e);
        initialScale = scale;
      } else if (e.touches.length === 1) {
        const now = Date.now();
        const touch = e.touches[0];
        const distFromLastTap = Math.hypot(touch.clientX - lastTapPos.x, touch.clientY - lastTapPos.y);

        if (now - lastTapTime < 320 && distFromLastTap < 30) {
          e.preventDefault();
          handleDoubleTap(touch.clientX, touch.clientY);
          lastTapTime = 0;
          return;
        }

        lastTapTime = now;
        lastTapPos = { x: touch.clientX, y: touch.clientY };

        if (scale > 1.02) {
          isDragging = true;
          startX = touch.clientX;
          startY = touch.clientY;
          startTranslateX = translateX;
          startTranslateY = translateY;
        }
      }
    }, { passive: false });

    zoomStage.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        const dist = getTouchDistance(e);
        if (initialPinchDistance > 0 && dist > 0) {
          const midpoint = getTouchMidpoint(e);
          const pinchScale = initialScale * (dist / initialPinchDistance);
          setScale(pinchScale, midpoint.x, midpoint.y, false);
        }
      } else if (e.touches.length === 1 && isDragging && scale > 1.02) {
        e.preventDefault();
        const touch = e.touches[0];
        translateX = startTranslateX + (touch.clientX - startX);
        translateY = startTranslateY + (touch.clientY - startY);
        clampPosition();
        updateTransform(false);
      }
    }, { passive: false });

    zoomStage.addEventListener('touchend', function(e) {
      if (isDragging) {
        isDragging = false;
        clampPosition();
        updateTransform(true);
      }
      if (e.touches.length < 2) {
        initialPinchDistance = 0;
      }
    });

    zoomStage.addEventListener('wheel', function(e) {
      if (zoomOverlay.style.display !== 'none') {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 0.25 : -0.25;
        setScale(scale + delta, e.clientX, e.clientY, true);
      }
    }, { passive: false });

    zoomStage.addEventListener('click', function(e) {
      if (e.target === zoomStage || e.target === zoomWrap) {
        if (scale <= 1.05) {
          window.closeWizardHDLightbox();
        } else {
          resetZoom(true);
        }
      }
    });
  }

  window.addEventListener('keydown', function(e) {
    if (zoomOverlay.style.display !== 'none') {
      if (e.key === 'Escape') {
        window.closeWizardHDLightbox();
      } else if (e.key === '+' || e.key === '=') {
        setScale(scale + 0.3, undefined, undefined, true);
      } else if (e.key === '-' || e.key === '_') {
        setScale(scale - 0.3, undefined, undefined, true);
      } else if (e.key === '0' || e.key.toLowerCase() === 'r') {
        resetZoom(true);
      }
    }
  });

  const wizardModal = document.getElementById('wizardModal');
  if (wizardModal) {
    wizardModal.removeEventListener('click', window._wizardZoomClickHandler, true);
    window._wizardZoomClickHandler = function(e) {
      const img = e.target.tagName === 'IMG' ? e.target : (e.target.tagName === 'A' && e.target.querySelector('img') ? e.target.querySelector('img') : null);
      if (
        img &&
        !img.closest('.spine-viz') &&
        !img.closest('#image-zoom-overlay') &&
        !img.closest('.logo-opt') &&
        !img.closest('.logo-sec-inner') &&
        !img.closest('.mand-card') &&
        !img.closest('.mandatory-opts') &&
        !img.closest('.stamp-card') &&
        !img.closest('.stamp-grid') &&
        !img.closest('.stamp-img-wrap')
      ) {
        e.stopPropagation();
        if (e.target.tagName === 'A') e.preventDefault();
        const src = img.getAttribute('data-src') || img.getAttribute('data-srcset') || img.currentSrc || img.src || img.getAttribute('src');
        const title = img.getAttribute('alt') || img.getAttribute('title') || 'Detail View';
        if (src && !src.includes('placeholder')) {
          let finalSrc = src;
          if (finalSrc.includes(' ')) { finalSrc = finalSrc.split(' ')[0]; }
          window.openWizardHDLightbox(finalSrc, title);
        }
      }
    };
    wizardModal.addEventListener('click', window._wizardZoomClickHandler, true);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWizardScripts);
} else {
  initWizardScripts();
}

// Expose interactive functions on window for inline HTML onclick handlers
window.orderState = typeof orderState !== 'undefined' ? orderState : window.orderState;
window.openWizard = typeof openWizard !== 'undefined' ? openWizard : window.openWizard;
window.closeWizard = typeof closeWizard !== 'undefined' ? closeWizard : window.closeWizard;
window.nextStep = typeof nextStep !== 'undefined' ? nextStep : window.nextStep;
window.prevStep = typeof prevStep !== 'undefined' ? prevStep : window.prevStep;
window.goToStep = typeof goToStep !== 'undefined' ? goToStep : window.goToStep;
window.calcTotal = typeof calcTotal !== 'undefined' ? calcTotal : window.calcTotal;
window.updatePriceBar = typeof updatePriceBar !== 'undefined' ? updatePriceBar : window.updatePriceBar;
window.selectOpt = typeof selectOpt !== 'undefined' ? selectOpt : window.selectOpt;
window.selectLeather = typeof selectLeather !== 'undefined' ? selectLeather : window.selectLeather;
window.pickColor = typeof pickColor !== 'undefined' ? pickColor : window.pickColor;
window.pickLiner = typeof pickLiner !== 'undefined' ? pickLiner : window.pickLiner;
window.updateCustomLeather = typeof updateCustomLeather !== 'undefined' ? updateCustomLeather : window.updateCustomLeather;
window.selectHub = typeof selectHub !== 'undefined' ? selectHub : window.selectHub;
window.selColor = typeof selColor !== 'undefined' ? selColor : window.selColor;
window.updateSec = typeof updateSec !== 'undefined' ? updateSec : window.updateSec;
window.pickSec3 = typeof pickSec3 !== 'undefined' ? pickSec3 : window.pickSec3;
window.selMand = typeof selMand !== 'undefined' ? selMand : window.selMand;
window.selFont = typeof selFont !== 'undefined' ? selFont : window.selFont;
window.selectCoverStamp = typeof selectCoverStamp !== 'undefined' ? selectCoverStamp : window.selectCoverStamp;
window.selectPlacement = typeof selectPlacement !== 'undefined' ? selectPlacement : window.selectPlacement;
window.selectCoverStampColor = typeof selectCoverStampColor !== 'undefined' ? selectCoverStampColor : window.selectCoverStampColor;
window.updateCoverStampText = typeof updateCoverStampText !== 'undefined' ? updateCoverStampText : window.updateCoverStampText;
window.toggleInscription = typeof toggleInscription !== 'undefined' ? toggleInscription : window.toggleInscription;
window.updateInscriptionText = typeof updateInscriptionText !== 'undefined' ? updateInscriptionText : window.updateInscriptionText;
window.addExtraInscriptionName = typeof addExtraInscriptionName !== 'undefined' ? addExtraInscriptionName : window.addExtraInscriptionName;
window.removeExtraInscriptionName = typeof removeExtraInscriptionName !== 'undefined' ? removeExtraInscriptionName : window.removeExtraInscriptionName;
window.renderInscriptionInputs = typeof renderInscriptionInputs !== 'undefined' ? renderInscriptionInputs : window.renderInscriptionInputs;
window.recalcInscriptionCost = typeof recalcInscriptionCost !== 'undefined' ? recalcInscriptionCost : window.recalcInscriptionCost;
window.selectInscriptionFont = typeof selectInscriptionFont !== 'undefined' ? selectInscriptionFont : window.selectInscriptionFont;
window.toggleExtraOpt = typeof toggleExtraOpt !== 'undefined' ? toggleExtraOpt : window.toggleExtraOpt;
window.toggleDyeAck = typeof toggleDyeAck !== 'undefined' ? toggleDyeAck : window.toggleDyeAck;
window.toggleSandoff = typeof toggleSandoff !== 'undefined' ? toggleSandoff : window.toggleSandoff;
window.selExtraColor = typeof selExtraColor !== 'undefined' ? selExtraColor : window.selExtraColor;
window.pickSp = typeof pickSp !== 'undefined' ? pickSp : window.pickSp;
window.submitOrder = typeof submitOrder !== 'undefined' ? submitOrder : window.submitOrder;
window.addToCartAndCheckout = typeof addToCartAndCheckout !== 'undefined' ? addToCartAndCheckout : window.addToCartAndCheckout;
window.addToCartAndGoCart = typeof addToCartAndGoCart !== 'undefined' ? addToCartAndGoCart : window.addToCartAndGoCart;
window.pickRibbon = typeof pickRibbon !== 'undefined' ? pickRibbon : window.pickRibbon;
window.updateRibbonChoice = typeof updateRibbonChoice !== 'undefined' ? updateRibbonChoice : window.updateRibbonChoice;
window.updateOwnBibleType = typeof updateOwnBibleType !== 'undefined' ? updateOwnBibleType : window.updateOwnBibleType;
window.wizardAutoScroll = typeof wizardAutoScroll !== 'undefined' ? wizardAutoScroll : window.wizardAutoScroll;

function resetWizardState() {
  if (window.WIZARD_CONFIG && window.WIZARD_CONFIG.basePrice !== undefined) {
    basePrice = window.WIZARD_CONFIG.basePrice;
  }
  orderState = {
    bibleSource: '',
    ownBibleType: '',
    bibleCondition: '',
    bibleConditionPrice: 0,
    translation: '',
    translationPrice: 0,
    leather: '',
    leatherName: '',
    leatherPrice: 0,
    customLeatherText: '',
    color: '',
    coverStiffness: '',
    coverStiffnessPrice: 0,
    yapp: '',
    yappPrice: 0,
    liner: '',
    ribbons: undefined,
    ribbonsPrice: 0,
    ribbonChoices: [],
    hubStyle: '',
    hubPrice: 0,
    spineStampColor: '',
    spineStampColorPrice: 0,
    stampFont: 'Goudy Light',
    stampFontFamily: "'Cormorant Garamond',serif",
    stampFontStyle: 'normal',
    spineSections: {},
    spineLogo: 'both',
    tooling: 'no-tooling',
    toolingPrice: 0,
    toggles: { stitch: false, gilt1: false, gilt2: false, dye: false, speckle: false },
    gilt1Color: '',
    gilt1Upcharge: 0,
    gilt2Color: '',
    gilt2Upcharge: 0,
    dyeColor: '',
    dyeSandoff: false,
    dyeAck: false,
    speckleAck: false,
    speckle1: '',
    speckle2: '',
    speckle3: '',
    stitchColor: '',
    coverStampType: 'none',
    coverStampCost: 0,
    coverStampPlacement: '',
    coverStampColor: '',
    coverStampColorCost: 0,
    coverStampText: '',
    inscriptions: { front: false, liner: false, back: false },
    inscriptionTexts: { front: [''], liner: [''], back: [''] },
    inscriptionCost: 0,
    inscriptionFont: 'Goudy Light'
  };

  // Reset DOM: Step 0
  document.querySelectorAll('#panel-0 .opt-card').forEach(c => c.classList.remove('selected'));
  const transSec = document.getElementById('translation-section');
  if (transSec) transSec.style.display = 'none';
  const ownSec = document.getElementById('own-bible-section');
  if (ownSec) ownSec.style.display = 'none';
  const ownTypeInput = document.getElementById('own-bible-type');
  if (ownTypeInput) ownTypeInput.value = '';

  // Reset DOM: Step 1
  document.querySelectorAll('.ltab').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.leather-panel').forEach(p => p.style.display = 'none');
  document.querySelectorAll('.ldot').forEach(d => d.classList.remove('sel'));
  document.querySelectorAll('.lnr-dot').forEach(d => d.classList.remove('sel'));
  const custLeathInput = document.getElementById('custom-leather-text');
  if (custLeathInput) custLeathInput.value = '';
  document.querySelectorAll('[id^="sel-color-"]').forEach(el => el.textContent = '');
  const linerNameLabel = document.getElementById('liner-name');
  if (linerNameLabel) linerNameLabel.textContent = '';

  // Reset DOM: Step 2
  document.querySelectorAll('#panel-2 .opt-card').forEach(c => c.classList.remove('selected'));
  const noTooling = document.querySelector('.opt-card[data-opt="no-tooling"]');
  if (noTooling) noTooling.classList.add('selected');

  // Reset DOM: Step 3
  document.querySelectorAll('.rcount-btn').forEach(b => b.classList.remove('selected'));
  const ribContainer = document.getElementById('selected-ribbons-container');
  if (ribContainer) ribContainer.innerHTML = '';

  // Reset DOM: Step 4
  document.querySelectorAll('#panel-4 .hub-card').forEach(c => c.classList.remove('sel'));
  document.querySelectorAll('#panel-4 .stamp-color').forEach(c => c.classList.remove('sel'));
  document.querySelectorAll('#panel-4 .font-card').forEach(c => c.classList.remove('sel'));
  document.querySelectorAll('.mand-card').forEach(c => c.classList.remove('sel'));
  for (let i = 1; i <= 5; i++) {
    const input = document.getElementById(`spine${i}`);
    if (input) input.value = '';
    const row = document.getElementById(`row-${i}`);
    if (row) { row.classList.remove('used'); row.style.borderBottom = ''; }
    const prev = document.getElementById(`prev-${i}`);
    if (prev) prev.innerHTML = '<span style="color:#2e2418;font-size:11px;">section ' + i + '</span>';
  }
  const sec3Opts = ['chirho-opt', 'latincross-opt', 'sword-opt', 'ichthys-opt', 'fishbread-opt', 'ark-opt', 'ega-opt', 'text3-opt', 'blank3-opt'];
  sec3Opts.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('sel');
  });

  // Reset DOM: Step 5
  document.querySelectorAll('.stamp-card, .stamp-custom-card').forEach(c => c.classList.remove('selected'));
  const noneStamp = document.querySelector('.stamp-card[data-cover-stamp="none"]');
  if (noneStamp) noneStamp.classList.add('selected');
  const brassNote = document.getElementById('brass-note');
  if (brassNote) brassNote.style.display = 'none';
  const cstWrap = document.getElementById('cover-stamp-text-wrap');
  if (cstWrap) cstWrap.style.display = 'none';
  const cstInput = document.getElementById('cover-stamp-text-input');
  if (cstInput) cstInput.value = '';
  document.querySelectorAll('.place-card').forEach(c => c.classList.remove('selected'));
  const placeOther = document.getElementById('placement-other-input');
  if (placeOther) placeOther.style.display = 'none';
  document.querySelectorAll('.stamp-color-card').forEach(c => c.classList.remove('selected'));
  const selCoverStampColor = document.getElementById('selected-cover-stamp-color');
  if (selCoverStampColor) selCoverStampColor.textContent = '';
  document.querySelectorAll('.insc-card').forEach(c => c.classList.remove('selected'));
  const noInsc = document.querySelector('.insc-card[data-inscription="none"]');
  if (noInsc) noInsc.classList.add('selected');
  const inscWrap = document.getElementById('inscription-input-wrap');
  if (inscWrap) inscWrap.style.display = 'none';
  const inscFrontWrap = document.getElementById('insc-front-input-wrap');
  if (inscFrontWrap) inscFrontWrap.style.display = 'none';
  const inscLinerWrap = document.getElementById('insc-liner-input-wrap');
  if (inscLinerWrap) inscLinerWrap.style.display = 'none';
  const inscBackWrap = document.getElementById('insc-back-input-wrap');
  if (inscBackWrap) inscBackWrap.style.display = 'none';
  const inscFront = document.getElementById('inscription-text-front');
  if (inscFront) inscFront.value = '';
  const inscLiner = document.getElementById('inscription-text-liner');
  if (inscLiner) inscLiner.value = '';
  const inscBack = document.getElementById('inscription-text-back');
  if (inscBack) inscBack.value = '';
  const extraF = document.getElementById('extra-insc-front-container');
  if (extraF) extraF.innerHTML = '';
  const extraL = document.getElementById('extra-insc-liner-container');
  if (extraL) extraL.innerHTML = '';
  const extraB = document.getElementById('extra-insc-back-container');
  if (extraB) extraB.innerHTML = '';
  document.querySelectorAll('#inscription-input-wrap .font-card').forEach(c => c.classList.remove('selected'));

  // Reset DOM: Step 6
  ['single', 'double', 'dye', 'speckle', 'stitch'].forEach(id => {
    const row = document.getElementById('row-' + id);
    if (row) row.classList.remove('active');
  });
  document.querySelectorAll('.sc-extra').forEach(c => c.classList.remove('sel'));
  document.querySelectorAll('.sp-dot').forEach(d => d.classList.remove('sel'));
  const sandoffCb = document.getElementById('sandoff-cb') || document.getElementById('sandoff-row');
  if (sandoffCb) sandoffCb.classList.remove('checked');
  const sandoffBox = document.getElementById('sandoff-box');
  if (sandoffBox) sandoffBox.textContent = '';
  const dyeAckRow = document.getElementById('dye-ack-row');
  if (dyeAckRow) dyeAckRow.classList.remove('checked');
  const dyeAckBox = document.getElementById('dye-ack-box');
  if (dyeAckBox) dyeAckBox.textContent = '';
  const speckleAckRow = document.getElementById('speckle-ack-row');
  if (speckleAckRow) speckleAckRow.classList.remove('checked');
  const speckleAckBox = document.getElementById('speckle-ack-box');
  if (speckleAckBox) speckleAckBox.textContent = '';
  const dyeInput = document.getElementById('dye-color');
  if (dyeInput) dyeInput.value = '';
  const stitchInput = document.getElementById('stitch-color');
  if (stitchInput) stitchInput.value = '';
  const sp1L = document.getElementById('sp1-label');
  if (sp1L) sp1L.textContent = '— select a color';
  const sp2L = document.getElementById('sp2-label');
  if (sp2L) sp2L.textContent = '— select a color';
  const sp3L = document.getElementById('sp3-label');
  if (sp3L) sp3L.textContent = '— optional +$15';

  // Reset DOM: Step 7
  const notesEl = document.getElementById('notes');
  if (notesEl) notesEl.value = '';
  if (typeof ackChecked !== 'undefined') {
    ackChecked[1] = false;
    ackChecked[2] = false;
    const item1 = document.getElementById('ack1');
    if (item1) item1.classList.remove('checked');
    const item2 = document.getElementById('ack2');
    if (item2) item2.classList.remove('checked');
  }
}
window.resetWizardState = resetWizardState;

function openWizardForCartItem(target, targetStep, scrollTarget) {
  let itemEl = null;
  if (target && target.nodeType) {
    itemEl = target.closest('.bb-cart-item') || target.closest('.m-cart-item') || target.closest('[data-cart-item]');
  } else if (typeof target === 'string' || typeof target === 'number') {
    itemEl = document.querySelector(`[data-line-index="${target}"]`) || document.querySelector(`[data-index="${target}"]`) || document.getElementById(`MinimogCart-Item-${target}`);
  }
  if (!itemEl) {
    itemEl = document.querySelector('.bb-cart-item[data-is-wizard="true"]');
  }
  if (!itemEl) return;
  if (itemEl.getAttribute('data-is-signature') === 'true' || itemEl.getAttribute('data-is-wizard') !== 'true') return;

  const lineIndex = itemEl.getAttribute('data-line-index') || itemEl.getAttribute('data-index') || (typeof target === 'string' || typeof target === 'number' ? target : 1);

  const rawProps = itemEl.getAttribute('data-item-properties');
  let props = {};
  if (rawProps) {
    try {
      let jsonStr = rawProps;
      if (jsonStr.includes('&quot;') || jsonStr.includes('&#34;') || jsonStr.includes('&amp;')) {
        const txt = document.createElement('textarea');
        txt.innerHTML = jsonStr;
        jsonStr = txt.value;
      }
      props = JSON.parse(jsonStr);
    } catch (e) {
      console.warn('Could not parse data-item-properties JSON:', e);
    }
  }

  // Fallback / complement: extract properties directly from the cart item DOM elements
  itemEl.querySelectorAll('.bb-prop-row, .m-cart-item__property, [data-cart-item-property], .bb-cart-item-details li').forEach(propLi => {
    let key = propLi.getAttribute('data-prop-name');
    let val = propLi.getAttribute('data-prop-value');
    if (!key || !val) {
      const nameEl = propLi.querySelector('[data-cart-item-property-name], .bb-prop-name');
      const valEl = propLi.querySelector('[data-cart-item-property-value], .bb-prop-val');
      if (nameEl && valEl) {
        key = nameEl.innerText.replace(/:\s*$/, '').trim();
        val = valEl.innerText.trim();
      }
    }
    if (key && val) {
      key = key.replace(/:\s*$/, '').trim();
      if (!props[key]) {
        props[key] = val;
      }
    }
  });

  // Normalize all keys in props (strip trailing colons, lowercase lookup helper)
  const normalizedProps = {};
  for (let k in props) {
    const cleanK = k.replace(/:\s*$/, '').trim();
    normalizedProps[cleanK] = typeof props[k] === 'string' ? props[k].trim() : props[k];
  }
  props = normalizedProps;

  // Helper to lookup property value across possible key variants
  function getProp(...possibleKeys) {
    for (let k of possibleKeys) {
      if (props[k] !== undefined && props[k] !== null && props[k] !== '') {
        return props[k];
      }
      const lowerK = k.toLowerCase();
      for (let actualKey in props) {
        if (actualKey.toLowerCase() === lowerK && props[actualKey] !== undefined && props[actualKey] !== '') {
          return props[actualKey];
        }
      }
    }
    return '';
  }

  const startStep = (typeof targetStep === 'number' && !isNaN(targetStep) && targetStep >= 0 && targetStep <= 7) ? targetStep : 0;

  window.WIZARD_EDIT_MODE = {
    lineIndex: lineIndex,
    itemKey: itemEl.getAttribute('data-item-key'),
    isEditing: true,
    originalQty: parseInt(itemEl.querySelector('input[name="updates[]"]')?.value || '1', 10) || 1,
    originalProps: Object.assign({}, props)
  };

  // Prevent scroll jump and OOS blocking during restoration
  window._isRestoringCartWizard = true;

  // Open the wizard modal directly to the target step
  openWizard(startStep);

  // Reset all state & DOM selections cleanly before loading this item's specific choices
  resetWizardState();

  const togglePrices = { stitch: 100, single: 20, gilt1: 20, double: 40, gilt2: 40, dye: 40, speckle: 100 };

  try {
    // Populate Product Header Bar in Wizard Modal
    const itemImg = itemEl.getAttribute('data-item-image') || (itemEl.querySelector('.m-cart-item__image img')?.src || '');
    const itemTitle = itemEl.getAttribute('data-item-title') || (itemEl.querySelector('.m-cart-item__title')?.innerText || 'The Byrd Bound Bible');
    const itemVariant = itemEl.getAttribute('data-item-variant-title') || '';

  const headerBanner = document.getElementById('wiz-cart-product-header');
  const headerImg = document.getElementById('wiz-cart-prod-img');
  const headerTitle = document.getElementById('wiz-cart-prod-title');
  const headerVariant = document.getElementById('wiz-cart-prod-variant');
  const headerLine = document.getElementById('wiz-cart-prod-line');

  if (headerBanner) {
    if (itemImg && headerImg) {
      headerImg.src = itemImg;
      headerImg.style.display = 'block';
    } else if (headerImg) {
      headerImg.style.display = 'none';
    }
    if (headerTitle) headerTitle.textContent = itemTitle;
    if (headerVariant) headerVariant.textContent = itemVariant ? itemVariant : 'Custom Specification';
    if (headerLine) headerLine.textContent = `Cart Item #${lineIndex}`;
    headerBanner.style.display = 'flex';
  }

  // Pre-populate Step 0: Bible Source & Condition / Translation
  const bSource = getProp('Bible Source');
  const condProp = getProp('Bible Condition');
  const ownTypeProp = getProp('Own Bible Type', 'Bible Type');
  const isOwn = bSource.includes('Sending my own') || bSource.toLowerCase().includes('own') || !!condProp || !!ownTypeProp;

  if (isOwn) {
    const ownCard = document.querySelector('#panel-0 .opt-card[data-opt="own"]');
    const sourceCard = document.querySelector('#panel-0 .opt-card[data-opt="source"]');
    if (sourceCard) sourceCard.classList.remove('selected');
    if (ownCard) ownCard.classList.add('selected');
    orderState.bibleSource = 'own';
    
    const ownSec = document.getElementById('own-bible-section');
    if (ownSec) ownSec.style.display = 'block';
    const transSec = document.getElementById('translation-section');
    if (transSec) transSec.style.display = 'none';
    
    // Extract own bible type
    let ownType = '';
    if (bSource.includes('(') && bSource.includes(')')) {
      ownType = bSource.substring(bSource.indexOf('(') + 1, bSource.lastIndexOf(')')).trim();
    } else if (ownTypeProp) {
      ownType = ownTypeProp;
    }
    if (ownType && ownType !== 'Not specified') {
      const ownInput = document.getElementById('own-bible-type');
      if (ownInput) ownInput.value = ownType;
      orderState.ownBibleType = ownType;
    }

    // Condition
    if (condProp) {
      const condCards = document.querySelectorAll('#own-bible-section .opt-card');
      let matchedCond = null;
      for (let c of condCards) {
        const title = (c.querySelector('.opt-card-title')?.innerText || '').trim();
        if (title.toLowerCase() === condProp.toLowerCase().trim() || title.toLowerCase().includes(condProp.toLowerCase().trim()) || condProp.toLowerCase().includes(title.toLowerCase())) {
          matchedCond = c;
          break;
        }
      }
      if (matchedCond) {
        condCards.forEach(c => c.classList.remove('selected'));
        matchedCond.classList.add('selected');
        orderState.bibleCondition = (matchedCond.querySelector('.opt-card-title')?.innerText || condProp).trim();
        orderState.bibleConditionPrice = parseInt(matchedCond.dataset.price) || 0;
      } else {
        orderState.bibleCondition = condProp;
      }
    }
  } else {
    const sourceCard = document.querySelector('#panel-0 .opt-card[data-opt="source"]');
    const ownCard = document.querySelector('#panel-0 .opt-card[data-opt="own"]');
    if (ownCard) ownCard.classList.remove('selected');
    if (sourceCard) sourceCard.classList.add('selected');
    orderState.bibleSource = 'source';

    const transSec = document.getElementById('translation-section');
    if (transSec) transSec.style.display = 'block';
    const ownSec = document.getElementById('own-bible-section');
    if (ownSec) ownSec.style.display = 'none';

    let transVal = getProp('Bible Text Block') || bSource.replace(/^Sourced:\s*/i, '').trim();
    if (transVal) {
      const transCards = document.querySelectorAll('#translation-section .opt-card');
      let matchedTrans = null;
      // 1. Exact match
      for (let c of transCards) {
        const title = (c.querySelector('.opt-card-title')?.innerText || '').trim();
        if (title.toLowerCase() === transVal.toLowerCase().trim()) {
          matchedTrans = c;
          break;
        }
      }
      // 2. Fuzzy match
      if (!matchedTrans) {
        for (let c of transCards) {
          const title = (c.querySelector('.opt-card-title')?.innerText || '').trim();
          const optVal = (c.getAttribute('data-opt') || '').toLowerCase();
          const cleanTrans = transVal.toLowerCase().replace(/[^a-z0-9]/g, '');
          const cleanTitle = title.toLowerCase().replace(/[^a-z0-9]/g, '');
          if ((cleanTitle && cleanTrans && (cleanTitle.includes(cleanTrans) || cleanTrans.includes(cleanTitle))) ||
              (optVal && cleanTrans && cleanTrans.includes(optVal.replace(/[^a-z0-9]/g, '')))) {
            matchedTrans = c;
            break;
          }
        }
      }
      if (matchedTrans) {
        transCards.forEach(c => c.classList.remove('selected'));
        matchedTrans.classList.add('selected');
        orderState.translation = (matchedTrans.querySelector('.opt-card-title')?.innerText || transVal).trim();
        orderState.translationPrice = parseInt(matchedTrans.dataset.price) || 45;
      } else {
        orderState.translation = transVal;
        orderState.translationPrice = 45;
        if (transCards.length > 0) {
          transCards[0].classList.add('selected');
          orderState.translation = (transCards[0].querySelector('.opt-card-title')?.innerText || transVal).trim();
          orderState.translationPrice = parseInt(transCards[0].dataset.price) || 45;
        }
      }
    }
  }

  // Pre-populate Step 1: Leather & Color & Liner
  const leatherVal = getProp('Leather', 'Leather Type');
  const colorVal = getProp('Color', 'Leather Color', 'Cover Color');
  const linerVal = getProp('Liner', 'Liner Color', 'Inner Liner');

  const leatherAliases = [
    { key: 'buffalo', match: ['buffalo', 'wild cape'] },
    { key: 'capra3', match: ['pueblo', 'capra3'] },
    { key: 'waxy', match: ['waxy'] },
    { key: 'minerva', match: ['minerva'] },
    { key: 'lochness', match: ['loch ness', 'lochness'] },
    { key: 'capra', match: ['sokoto'] },
    { key: 'levant', match: ['levant'] },
    { key: 'bisanzio', match: ['bisanzio', 'puccini', 'rustic metallic'] },
    { key: 'sauvage', match: ['sauvage'] },
    { key: 'pullup', match: ['pull up', 'pullup', 'siegel vegetable goat'] },
    { key: 'custom', match: ['custom'] }
  ];

  let chosenLeatherKey = 'minerva';
  const lLower = leatherVal.toLowerCase();
  for (let alias of leatherAliases) {
    if (alias.match.some(m => lLower.includes(m))) {
      chosenLeatherKey = alias.key;
      break;
    }
  }

  // Activate tab & panel for chosen leather
  document.querySelectorAll('.ltab').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.leather-panel').forEach(p => p.style.display = 'none');
  const chosenTab = document.getElementById('tab-' + chosenLeatherKey);
  if (chosenTab) chosenTab.classList.add('active');
  const chosenPanel = document.getElementById('panel-' + chosenLeatherKey);
  if (chosenPanel) chosenPanel.style.display = 'block';

  const prices = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.leatherPrices) ? window.WIZARD_CONFIG.leatherPrices : { waxy: 0, buffalo: 100, minerva: 0, lochness: 50, capra: 70, levant: 60, bisanzio: 100, sauvage: 60, pullup: 40, capra3: 0, custom: 100 };
  const names = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.leatherNames) ? window.WIZARD_CONFIG.leatherNames : { waxy: 'Badalassi Waxy Cowhide', buffalo: 'Wild Cape Buffalo', minerva: 'Badalassi Minerva Cowhide', lochness: 'Badalassi Loch Ness Cowhide', capra: 'Sokoto Goatskin', levant: 'Black Patina Sauvage Goatskin', bisanzio: 'Conceria Puccini Bisanzio Rustic Metallic', sauvage: 'Alran Patina Sauvage Chevre', pullup: 'Siegel Vegetable Goat Pull Up', capra3: 'Badalassi Pueblo Cowhide', custom: 'Custom Leather' };
  orderState.leather = chosenLeatherKey;
  orderState.leatherName = names[chosenLeatherKey] || leatherVal || 'Badalassi Minerva Cowhide';
  orderState.leatherPrice = prices[chosenLeatherKey] !== undefined ? prices[chosenLeatherKey] : 0;

  // Select color dot
  if (chosenLeatherKey === 'custom') {
    const custInput = document.getElementById('custom-leather-text');
    if (custInput) {
      custInput.value = colorVal || leatherVal;
      updateCustomLeather(custInput.value);
    }
    orderState.customLeatherText = colorVal || leatherVal;
    orderState.color = colorVal || leatherVal;
  } else if (colorVal) {
    const colorDots = document.querySelectorAll(`#dots-${chosenLeatherKey} .ldot, .ldot`);
    let matchedDot = null;
    const cleanTargetColor = colorVal.replace(/\s*\([^)]*\)/g, '').trim().toLowerCase();
    
    for (let dot of colorDots) {
      const dotTitle = (dot.getAttribute('title') || '').trim();
      const cleanDotTitle = dotTitle.replace(/\s*\([^)]*\)/g, '').trim().toLowerCase();
      if (cleanDotTitle === cleanTargetColor || dotTitle.toLowerCase() === colorVal.toLowerCase().trim()) {
        matchedDot = dot;
        break;
      }
    }
    if (!matchedDot) {
      for (let dot of colorDots) {
        const dotTitle = (dot.getAttribute('title') || '').trim();
        const cleanDotTitle = dotTitle.replace(/\s*\([^)]*\)/g, '').trim().toLowerCase();
        if (cleanDotTitle.includes(cleanTargetColor) || cleanTargetColor.includes(cleanDotTitle)) {
          matchedDot = dot;
          break;
        }
      }
    }
    document.querySelectorAll('.ldot').forEach(d => d.classList.remove('sel'));
    if (matchedDot) {
      matchedDot.classList.add('sel');
      const finalTitle = (matchedDot.getAttribute('title') || '').replace(/\s*\([^)]*\)/g, '').trim();
      orderState.color = finalTitle;
      const label = document.getElementById(`sel-color-${chosenLeatherKey}`);
      if (label) label.textContent = finalTitle;
    } else {
      orderState.color = colorVal;
      const label = document.getElementById(`sel-color-${chosenLeatherKey}`);
      if (label) label.textContent = colorVal;
    }
  }

  // Select Liner
  if (linerVal) {
    const cleanLiner = linerVal.replace(/lambskin/i, '').replace(/\s*\([^)]*\)/g, '').trim();
    const linerDots = document.querySelectorAll('.liner-dots .lnr-dot, .lnr-dot');
    let matchedLinerDot = null;
    
    for (let dot of linerDots) {
      const dotTitle = (dot.getAttribute('title') || '').trim();
      const cleanDotTitle = dotTitle.replace(/\s*\([^)]*\)/g, '').replace(/lambskin/i, '').trim().toLowerCase();
      if (cleanDotTitle === cleanLiner.toLowerCase() || dotTitle.toLowerCase() === cleanLiner.toLowerCase()) {
        matchedLinerDot = dot;
        break;
      }
    }
    if (!matchedLinerDot) {
      for (let dot of linerDots) {
        const dotTitle = (dot.getAttribute('title') || '').trim();
        const cleanDotTitle = dotTitle.replace(/\s*\([^)]*\)/g, '').replace(/lambskin/i, '').trim().toLowerCase();
        if (cleanDotTitle.includes(cleanLiner.toLowerCase()) || cleanLiner.toLowerCase().includes(cleanDotTitle)) {
          matchedLinerDot = dot;
          break;
        }
      }
    }
    document.querySelectorAll('.lnr-dot').forEach(d => d.classList.remove('sel'));
    if (matchedLinerDot) {
      matchedLinerDot.classList.add('sel');
      const finalLinerTitle = (matchedLinerDot.getAttribute('title') || '').replace(/\s*\([^)]*\)/g, '').trim();
      orderState.liner = finalLinerTitle;
      const label = document.getElementById('liner-name');
      if (label) label.textContent = finalLinerTitle + ' lambskin';
    } else {
      orderState.liner = cleanLiner;
      const label = document.getElementById('liner-name');
      if (label) label.textContent = cleanLiner + ' lambskin';
    }
  }

  // Pre-populate Step 2: Cover Stiffness, Yapp, Tooling
  const coverVal = getProp('Cover', 'Cover Stiffness', 'Stiffness');
  document.querySelectorAll('#panel-2 .opt-card[data-opt="floppy"], #panel-2 .opt-card[data-opt="firm"]').forEach(c => c.classList.remove('selected'));
  if (coverVal.toLowerCase().includes('firm') || coverVal.toLowerCase().includes('stiff')) {
    const firmCard = document.querySelector('#panel-2 .opt-card[data-opt="firm"]');
    if (firmCard) firmCard.classList.add('selected');
    orderState.coverStiffness = 'Firm';
    orderState.coverStiffnessPrice = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.coverStiffnessPrices && window.WIZARD_CONFIG.coverStiffnessPrices.firm) ? window.WIZARD_CONFIG.coverStiffnessPrices.firm : 25;
  } else {
    const floppyCard = document.querySelector('#panel-2 .opt-card[data-opt="floppy"]');
    if (floppyCard) floppyCard.classList.add('selected');
    orderState.coverStiffness = 'Floppy';
    orderState.coverStiffnessPrice = 0;
  }

  const yappVal = getProp('Yapp', 'Yapp Length') || coverVal;
  document.querySelectorAll('#panel-2 .opt-card[data-opt="standard"], #panel-2 .opt-card[data-opt="half"], #panel-2 .opt-card[data-opt="full"]').forEach(c => c.classList.remove('selected'));
  if (yappVal.toLowerCase().includes('half') || yappVal.toLowerCase().includes('semi') || yappVal.includes('1/2')) {
    const halfYapp = document.querySelector('#panel-2 .opt-card[data-opt="half"]');
    if (halfYapp) halfYapp.classList.add('selected');
    orderState.yapp = 'Semi/Half Yapp (1/2")';
    orderState.yappPrice = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.yappPrices && window.WIZARD_CONFIG.yappPrices.half) ? window.WIZARD_CONFIG.yappPrices.half : 15;
  } else if (yappVal.toLowerCase().includes('full') || yappVal.includes('3/4')) {
    const fullYapp = document.querySelector('#panel-2 .opt-card[data-opt="full"]');
    if (fullYapp) fullYapp.classList.add('selected');
    orderState.yapp = 'Full Yapp (3/4")';
    orderState.yappPrice = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.yappPrices && window.WIZARD_CONFIG.yappPrices.full) ? window.WIZARD_CONFIG.yappPrices.full : 20;
  } else {
    const stdYapp = document.querySelector('#panel-2 .opt-card[data-opt="standard"]');
    if (stdYapp) stdYapp.classList.add('selected');
    orderState.yapp = 'Standard (3/8")';
    orderState.yappPrice = 0;
  }

  const extrasVal = getProp('Extras', 'Optional add-ons');
  const toolingVal = getProp('Tooling', 'Edge Tooling');
  document.querySelectorAll('#panel-2 .opt-card[data-opt="no-tooling"], #panel-2 .opt-card[data-opt="single-tooling"], #panel-2 .opt-card[data-opt="double-tooling"]').forEach(c => c.classList.remove('selected'));
  if (extrasVal.toLowerCase().includes('double perimeter') || extrasVal.toLowerCase().includes('double edge tooling') || extrasVal.toLowerCase().includes('tooling (double') || toolingVal.toLowerCase().includes('double')) {
    const dt = document.querySelector('.opt-card[data-opt="double-tooling"]');
    if (dt) dt.classList.add('selected');
    orderState.tooling = 'double-tooling';
    orderState.toolingPrice = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.toolingPrices && window.WIZARD_CONFIG.toolingPrices['double-tooling']) ? window.WIZARD_CONFIG.toolingPrices['double-tooling'] : 25;
  } else if (extrasVal.toLowerCase().includes('single perimeter') || extrasVal.toLowerCase().includes('single edge tooling') || extrasVal.toLowerCase().includes('tooling (single') || toolingVal.toLowerCase().includes('single')) {
    const st = document.querySelector('.opt-card[data-opt="single-tooling"]');
    if (st) st.classList.add('selected');
    orderState.tooling = 'single-tooling';
    orderState.toolingPrice = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.toolingPrices && window.WIZARD_CONFIG.toolingPrices['single-tooling']) ? window.WIZARD_CONFIG.toolingPrices['single-tooling'] : 15;
  } else {
    const nt = document.querySelector('.opt-card[data-opt="no-tooling"]');
    if (nt) nt.classList.add('selected');
    orderState.tooling = 'no-tooling';
    orderState.toolingPrice = 0;
  }

  // Pre-populate Step 3: Ribbons
  const ribbonCount = parseInt(getProp('Ribbons', 'Ribbon Count'), 10) || 0;
  orderState.ribbons = ribbonCount;
  const ribbonPrices = (window.WIZARD_CONFIG && window.WIZARD_CONFIG.ribbonPrices) ? window.WIZARD_CONFIG.ribbonPrices : [0, 0, 5, 10, 15, 20, 25];
  orderState.ribbonsPrice = ribbonPrices[ribbonCount] !== undefined ? ribbonPrices[ribbonCount] : 0;
  buildRibbonBtns();
  document.querySelectorAll('#ribbon-btns .rcount-btn').forEach(b => {
    if (parseInt(b.innerText, 10) === ribbonCount) {
      b.classList.add('selected');
    } else {
      b.classList.remove('selected');
    }
  });

  const ribbonColorStr = getProp('Ribbon Color', 'Ribbons Color');
  orderState.ribbonChoices = [];
  if (ribbonColorStr && ribbonCount > 0) {
    const ribbonParts = ribbonColorStr.includes('|') ? ribbonColorStr.split('|') : [ribbonColorStr];
    ribbonParts.forEach((part, idx) => {
      if (idx < ribbonCount) {
        let rName = part.replace(/^Ribbon \d+:\s*/i, '').trim();
        orderState.ribbonChoices[idx] = rName;
      }
    });
  }
  renderRibbonInputs();
  if (orderState.ribbonChoices && orderState.ribbonChoices.length) {
    orderState.ribbonChoices.forEach((rName, idx) => {
      const rInput = document.getElementById('ribbon-input-' + idx);
      if (rInput) rInput.value = rName;
    });
  }

  // Pre-populate Step 4: Spine Hubs, Stamping Color, Fonts, Logo & Sections
  const hubVal = getProp('Hub Style', 'Hubs');
  if (hubVal) {
    const hubCards = document.querySelectorAll('#panel-4 .hub-card');
    hubCards.forEach(c => {
      const hTitle = c.querySelector('.hub-name')?.innerText || '';
      if (hTitle.toLowerCase().trim() === hubVal.toLowerCase().trim() || hubVal.toLowerCase().includes(hTitle.toLowerCase().trim())) {
        hubCards.forEach(card => card.classList.remove('sel'));
        c.classList.add('sel');
        const costMatch = c.getAttribute('onclick')?.match(/selectHub\(this,\s*(\d+)\)/);
        const cost = costMatch ? parseInt(costMatch[1], 10) : (parseInt(c.dataset.price, 10) || 0);
        orderState.hubStyle = hTitle;
        orderState.hubPrice = cost;
      }
    });
  }

  const spineStampCol = getProp('Spine Stamping Color', 'Stamping Color', 'Spine Color') || 'Gold';
  const colorCards = document.querySelectorAll('#panel-4 .stamp-color');
  let matchedSpineColor = false;
  colorCards.forEach(c => {
    const nameEl = c.querySelector('.sc-name');
    if (nameEl && (nameEl.innerText.trim().toLowerCase() === spineStampCol.toLowerCase() || c.getAttribute('onclick')?.toLowerCase().includes(spineStampCol.toLowerCase()))) {
      colorCards.forEach(card => card.classList.remove('sel'));
      c.classList.add('sel');
      orderState.spineStampColor = nameEl.innerText.trim();
      orderState.spineStampColorPrice = 0;
      matchedSpineColor = true;
    }
  });
  if (!matchedSpineColor && colorCards.length > 0) {
    colorCards.forEach(card => card.classList.remove('sel'));
    colorCards[0].classList.add('sel');
    const nameEl = colorCards[0].querySelector('.sc-name');
    orderState.spineStampColor = nameEl ? nameEl.innerText.trim() : 'Gold';
    orderState.spineStampColorPrice = 0;
  }

  const stampFont = getProp('Stamping Font', 'Font') || 'Goudy Light';
  const fontCards = document.querySelectorAll('#panel-4 .font-card');
  let matchedFont = false;
  fontCards.forEach(c => {
    const fName = c.querySelector('.font-name')?.innerText || '';
    if (fName.toLowerCase().trim() === stampFont.toLowerCase().trim() || stampFont.toLowerCase().includes(fName.toLowerCase().trim())) {
      fontCards.forEach(card => card.classList.remove('sel'));
      c.classList.add('sel');
      orderState.stampFont = fName;
      matchedFont = true;
    }
  });
  if (!matchedFont && fontCards.length > 0) {
    fontCards.forEach(card => card.classList.remove('sel'));
    fontCards[0].classList.add('sel');
    orderState.stampFont = fontCards[0].querySelector('.font-name')?.innerText || 'Goudy Light';
  }

  const spineLogoVal = getProp('Spine Logo Type', 'Spine Logo', 'Logo') || 'both';
  const mandCards = document.querySelectorAll('.mand-card');
  mandCards.forEach(c => {
    const isMatch = (c.id === 'mand-both' && (spineLogoVal.toLowerCase().includes('both') || spineLogoVal.toLowerCase().includes('logo + text'))) ||
                    (c.id === 'mand-logo' && (spineLogoVal.toLowerCase().includes('logo only') || spineLogoVal.toLowerCase() === 'logo')) ||
                    (c.id === 'mand-text' && (spineLogoVal.toLowerCase().includes('text only') || spineLogoVal.toLowerCase() === 'text')) ||
                    (c.id === 'mand-custom' && (spineLogoVal.toLowerCase().includes('cursive') || spineLogoVal.toLowerCase().includes('custom')));
    if (isMatch) {
      mandCards.forEach(card => card.classList.remove('sel'));
      c.classList.add('sel');
      const type = c.id === 'mand-both' ? 'both' : (c.id === 'mand-logo' ? 'logo' : (c.id === 'mand-text' ? 'text' : 'custom'));
      orderState.spineLogo = type;
    }
  });

  for (let i = 1; i <= 5; i++) {
    if (i === 3) continue;
    const spineSecVal = getProp(`Spine Section ${i}`, `Spine ${i}`);
    const input = document.getElementById(`spine${i}`);
    if (input && spineSecVal) {
      input.value = spineSecVal;
      updateSec(i, spineSecVal);
    }
  }

  const sec3Val = getProp('Spine Section 3', 'Spine 3');
  if (sec3Val) {
    if (sec3Val.toLowerCase().includes('chi rho')) {
      pickSec3('chirho');
    } else if (sec3Val.toLowerCase().includes('latin cross')) {
      pickSec3('latincross');
    } else if (sec3Val.toLowerCase().includes('sword')) {
      pickSec3('sword');
    } else if (sec3Val.toLowerCase().includes('ichthys') || (sec3Val.toLowerCase().includes('fish') && !sec3Val.toLowerCase().includes('bread'))) {
      pickSec3('ichthys');
    } else if (sec3Val.toLowerCase().includes('bread') || sec3Val.toLowerCase().includes('fish + bread')) {
      pickSec3('fishbread');
    } else if (sec3Val.toLowerCase().includes('ark')) {
      pickSec3('ark');
    } else if (sec3Val.toLowerCase().includes('ega')) {
      pickSec3('ega');
    } else {
      pickSec3('text');
      const input3 = document.getElementById('spine3');
      if (input3) {
        input3.value = sec3Val;
        updateSec(3, sec3Val);
      }
    }
  } else {
    pickSec3('blank');
  }

  // Pre-populate Step 5: Stamping & Inscriptions
  const coverStampType = getProp('Cover Stamp Type', 'Cover Stamp') || 'none';
  const stampCards = document.querySelectorAll('.stamp-card, .stamp-custom-card');
  stampCards.forEach(c => c.classList.remove('selected'));
  if (coverStampType && coverStampType !== 'none') {
    stampCards.forEach(c => {
      const sType = c.dataset.coverStamp || '';
      if (sType.toLowerCase() === coverStampType.toLowerCase() ||
          (coverStampType.toLowerCase().includes('cross') && sType === 'cross') ||
          (coverStampType.toLowerCase().includes('chi rho') && sType === 'chirho') ||
          (coverStampType.toLowerCase().includes('latin cross') && sType === 'latin-cross') ||
          (coverStampType.toLowerCase().includes('sword') && sType === 'sword') ||
          (coverStampType.toLowerCase().includes('ichthys') && sType === 'ichthys') ||
          (coverStampType.toLowerCase().includes('bread') && sType === 'fishbread') ||
          (coverStampType.toLowerCase().includes('ark') && sType === 'ark') ||
          (coverStampType.toLowerCase().includes('believe') && sType === 'believe') ||
          (coverStampType.toLowerCase().includes('bryce') && sType === 'bryce-jesus') ||
          (coverStampType.toLowerCase().includes('byzantine') && sType === 'byzantine-cross') ||
          (coverStampType.toLowerCase().includes('celtic') && sType === 'celtic-cross') ||
          (coverStampType.toLowerCase().includes('eagle') && sType === 'eagle') ||
          (coverStampType.toLowerCase().includes('ega') && sType === 'ega') ||
          (coverStampType.toLowerCase().includes('sheep') && sType === 'lost-sheep') ||
          (coverStampType.toLowerCase().includes('lamb') && sType === 'lamb') ||
          (coverStampType.toLowerCase().includes('lion') && sType === 'lion-lamb') ||
          (coverStampType.toLowerCase().includes('nail') && sType === 'nail-cross') ||
          (coverStampType.toLowerCase().includes('orthodox') && sType === 'orthodox-cross') ||
          (coverStampType.toLowerCase().includes('realistic') && sType === 'realistic-cross') ||
          (coverStampType.toLowerCase().includes('text') && sType === 'text') ||
          (coverStampType.toLowerCase().includes('custom') && sType === 'custom')) {
        c.classList.add('selected');
        orderState.coverStampType = sType;
        orderState.coverStampCost = parseInt(c.dataset.price || c.dataset.cost) || 0;
      }
    });
    const coverText = getProp('Cover Stamp Text');
    const cstInput = document.getElementById('cover-stamp-text-input');
    const cstWrap = document.getElementById('cover-stamp-text-wrap');
    if (coverStampType === 'text' || coverStampType === 'custom') {
      if (cstWrap) cstWrap.style.display = 'block';
    }
    if (cstInput && coverText) {
      cstInput.value = coverText;
      orderState.coverStampText = coverText;
    }
  } else {
    const noneStampCard = document.querySelector('.stamp-card[data-cover-stamp="none"]');
    if (noneStampCard) noneStampCard.classList.add('selected');
    orderState.coverStampType = 'none';
    orderState.coverStampCost = 0;
  }

  const coverPlace = getProp('Cover Stamp Placement', 'Placement');
  if (coverPlace) {
    const placeCards = document.querySelectorAll('.place-card');
    placeCards.forEach(c => {
      const pType = c.dataset.placement || '';
      if (pType && (pType.toLowerCase() === coverPlace.toLowerCase() ||
          coverPlace.toLowerCase().replace(/[^a-z0-9]/g, '').includes(pType.toLowerCase().replace(/[^a-z0-9]/g, '')))) {
        placeCards.forEach(card => card.classList.remove('selected'));
        c.classList.add('selected');
        orderState.coverStampPlacement = pType;
      }
    });
  }

  const coverColor = getProp('Cover Stamp Color', 'Cover Color');
  if (coverColor) {
    const stampColorCards = document.querySelectorAll('#cover-stamp-color-row .stamp-color-card');
    stampColorCards.forEach(c => {
      if (c.dataset.color && c.dataset.color.toLowerCase() === coverColor.toLowerCase()) {
        stampColorCards.forEach(card => card.classList.remove('selected'));
        c.classList.add('selected');
        orderState.coverStampColor = c.dataset.color;
        orderState.coverStampColorCost = parseInt(c.dataset.price || c.dataset.cost) || 0;
        const colLabel = document.getElementById('selected-cover-stamp-color');
        if (colLabel) colLabel.textContent = c.dataset.color;
      }
    });
  }

  // Inscriptions
  let hasInsc = false;
  for (let k in props) {
    if (k.startsWith('Inscription Location') || k.startsWith('Inscription')) {
      const locMatch = k.toLowerCase();
      const val = props[k];
      if (!val || val === 'None' || val === 'Not specified') continue;
      if (locMatch.includes('font')) continue;
      
      let targetLoc = null;
      if (locMatch.includes('front')) targetLoc = 'front';
      else if (locMatch.includes('liner')) targetLoc = 'liner';
      else if (locMatch.includes('back')) targetLoc = 'back';
      
      if (targetLoc) {
        hasInsc = true;
        orderState.inscriptions[targetLoc] = true;
        const card = document.querySelector(`.insc-card[data-inscription="${targetLoc}"]`);
        if (card) card.classList.add('selected');
        
        if (!Array.isArray(orderState.inscriptionTexts[targetLoc])) {
          orderState.inscriptionTexts[targetLoc] = [];
        }
        if (val.includes(',') && !k.includes('Name')) {
          const parts = val.split(',').map(s => s.trim()).filter(Boolean);
          for (let p of parts) {
            if (!orderState.inscriptionTexts[targetLoc].includes(p)) {
              orderState.inscriptionTexts[targetLoc].push(p);
            }
          }
        } else {
          if (!orderState.inscriptionTexts[targetLoc].includes(val.trim())) {
            orderState.inscriptionTexts[targetLoc].push(val.trim());
          }
        }
      }
    }
  }
  if (hasInsc) {
    const inscWrap = document.getElementById('inscription-input-wrap');
    if (inscWrap) inscWrap.style.display = 'block';
    const noInscCard = document.querySelector('.insc-card[data-inscription="none"]');
    if (noInscCard) noInscCard.classList.remove('selected');
    
    for (let l of ['front', 'liner', 'back']) {
      if (orderState.inscriptions[l]) {
        const wrap = document.getElementById(`insc-${l}-input-wrap`);
        if (wrap) wrap.style.display = 'block';
        if (!orderState.inscriptionTexts[l] || orderState.inscriptionTexts[l].length === 0) {
          orderState.inscriptionTexts[l] = [''];
        }
        renderInscriptionInputs(l);
      }
    }
    recalcInscriptionCost();
  }

  const inscFont = getProp('Inscription Font');
  if (inscFont) {
    const inscFontCards = document.querySelectorAll('#inscription-input-wrap .font-card');
    inscFontCards.forEach(c => {
      const fName = c.querySelector('.font-name')?.innerText || '';
      const dataF = c.dataset.font || '';
      if (fName.toLowerCase() === inscFont.toLowerCase() || dataF.toLowerCase() === inscFont.toLowerCase()) {
        inscFontCards.forEach(card => card.classList.remove('selected'));
        c.classList.add('selected');
        orderState.inscriptionFont = dataF || fName;
      }
    });
  }

  // Pre-populate Step 6: Extras
  if (extrasVal) {
    // Hand stitching
    if (extrasVal.includes('stitching') || extrasVal.includes('Hand stitching')) {
      const stitchEl = document.getElementById('row-stitch');
      if (stitchEl && !stitchEl.classList.contains('active')) toggleExtraOpt('stitch', togglePrices.stitch || 100);
      let stitchMatch = extrasVal.match(/Hand stitching:\s*([^|()]+)/i) || extrasVal.match(/Hand stitching\s*\(([^)]+)\)/i);
      if (stitchMatch && stitchMatch[1]) {
        const stitchCol = stitchMatch[1].trim();
        orderState.stitchColor = stitchCol;
        const stitchInput = document.getElementById('stitch-color');
        if (stitchInput) stitchInput.value = stitchCol;
      }
    }

    // Single gilt lines
    if (extrasVal.includes('Single gilt')) {
      const g1 = document.getElementById('row-single');
      if (g1 && !g1.classList.contains('active')) toggleExtraOpt('single', togglePrices.gilt1 || 20);
      let g1Match = extrasVal.match(/Single gilt lines:\s*([^|()]+)/i) || extrasVal.match(/Single gilt\s*\(([^)]+)\)/i);
      let g1Color = g1Match ? g1Match[1].trim() : (extrasVal.includes('Silver') ? 'Silver' : (extrasVal.includes('Red') ? 'Red' : 'Gold'));
      const scCards = document.querySelectorAll('#colors-single .sc-extra');
      scCards.forEach(card => {
        const cName = card.querySelector('.sc-name')?.innerText || '';
        if (cName.toLowerCase() === g1Color.toLowerCase()) {
          selExtraColor('single', card, cName, cName.toLowerCase() === 'gold' ? 0 : 5);
        }
      });
    }

    // Double gilt lines
    if (extrasVal.includes('Double gilt')) {
      const g2 = document.getElementById('row-double');
      if (g2 && !g2.classList.contains('active')) toggleExtraOpt('double', togglePrices.gilt2 || 40);
      let g2Match = extrasVal.match(/Double gilt lines:\s*([^|()]+)/i) || extrasVal.match(/Double gilt\s*\(([^)]+)\)/i);
      let g2Color = g2Match ? g2Match[1].trim() : (extrasVal.includes('Silver') ? 'Silver' : (extrasVal.includes('Red') ? 'Red' : 'Gold'));
      const scCards = document.querySelectorAll('#colors-double .sc-extra');
      scCards.forEach(card => {
        const cName = card.querySelector('.sc-name')?.innerText || '';
        if (cName.toLowerCase() === g2Color.toLowerCase()) {
          selExtraColor('double', card, cName, cName.toLowerCase() === 'gold' ? 0 : 5);
        }
      });
    }

    // Page edge dyeing
    if (extrasVal.includes('dyeing') || extrasVal.includes('Page edge dyeing') || extrasVal.includes('Edge dye')) {
      const dye = document.getElementById('row-dye');
      if (dye && !dye.classList.contains('active')) toggleExtraOpt('dye', togglePrices.dye || 40);
      let dyeMatch = extrasVal.match(/Page edge dyeing:\s*([^|()]+)/i) || extrasVal.match(/Edge dye\s*\(([^)]+)\)/i);
      if (dyeMatch && dyeMatch[1]) {
        const dyeCol = dyeMatch[1].trim();
        orderState.dyeColor = dyeCol;
        const dyeInput = document.getElementById('dye-color');
        if (dyeInput) dyeInput.value = dyeCol;
      }
      if (extrasVal.includes('Sand off') || extrasVal.includes('sand')) {
        const sandoffEl = document.getElementById('sandoff-cb') || document.getElementById('sandoff-row');
        if (sandoffEl) toggleSandoff(sandoffEl);
      }
      const dyeAckEl = document.getElementById('dye-ack-row');
      if (dyeAckEl) toggleDyeAck(dyeAckEl, 'dye');
    }

    // Speckles
    if (extrasVal.includes('Speckled') || extrasVal.includes('speckle') || extrasVal.includes('Speckles')) {
      const sp = document.getElementById('row-speckle');
      if (sp && !sp.classList.contains('active')) toggleExtraOpt('speckle', togglePrices.speckle || 100);
      const spAckEl = document.getElementById('speckle-ack-row');
      if (spAckEl) toggleDyeAck(spAckEl, 'speckle');
      let spMatch = extrasVal.match(/Speckled art edges:\s*([^|]+)/i) || extrasVal.match(/Speckles:\s*([^|]+)/i) || extrasVal.match(/Speckled edges\s*\(([^)]+)\)/i);
      if (spMatch && spMatch[1]) {
        const spCols = spMatch[1].split(',').map(s => s.trim());
        spCols.forEach((col, idx) => {
          const slot = idx + 1;
          if (slot <= 3) {
            const dots = document.querySelectorAll(`#sp${slot} .sp-dot`);
            dots.forEach(dot => {
              const dotTitle = dot.getAttribute('title') || '';
              if (dotTitle.toLowerCase() === col.toLowerCase()) {
                pickSp(slot, dot, dotTitle);
              }
            });
          }
        });
      }
    }
  }

  // Pre-populate Step 7: Notes
  const notesVal = getProp('Notes', 'Item Note', 'Special Instructions');
  const notesEl = document.getElementById('notes');
  if (notesEl && notesVal) {
    notesEl.value = notesVal;
  }

  // Sync acknowledgments in Step 7
  if (typeof ackChecked !== 'undefined') {
    ackChecked[1] = true;
    ackChecked[2] = true;
    const item1 = document.getElementById('ack1');
    if (item1) item1.classList.add('checked');
    const item2 = document.getElementById('ack2');
    if (item2) item2.classList.add('checked');
    if (typeof updateSubmitBtn === 'function') updateSubmitBtn();
  }

  // Change submit button text in Step 7
  const submitBtn = document.getElementById('submit-btn-new');
  if (submitBtn) {
    submitBtn.textContent = 'UPDATE CUSTOMIZATION IN CART →';
    submitBtn.disabled = false;
    submitBtn.classList.add('active');
    submitBtn.style.opacity = '1';
  }

  } catch (err) {
    console.error('Error restoring cart wizard selections:', err);
  } finally {
    // Release restoration lock BEFORE activating target step
    window._isRestoringCartWizard = false;

    // Enforce target step navigation
    currentStep = startStep;
    document.querySelectorAll('.step-panel').forEach(p => p.classList.remove('active'));
    const targetPanel = document.getElementById('panel-' + currentStep);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
    buildProgress();
    window.wizardReturnToReview = false;
    updateReturnToReviewBanner();

    if (currentStep === 1) {
      // Ensure active leather tab is selected and rendered
      const activeTab = document.querySelector('.ltab.active') || document.getElementById('tab-' + (orderState.leather || 'waxy'));
      if (activeTab) activeTab.classList.add('active');
      const activePanel = document.querySelector('.leather-panel[style*="display: block"]') || document.getElementById('panel-' + (orderState.leather || 'waxy'));
      if (activePanel) activePanel.style.display = 'block';
    }
    if (currentStep === 3) {
      if (typeof buildRibbonBtns === 'function') buildRibbonBtns();
      if (typeof renderRibbonInputs === 'function') renderRibbonInputs();
    }
    if (currentStep === 4) {
      if (typeof setupSpineStep === 'function') setupSpineStep();
    }
    if (currentStep === 7) {
      if (typeof updateSummary === 'function') updateSummary();
    }

    updateWizardEditModeUI();

    // Smooth scroll to specific section if scrollTarget is provided
    if (scrollTarget) {
      setTimeout(() => {
        wizardAutoScroll(scrollTarget);
      }, 120);
    } else {
      const modalContent = document.querySelector('.wizard-modal-content');
      if (modalContent) modalContent.scrollTop = 0;
    }
  }
}

function openWizardForCartProperty(target, propKey, explicitStep) {
  let step = (typeof explicitStep === 'number' && !isNaN(explicitStep) && explicitStep >= 0 && explicitStep <= 7) ? explicitStep : null;

  // Normalize property key string: strip colons, html quotes, leading/trailing whitespace
  let cleanKey = String(propKey || '')
    .replace(/&quot;|&#34;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/[:\s]+$/, '')
    .replace(/^[:\s]+/, '')
    .trim()
    .toLowerCase();

  // Non-editable price or system rows
  if (cleanKey.includes('total expected') || cleanKey.includes('due later') || cleanKey.includes('optionsetid') || cleanKey.includes('deposit')) {
    return;
  }

  let itemEl = target && target.nodeType ? (target.closest('.bb-cart-item') || target.closest('.m-cart-item')) : null;
  if (!itemEl || itemEl.getAttribute('data-is-signature') === 'true' || itemEl.getAttribute('data-is-wizard') !== 'true') {
    return;
  }

  let scrollTarget = null;

  if (step === null) {
    // Step 0: Bible Source & Condition / Translation
    if (
      cleanKey.includes('source') ||
      cleanKey.includes('condition') ||
      cleanKey.includes('translation') ||
      cleanKey.includes('text block') ||
      cleanKey.includes('own bible') ||
      cleanKey.includes('bible type')
    ) {
      step = 0;
    }
    // Step 1: Leather & Color & Liner
    else if (
      cleanKey === 'leather' ||
      cleanKey.includes('leather type') ||
      cleanKey.includes('badalassi') ||
      cleanKey.includes('pueblo') ||
      cleanKey.includes('waxy') ||
      cleanKey.includes('minerva') ||
      cleanKey.includes('loch ness') ||
      cleanKey.includes('lochness') ||
      cleanKey.includes('sokoto') ||
      cleanKey.includes('levant') ||
      cleanKey.includes('bisanzio') ||
      cleanKey.includes('puccini') ||
      cleanKey.includes('sauvage') ||
      cleanKey.includes('pull up') ||
      cleanKey.includes('pullup') ||
      cleanKey.includes('buffalo') ||
      cleanKey.includes('custom leather')
    ) {
      step = 1;
    } else if (
      cleanKey === 'color' ||
      cleanKey.includes('leather color') ||
      cleanKey.includes('cover color')
    ) {
      step = 1;
    } else if (
      cleanKey === 'liner' ||
      cleanKey.includes('liner color') ||
      cleanKey.includes('lambskin') ||
      cleanKey.includes('inner liner') ||
      cleanKey.includes('leather liner')
    ) {
      step = 1;
    }
    // Step 2: Cover Stiffness, Yapp & Tooling
    else if (
      cleanKey === 'cover' ||
      cleanKey.includes('stiff') ||
      cleanKey.includes('floppy') ||
      cleanKey.includes('structure') ||
      cleanKey.includes('cover stiffness')
    ) {
      step = 2;
    } else if (cleanKey.includes('yapp')) {
      step = 2;
    } else if (cleanKey.includes('tooling') || cleanKey.includes('perimeter')) {
      step = 2;
    }
    // Step 3: Ribbons
    else if (cleanKey.includes('ribbon')) {
      step = 3;
    }
    // Step 4: Spine Hubs, Stamping Color, Fonts, Logo & Sections
    else if (cleanKey.includes('hub')) {
      step = 4;
    } else if (
      cleanKey.includes('spine stamping color') ||
      cleanKey.includes('spine color') ||
      (cleanKey.includes('stamping color') && !cleanKey.includes('cover'))
    ) {
      step = 4;
    } else if (
      (cleanKey.includes('font') || cleanKey.includes('stamping font')) &&
      !cleanKey.includes('inscription')
    ) {
      step = 4;
    } else if (cleanKey.includes('logo') || cleanKey.includes('spine logo')) {
      step = 4;
    } else if (cleanKey.includes('spine section') || cleanKey.includes('spine 1') || cleanKey.includes('spine 2') || cleanKey.includes('spine 3') || cleanKey.includes('spine 4') || cleanKey.includes('spine 5') || cleanKey.includes('spine sections')) {
      step = 4;
    }
    // Step 5: Cover Stamping & Inscriptions
    else if (cleanKey.includes('cover stamp') || cleanKey.includes('stamp type') || cleanKey.includes('cover stamping')) {
      step = 5;
    } else if (cleanKey.includes('placement')) {
      step = 5;
    } else if (cleanKey.includes('inscription')) {
      step = 5;
    }
    // Step 6: Extras
    else if (
      cleanKey.includes('extra') ||
      cleanKey.includes('gilt') ||
      cleanKey.includes('dye') ||
      cleanKey.includes('speckle') ||
      cleanKey.includes('stitch') ||
      cleanKey.includes('optional add-on')
    ) {
      step = 6;
    }
    // Step 7: Notes & Review
    else if (
      cleanKey.includes('note') ||
      cleanKey.includes('instruction') ||
      cleanKey.includes('request')
    ) {
      step = 7;
    } else {
      step = 0;
    }
  }

  // Scroll targets based on step and key
  if (step === 0) {
    scrollTarget = (cleanKey.includes('own') || cleanKey.includes('condition') || cleanKey.includes('type')) ? '#own-bible-section' : '#translation-section';
  } else if (step === 1) {
    if (cleanKey.includes('liner') || cleanKey.includes('lambskin')) {
      scrollTarget = '#step1-liner-section, #step1-liner-heading';
    } else if (cleanKey.includes('color')) {
      scrollTarget = '.leather-panel:not([style*="display: none"]) .ldots, #panel-1';
    } else {
      scrollTarget = '#leather-tabs, #panel-1';
    }
  } else if (step === 2) {
    if (cleanKey.includes('yapp')) scrollTarget = '#step2-yapp-heading';
    else if (cleanKey.includes('tooling')) scrollTarget = '#step2-tooling-heading';
    else scrollTarget = '#step2-stiffness-heading, #panel-2';
  } else if (step === 3) {
    scrollTarget = cleanKey.includes('color') ? '#selected-ribbons-container, #ribbon-color-accordion' : '#ribbon-btns';
  } else if (step === 4) {
    if (cleanKey.includes('hub')) scrollTarget = '#step4-hub-heading';
    else if (cleanKey.includes('font')) scrollTarget = '#step4-font-heading';
    else if (cleanKey.includes('logo')) scrollTarget = '#step4-logo-heading';
    else if (cleanKey.includes('section')) scrollTarget = '#spine-sections-grid';
    else scrollTarget = '#step4-stamping-color-heading';
  } else if (step === 5) {
    if (cleanKey.includes('inscription')) scrollTarget = '#inscription-input-wrap, #panel-5';
    else if (cleanKey.includes('color')) scrollTarget = '#step5-stamp-color-heading';
    else if (cleanKey.includes('placement')) scrollTarget = '#step5-placement-heading';
    else scrollTarget = '#step5-stamp-heading';
  } else if (step === 6) {
    scrollTarget = '#panel-6';
  } else if (step === 7) {
    scrollTarget = '#notes';
  }

  openWizardForCartItem(target, step, scrollTarget);
}

window.openWizard = openWizard;
window.openWizardForCartItem = openWizardForCartItem;
window.openWizardForCartProperty = openWizardForCartProperty;
window.goToStep = goToStep;
window.saveCartItemFromWizard = saveCartItemFromWizard;
window.updateWizardEditModeUI = updateWizardEditModeUI;
window.buildCurrentOrderProperties = buildCurrentOrderProperties;
try {
  Object.defineProperty(window, 'currentStep', {
    get: function() { return currentStep; },
    set: function(val) { currentStep = val; },
    configurable: true
  });
} catch(e) {}

// Ensure only one #wizardModal exists in the DOM if multiple sections rendered it
function deduplicateWizardModals() {
  const modals = document.querySelectorAll('#wizardModal');
  if (modals.length > 1) {
    let bestModal = modals[0];
    for (let i = 0; i < modals.length; i++) {
      const m = modals[i];
      if (m.querySelector('[data-opt^="translation_"]') || m.querySelector('img[src*="Untitled_design"]') || m.querySelector('img[src*="fish_and_bread"]')) {
        bestModal = m;
        break;
      }
    }
    for (let i = 0; i < modals.length; i++) {
      if (modals[i] !== bestModal) {
        modals[i].remove();
      }
    }
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', deduplicateWizardModals);
} else {
  deduplicateWizardModals();
}

// Replay any early clicks on cart edit buttons before wizard.js loaded
if (window._pendingWizardCalls && window._pendingWizardCalls.length > 0) {
  const pending = window._pendingWizardCalls.slice();
  window._pendingWizardCalls = [];
  pending.forEach(call => {
    try {
      if (call.fn === 'openWizardForCartItem') {
        openWizardForCartItem.apply(null, call.args);
      } else if (call.fn === 'openWizardForCartProperty') {
        openWizardForCartProperty.apply(null, call.args);
      }
    } catch(err) {
      console.warn('Error executing pending wizard call:', err);
    }
  });
}


